import React, { useEffect, useMemo, useRef, useState } from 'react'
import Swal from 'sweetalert2'
import { supabase } from '../../supabaseClient'
import { getAuthItem } from '../../utils/auth'


if (typeof document !== 'undefined' && !document.getElementById('shimmer-keyframes')) {
    const style = document.createElement('style')
    style.id = 'shimmer-keyframes'
    style.innerHTML = `
        @keyframes shimmer {
            0% { background-position: -400px 0; }
            100% { background-position: 400px 0; }
        }
    `
    document.head.appendChild(style)
}

if (typeof document !== 'undefined' && !document.getElementById('scrollbar-hide-styles')) {
    const style = document.createElement('style')
    style.id = 'scrollbar-hide-styles'
    style.innerHTML = `
            .scrollbar-hide::-webkit-scrollbar { display: none; }
            .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
        `
    document.head.appendChild(style)
}

// ─── Design tokens ────────────────────────────────────────────────────
const C = {
    espresso: 'transparent',
    dark: '#F9FAFB',
    card: '#FFFFFF',
    border: '#E5E7EB',
    muted: '#9CA3AF',
    text: '#111827',
    textSoft: '#6B7280',
    amber: '#D97706',
    gold: '#B45309',
    teal: '#0D9488',
    coral: '#DC2626',
    blue: '#2563EB',
    green: '#16A34A',
    purple: '#7C3AED',
    indigo: '#4F46E5',
    nude: '#A0826D',
    midgrey: '#6B7280',
}

const SkeletonBlock = ({ className = '', style = {} }) => (
    <div
        className={`rounded ${className}`}
        style={{
            backgroundImage: 'linear-gradient(90deg, #e5e7eb 0px, #f3f4f6 40px, #e5e7eb 80px)',
            backgroundSize: '400px 100%',
            animation: 'shimmer 1.4s ease-in-out infinite',
            ...style,
        }}
    />
)

export default function StaffMenuManagement() {
    const [activeTab, setActiveTab] = useState('menu_overview')
    const [branches, setBranches] = useState([])
    const [selectedBranchIds, setSelectedBranchIds] = useState(new Set())
    const [currentStaffId, setCurrentStaffId] = useState(null)
    const [currentBranchId, setCurrentBranchId] = useState(null)
    const [branchOverviewSubTab, setBranchOverviewSubTab] = useState('menu_items')
    const [myPriceRequests, setMyPriceRequests] = useState([])
    const [loadingMyPriceRequests, setLoadingMyPriceRequests] = useState(false)
    const [myMenuChangeRequests, setMyMenuChangeRequests] = useState([])
    const [loadingMyMenuChangeRequests, setLoadingMyMenuChangeRequests] = useState(false)
    const [myReinstateRequests, setMyReinstateRequests] = useState([])
    const [menuChangeRequestsPage, setMenuChangeRequestsPage] = useState(1)
    const [variantChangeRequestsPage, setVariantChangeRequestsPage] = useState(1)
    const [modifierChangeRequestsPage, setModifierChangeRequestsPage] = useState(1)

    const [menuItemsPage, setMenuItemsPage] = useState(1)
    const [variantsPage, setVariantsPage] = useState(1)
    const [modifiersPage, setModifiersPage] = useState(1)
    const ITEMS_PAGE_SIZE = 10
    const MAX_PRICE_LENGTH = 4

    // Branch menu overview
    const [allBranchMenuItems, setAllBranchMenuItems] = useState([])
    const [branchMenuItems, setBranchMenuItems] = useState([])
    const [branchMenuLoading, setBranchMenuLoading] = useState(true)
    const [selectedBranchForMenu, setSelectedBranchForMenu] = useState('all')
    const [branchBreakdownCollapsed, setBranchBreakdownCollapsed] = useState(true)
    const [uniqueItemsCollapsed, setUniqueItemsCollapsed] = useState(true)
    const [menuItemSearch, setMenuItemSearch] = useState('')
    const [openMenuItemId, setOpenMenuItemId] = useState(null)

    const [filterClassification, setFilterClassification] = useState('All')
    const [availableClassificationsForCategory, setAvailableClassificationsForCategory] = useState([])

    const [menuItems, setMenuItems] = useState([])
    const [modifiers, setModifiers] = useState([])
    const [loading, setLoading] = useState(true)
    const [loadingModifiers, setLoadingModifiers] = useState(true)

    const [showAddItemModal, setShowAddItemModal] = useState(false)
    const [showEditItemModal, setShowEditItemModal] = useState(false)

    // Variants
    const [variants, setVariants] = useState([])
    const [loadingVariants, setLoadingVariants] = useState(true)
    const [showAddVariantModal, setShowAddVariantModal] = useState(false)
    const [showEditVariantModal, setShowEditVariantModal] = useState(false)
    const [showAssignVariantsModal, setShowAssignVariantsModal] = useState(false)

    const [assignVariantSearch, setAssignVariantSearch] = useState('')
    const [editingVariant, setEditingVariant] = useState(null)
    const [selectedItemForVariants, setSelectedItemForVariants] = useState(null)
    const [assignVariantCategoryFilter, setAssignVariantCategoryFilter] = useState('All')   // ← ADD

    const [assignedVariantIds, setAssignedVariantIds] = useState(new Set())
    const [loadingVariantAssignments, setLoadingVariantAssignments] = useState(false)
    const [savingVariantAssignments, setSavingVariantAssignments] = useState(false)

    const [variantSearchQuery, setVariantSearchQuery] = useState("")
    const [filterVariantCategory, setFilterVariantCategory] = useState("All")

    const [savingVariant, setSavingVariant] = useState(false)
    const [loadingItemVariants, setLoadingItemVariants] = useState(false)

    const [variantCategorySearch, setVariantCategorySearch] = useState("")
    const [openVariantCategoryDropdown, setOpenVariantCategoryDropdown] = useState(false)
    const variantCategoryDropdownRef = useRef(null)

    // Modifiers
    const [showAddModifierModal, setShowAddModifierModal] = useState(false)
    const [showEditModifierModal, setShowEditModifierModal] = useState(false)
    const [showAssignModifiersModal, setShowAssignModifiersModal] = useState(false)

    const [assignModifierSearch, setAssignModifierSearch] = useState('')
    const [editingItem, setEditingItem] = useState(null)
    const [editingModifier, setEditingModifier] = useState(null)
    const [selectedItemForModifiers, setSelectedItemForModifiers] = useState(null)
    const [assignModifierCategoryFilter, setAssignModifierCategoryFilter] = useState('All')

    const [assignedModifierIds, setAssignedModifierIds] = useState(new Set())
    const [loadingAssignments, setLoadingAssignments] = useState(false)
    const [savingAssignments, setSavingAssignments] = useState(false)
    const [searchQuery, setSearchQuery] = useState("")
    const [filterCategory, setFilterCategory] = useState("All")
    const [modifierSearchQuery, setModifierSearchQuery] = useState("")
    const [filterModifierCategory, setFilterModifierCategory] = useState("All")

    //Item Image
    const [itemImageFile, setItemImageFile] = useState(null)
    const [imageInputMode, setImageInputMode] = useState('upload')
    const [uploadingImage, setUploadingImage] = useState(false)

    //Initial Data
    const [initialItemFormData, setInitialItemFormData] = useState(null)
    const [initialVariantFormData, setInitialVariantFormData] = useState(null)
    const [initialModifierFormData, setInitialModifierFormData] = useState(null)
    const [initialVariantRuleFormData, setInitialVariantRuleFormData] = useState(null)

    const [initialSelectedBranchIds, setInitialSelectedBranchIds] = useState(new Set())
    const [initialAssignedVariantIds, setInitialAssignedVariantIds] = useState(new Set())
    const [initialAssignedModifierIds, setInitialAssignedModifierIds] = useState(new Set())

    //Variant Rules
    const [variantRuleTableSearch, setVariantRuleTableSearch] = useState('')
    const [showVariantRulesModal, setShowVariantRulesModal] = useState(false)
    const [selectedItemForVariantRules, setSelectedItemForVariantRules] = useState(null)

    const [itemVariants, setItemVariants] = useState([])
    const [ingredients, setIngredients] = useState([])
    const [variantRules, setVariantRules] = useState([])

    const [loadingVariantRules, setLoadingVariantRules] = useState(false)
    const [savingVariantRule, setSavingVariantRule] = useState(false)

    const [variantRuleVariantSearch, setVariantRuleVariantSearch] = useState('')
    const [variantRuleIngredientSearch, setVariantRuleIngredientSearch] = useState('')

    const [openVariantDropdown, setOpenVariantDropdown] = useState(false)
    const [openIngredientDropdown, setOpenIngredientDropdown] = useState(false)

    const variantDropdownRef = useRef(null)
    const ingredientDropdownRef = useRef(null)

    //View Archived
    const [showReinstateRequestModal, setShowReinstateRequestModal] = useState(false)
    const [reinstateRequestItem, setReinstateRequestItem] = useState(null)
    const [reinstateRequestType, setReinstateRequestType] = useState('') // 'variant' | 'modifier'
    const [reinstateRequestReason, setReinstateRequestReason] = useState('')
    const [submittingReinstateRequest, setSubmittingReinstateRequest] = useState(false)

    // Edit request modal
    const [showEditRequestModal, setShowEditRequestModal] = useState(false)
    const [editRequestReason, setEditRequestReason] = useState('')
    const [editRequestType, setEditRequestType] = useState('') // 'variant' | 'modifier'
    const [submittingEditRequest, setSubmittingEditRequest] = useState(false)

    // Assign variant request modal
    const [showAssignVariantRequestModal, setShowAssignVariantRequestModal] = useState(false)
    const [assignVariantRequestReason, setAssignVariantRequestReason] = useState('')
    const [submittingAssignVariantRequest, setSubmittingAssignVariantRequest] = useState(false)

    // Assign modifier request modal
    const [showAssignModifierRequestModal, setShowAssignModifierRequestModal] = useState(false)
    const [assignModifierRequestReason, setAssignModifierRequestReason] = useState('')
    const [submittingAssignModifierRequest, setSubmittingAssignModifierRequest] = useState(false)

    // Variant rule request modal
    const [showVariantRuleRequestModal, setShowVariantRuleRequestModal] = useState(false)
    const [variantRuleRequestReason, setVariantRuleRequestReason] = useState('')
    const [submittingVariantRuleRequest, setSubmittingVariantRuleRequest] = useState(false)
    const [pendingVariantRuleAction, setPendingVariantRuleAction] = useState(null) // 'add' | 'update' | 'delete'
    const [pendingVariantRuleId, setPendingVariantRuleId] = useState(null)

    const [showDeleteRequestModal, setShowDeleteRequestModal] = useState(false)
    const [deleteRequestItem, setDeleteRequestItem] = useState(null)
    const [deleteRequestType, setDeleteRequestType] = useState('')
    const [deleteRequestReason, setDeleteRequestReason] = useState('')
    const [submittingDeleteRequest, setSubmittingDeleteRequest] = useState(false)
    const [showAddItemRequestReasonModal, setShowAddItemRequestReasonModal] = useState(false)
    const [addItemRequestReason, setAddItemRequestReason] = useState('')
    const [submittingAddItemRequest, setSubmittingAddItemRequest] = useState(false)

    // Add Variant/Modifier request
    const [showAddVariantRequestModal, setShowAddVariantRequestModal] = useState(false)
    const [addVariantRequestReason, setAddVariantRequestReason] = useState('')
    const [submittingAddVariantRequest, setSubmittingAddVariantRequest] = useState(false)

    const [showAddModifierRequestModal, setShowAddModifierRequestModal] = useState(false)
    const [addModifierRequestReason, setAddModifierRequestReason] = useState('')
    const [submittingAddModifierRequest, setSubmittingAddModifierRequest] = useState(false)

    const [showArchivedViewerModal, setShowArchivedViewerModal] = useState(false)
    const [archivedMenuItems, setArchivedMenuItems] = useState([])
    const [archivedVariants, setArchivedVariants] = useState([])
    const [archivedModifiers, setArchivedModifiers] = useState([])
    const [loadingArchivedItems, setLoadingArchivedItems] = useState(false)
    const [archivedSearch, setArchivedSearch] = useState('')
    const [archivedCategoryFilter, setArchivedCategoryFilter] = useState('All')
    const [archivedPage, setArchivedPage] = useState(1)
    const ARCHIVED_PAGE_SIZE = 10

    //Dropdown search
    const [itemCategorySearch, setItemCategorySearch] = useState("")
    const [itemClassificationSearch, setItemClassificationSearch] = useState("")
    const [openItemCategoryDropdown, setOpenItemCategoryDropdown] = useState(false)
    const [openItemClassificationDropdown, setOpenItemClassificationDropdown] = useState(false)

    const itemCategoryDropdownRef = useRef(null)
    const itemClassificationDropdownRef = useRef(null)

    const [modifierCategorySearch, setModifierCategorySearch] = useState("")
    const [openModifierCategoryDropdown, setOpenModifierCategoryDropdown] = useState(false)
    const modifierCategoryDropdownRef = useRef(null)

    // Modifier Ingredient
    const [modifierIngredientSearch, setModifierIngredientSearch] = useState("")
    const [openModifierIngredientDropdown, setOpenModifierIngredientDropdown] = useState(false)
    const modifierIngredientDropdownRef = useRef(null)

    //Menu Request
    const [showPriceChangeRequestModal, setShowPriceChangeRequestModal] = useState(false)
    const [priceChangeRequestItem, setPriceChangeRequestItem] = useState(null)
    const [priceChangeRequestType, setPriceChangeRequestType] = useState('')
    const [priceChangeRequestedPrice, setPriceChangeRequestedPrice] = useState('')
    const [priceChangeRequestReason, setPriceChangeRequestReason] = useState('')
    const [submittingPriceChangeRequest, setSubmittingPriceChangeRequest] = useState(false)
    const [applyingPriceRequestId, setApplyingPriceRequestId] = useState(null)

    const [viewOnlyVariant, setViewOnlyVariant] = useState(false)
    const [viewOnlyModifier, setViewOnlyModifier] = useState(false)

    const [menuOverviewPage, setMenuOverviewPage] = useState(1)
    const [priceRequestsPage, setPriceRequestsPage] = useState(1)
    const [uniqueItemsPage, setUniqueItemsPage] = useState(1)

    const MENU_PAGE_SIZE = 10

    const [variantRuleFormData, setVariantRuleFormData] = useState({
        id: null,
        variant_id: '',
        ingredient_id: '',
        quantity_delta: '',
        unit: '',
        notes: ''
    })

    const [itemFormData, setItemFormData] = useState({
        name: "",
        item_price: "",
        category: "",
        classification: "",
        description: "",
        prep_time_minutes: "",
        item_img: ""
    })

    const [variantFormData, setVariantFormData] = useState({
        category: "",
        variant_name: "",
        price: "",
        applicable_categories: []
    })

    const [modifierFormData, setModifierFormData] = useState({
        modifier_name: "",
        category: "",
        price: "",
        applicable_categories: [],
        ingredient_id: ""
    })


    useEffect(() => {
        const style = document.createElement('style')
        style.innerHTML = `
            .swal2-confirm { background-color: #FF6F3C !important; border: none !important; }
            .swal2-confirm:hover { background-color: #ff4c0b !important; }
            .swal2-cancel { background-color: #6b7280 !important; border: none !important; }
            .swal2-cancel:hover { background-color: #5a5a5a !important; }
        `
        document.head.appendChild(style)
        return () => document.head.removeChild(style)
    }, [])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (variantDropdownRef.current && !variantDropdownRef.current.contains(event.target)) {
                setOpenVariantDropdown(false)
            }

            if (ingredientDropdownRef.current && !ingredientDropdownRef.current.contains(event.target)) {
                setOpenIngredientDropdown(false)
            }

            if (variantCategoryDropdownRef.current && !variantCategoryDropdownRef.current.contains(event.target)) {
                setOpenVariantCategoryDropdown(false)
            }

            if (itemCategoryDropdownRef.current && !itemCategoryDropdownRef.current.contains(event.target)) {
                setOpenItemCategoryDropdown(false)
            }

            if (itemClassificationDropdownRef.current && !itemClassificationDropdownRef.current.contains(event.target)) {
                setOpenItemClassificationDropdown(false)
            }

            if (openMenuItemId) {
                setOpenMenuItemId(null)
            }

            if (modifierCategoryDropdownRef.current && !modifierCategoryDropdownRef.current.contains(event.target)) {
                setOpenModifierCategoryDropdown(false)
            }

            if (modifierIngredientDropdownRef.current && !modifierIngredientDropdownRef.current.contains(event.target)) {
                setOpenModifierIngredientDropdown(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [])

    useEffect(() => {
        fetchModifiers()
        fetchVariants()
        fetchBranches()
        fetchIngredients()
        fetchCurrentStaff()
    }, [])

    // useEffect(() => {
    //     if (currentBranchId) {
    //         fetchMenuItems(currentBranchId)
    //         fetchBranchMenuItems(currentBranchId)
    //     }
    // }, [currentBranchId])

    useEffect(() => {
        if (currentBranchId) {
            fetchMyPriceRequests()
            fetchMyMenuChangeRequests()
        }
        setPriceRequestsPage(1)
        setMenuChangeRequestsPage(1)
        setVariantChangeRequestsPage(1)
        setModifierChangeRequestsPage(1)
    }, [currentBranchId])

    useEffect(() =>
        setMenuItemsPage(1), [searchQuery, filterCategory, filterClassification])

    useEffect(() =>
        setVariantsPage(1), [variantSearchQuery, filterVariantCategory])

    useEffect(() =>
        setModifiersPage(1), [modifierSearchQuery, filterModifierCategory])

    useEffect(() => setArchivedPage(1), [archivedSearch, archivedCategoryFilter, activeTab])

    useEffect(() => setArchivedCategoryFilter('All'), [activeTab])

    const fetchCurrentStaff = async () => {
        try {
            const sessionStaffId = getAuthItem('staffId')
            if (!sessionStaffId) return

            const { data: accountData, error: accountError } = await supabase
                .from('staff_accounts')
                .select('id, staff_id')
                .or(`id.eq.${sessionStaffId},staff_id.eq.${sessionStaffId}`)
                .single()

            if (accountError) throw accountError

            const resolvedStaffId = accountData.staff_id || accountData.id
            if (!resolvedStaffId) return

            const { data, error } = await supabase
                .from('staff')
                .select('id, branch_id')
                .eq('id', resolvedStaffId)
                .single()

            if (error) throw error
            setCurrentStaffId(data.id)
            setCurrentBranchId(data.branch_id)
            await fetchMenuItems(data.branch_id)
            fetchBranchMenuItems('all')
        } catch (err) {
            console.error('Error fetching current staff:', err)
        }
    }

    const fetchBranches = async () => {
        try {
            const { data, error } = await supabase
                .from('branches')
                .select('branch_id, name, status')
                .order('name', { ascending: true })

            if (error) throw error

            setBranches((data || []).filter(branch => branch.status !== 'inactive'))
        } catch (err) {
            console.error("Error fetching branches:", err)
        }
    }

    const fetchMenuItems = async (branchId = currentBranchId) => {
        try {
            setLoading(true)
            const { data: items, error } = await supabase
                .from('menu_items')
                .select('*')
                .eq('is_archived', false)
                .order('name', { ascending: true })
            if (error) throw error

            // Fetch branch prices for current branch (if available)
            let branchPriceMap = {}
            // const branchId = currentBranchId
            if (branchId) {
                const { data: bmiData } = await supabase
                    .from('branch_menu_items')
                    .select('item_id, branch_price')
                    .eq('branch_id', branchId)
                for (const row of bmiData || []) {
                    branchPriceMap[row.item_id] = row.branch_price
                }
            }

            const enriched = (items || []).map(item => {
                const branchPrice = branchPriceMap[item.item_id]
                const hasPriceOverride = branchPrice != null
                return {
                    ...item,
                    effective_price: hasPriceOverride ? parseFloat(branchPrice) : parseFloat(item.item_price),
                    has_price_override: hasPriceOverride,
                    branch_price: hasPriceOverride ? parseFloat(branchPrice) : null,
                    master_price: parseFloat(item.item_price),
                }
            })

            setMenuItems(enriched)
        } catch (err) {
            console.error("Error fetching menu items:", err)
        } finally {
            setLoading(false)
        }
    }

    const fetchVariants = async () => {
        try {
            setLoadingVariants(true)

            const { data, error } = await supabase
                .from('item_variants')
                .select('variant_id, category, variant_name, price, applicable_categories, created_at, is_archived')
                .eq('is_archived', false)
                .order('category', { ascending: true })
                .order('variant_name', { ascending: true })

            if (error) throw error
            setVariants(data || [])
        } catch (err) {
            console.error("Error fetching variants:", err)
            setVariants([])
        } finally {
            setLoadingVariants(false)
        }
    }

    const fetchModifiers = async () => {
        try {
            setLoadingModifiers(true)
            const { data, error } = await supabase
                .from('item_modifiers')
                .select('*')
                .eq('is_archived', false)
                .order('modifier_name', { ascending: true })

            if (error) throw error

            setModifiers(data || [])
        } catch (err) {
            console.error("Error fetching modifiers:", err)
            setModifiers([])
        } finally {
            setLoadingModifiers(false)
        }
    }

    const fetchItemVariants = async (itemId) => {
        try {
            setLoadingItemVariants(true)

            const { data, error } = await supabase
                .from('menu_variants')
                .select(`
                    variant_id,
                    item_variants (
                        variant_id,
                        category,
                        variant_name,
                        price,
                        created_at,
                        is_archived
                    )
                `)
                .eq('item_id', itemId)

            if (error) throw error

            const flattenedVariants = (data || [])
                .map((row) => row.item_variants)
                .filter((variant) => variant && variant.is_archived === false)
                .sort((a, b) => {
                    const categoryCompare = String(a.category || '').localeCompare(String(b.category || ''))
                    if (categoryCompare !== 0) return categoryCompare
                    return String(a.variant_name || '').localeCompare(String(b.variant_name || ''))
                })

            setItemVariants(flattenedVariants)
        } catch (err) {
            console.error("Error fetching item variants:", err)
            setItemVariants([])
        } finally {
            setLoadingItemVariants(false)
        }
    }

    const fetchIngredients = async () => {
        try {
            const { data, error } = await supabase
                .schema('inventory')
                .from('ingredients')
                .select('ingredient_id, name, unit, category')
                .eq('is_active', true)
                .order('name', { ascending: true })

            if (error) throw error

            setIngredients(
                (data || []).map((ingredient) => ({
                    ...ingredient,
                    ingredient_name: ingredient.name
                }))
            )
        } catch (err) {
            console.error("Error fetching ingredients:", err)
            setIngredients([])
        }
    }

    const fetchVariantRules = async (itemId) => {
        try {
            setLoadingVariantRules(true)

            const { data, error } = await supabase
                .schema('inventory')
                .from('menu_item_variant_ingredient_rules')
                .select(`
                    id,
                    item_id,
                    variant_id,
                    ingredient_id,
                    quantity_delta,
                    unit,
                    notes,
                    created_at
                `)
                .eq('item_id', itemId)
                .order('created_at', { ascending: true })

            if (error) throw error

            const { data: activeIngredients, error: ingredientError } = await supabase
                .schema('inventory')
                .from('ingredients')
                .select('ingredient_id')
                .eq('is_active', true)

            if (ingredientError) throw ingredientError

            const activeIngredientIds = new Set(
                (activeIngredients || []).map(ing => String(ing.ingredient_id))
            )

            const filteredRules = (data || []).filter(rule =>
                activeIngredientIds.has(String(rule.ingredient_id))
            )

            setVariantRules(filteredRules)
        } catch (err) {
            console.error("Error fetching variant rules:", err)
            setVariantRules([])
        } finally {
            setLoadingVariantRules(false)
        }
    }

    const fetchArchivedMenuItems = async () => {
        try {
            setLoadingArchivedItems(true)

            const { data, error } = await supabase
                .from('menu_items')
                .select('*')
                .eq('is_archived', true)
                .order('archived_at', { ascending: false })

            if (error) throw error
            setArchivedMenuItems(data || [])
        } catch (err) {
            console.error("Error fetching archived menu items:", err)
            setArchivedMenuItems([])
        } finally {
            setLoadingArchivedItems(false)
        }
    }

    const fetchArchivedVariants = async () => {
        try {
            setLoadingArchivedItems(true)

            const { data, error } = await supabase
                .from('item_variants')
                .select('variant_id, category, variant_name, price, created_at, archived_at, is_archived')
                .eq('is_archived', true)
                .order('archived_at', { ascending: false })

            if (error) throw error
            setArchivedVariants(data || [])
        } catch (err) {
            console.error("Error fetching archived variants:", err)
            setArchivedVariants([])
        } finally {
            setLoadingArchivedItems(false)
        }
    }

    const fetchArchivedModifiers = async () => {
        try {
            setLoadingArchivedItems(true)

            const { data, error } = await supabase
                .from('item_modifiers')
                .select('*')
                .eq('is_archived', true)
                .order('archived_at', { ascending: false })

            if (error) throw error
            setArchivedModifiers(data || [])
        } catch (err) {
            console.error("Error fetching archived modifiers:", err)
            setArchivedModifiers([])
        } finally {
            setLoadingArchivedItems(false)
        }
    }

    const fetchBranchMenuItems = async (branchId = 'all') => {
        try {
            setBranchMenuLoading(true)

            const { data: activeItems, error: activeItemsError } = await supabase
                .from('menu_items')
                .select('item_id')
                .eq('is_archived', false)

            if (activeItemsError) throw activeItemsError

            const activeItemIds = (activeItems || []).map((i) => i.item_id)

            if (activeItemIds.length === 0) {
                setBranchMenuItems([])
                if (branchId === 'all') setAllBranchMenuItems([])
                return
            }

            let query = supabase
                .from('branch_menu_items')
                .select(`
                    id,
                    branch_id,
                    item_id,
                    branch_price,
                    price_updated_at,
                    price_updated_by,
                    approved_at,
                    created_at,
                    updated_at,
                    branches:branch_id (
                        branch_id,
                        name
                    ),
                    menu_items:item_id (
                        item_id,
                        name,
                        item_price,
                        category,
                        classification,
                        item_img,
                        status,
                        is_archived
                    )
                `)
                .in('item_id', activeItemIds)

            if (branchId !== 'all') {
                query = query.eq('branch_id', branchId)
            }

            const { data, error } = await query
            if (error) throw error

            const formatted = (data || [])
                .filter((row) => row.menu_items && row.menu_items.is_archived === false)
                .map((row) => {
                    const masterPrice = parseFloat(row.menu_items?.item_price ?? 0)

                    const rawBranchPrice = row.branch_price
                    const hasPriceOverride =
                        rawBranchPrice !== null && rawBranchPrice !== undefined
                    const branchPrice = hasPriceOverride
                        ? parseFloat(rawBranchPrice)
                        : null
                    const effectivePrice = hasPriceOverride ? branchPrice : masterPrice

                    return {
                        id: row.id,
                        branch_id: row.branch_id,
                        item_id: row.item_id,
                        branch_name: formatBranchName(row.branches?.name) || 'Unknown Branch',
                        name: row.menu_items?.name || 'Unnamed Item',
                        master_price: masterPrice,
                        branch_price: branchPrice,
                        effective_price: effectivePrice,
                        has_price_override: hasPriceOverride,
                        price_updated_at: row.price_updated_at || null,
                        price_updated_by: row.price_updated_by || null,
                        approved_at: row.approved_at || null,
                        category: row.menu_items?.category || 'Uncategorized',
                        classification: row.menu_items?.classification || 'N/A',
                        item_img: row.menu_items?.item_img || null,
                        status: row.menu_items?.status || 'available',
                    }
                })

            setAllBranchMenuItems(formatted)
            setBranchMenuItems(formatted)

        } catch (err) {
            console.error('Error fetching branch menu items:', err)
            setBranchMenuItems([])
        } finally {
            setBranchMenuLoading(false)
        }
    }

    const fetchMyPriceRequests = async () => {
        if (!currentBranchId) return
        try {
            setLoadingMyPriceRequests(true)
            const { data, error } = await supabase
                .from('menu_price_change_requests')
                .select('id, item_type, item_id, item_name, current_price, requested_price, reason, status, branch_id, created_at, updated_at')
                .eq('branch_id', currentBranchId)
                .order('created_at', { ascending: false })
            if (error) throw error
            setMyPriceRequests(data || [])
        } catch (err) {
            setMyPriceRequests([])
        } finally {
            setLoadingMyPriceRequests(false)
        }
    }

    const fetchMyMenuChangeRequests = async () => {
        if (!currentBranchId) return
        try {
            setLoadingMyMenuChangeRequests(true)
            const { data, error } = await supabase
                .from('admin_requests')
                .select('id, request_type, item_type, item_name, reason, status, rejection_reason, created_at')
                .eq('branch_id', currentBranchId)
                .in('item_type', ['menu', 'variant', 'modifier'])
                .in('request_type', ['add', 'delete', 'reinstate'])
                .order('created_at', { ascending: false })
            if (error) throw error
            setMyMenuChangeRequests(data || [])
        } catch (err) {
            console.error('Error fetching menu change requests:', err)
            setMyMenuChangeRequests([])
        } finally {
            setLoadingMyMenuChangeRequests(false)
        }
    }

    const fetchMyReinstateRequests = async () => {
        try {
            const { data, error } = await supabase
                .from('admin_requests')
                .select('id, item_type, item_id, status')
                .in('item_type', ['menu', 'variant', 'modifier'])
                .eq('request_type', 'reinstate')
                .eq('status', 'pending')
                .order('created_at', { ascending: false })
            if (error) throw error
            setMyReinstateRequests(data || [])
        } catch (err) {
            console.error('Error fetching reinstate requests:', err)
            setMyReinstateRequests([])
        }
    }

    const hasPendingReinstateRequest = (itemType, itemId) =>
        myReinstateRequests.some(r => r.item_type === itemType && String(r.item_id) === String(itemId))

    const handleApplyBranchPrice = async (request) => {
        try {
            setApplyingPriceRequestId(request.id)

            // Re-resolve staff ID if missing (same pattern as handleSubmitPriceChangeRequest)
            let resolvedStaffId = currentStaffId
            if (!resolvedStaffId) {
                const sessionStaffId = getAuthItem('staffId')
                if (sessionStaffId) {
                    const { data: accountData } = await supabase
                        .from('staff_accounts')
                        .select('id, staff_id')
                        .or(`id.eq.${sessionStaffId},staff_id.eq.${sessionStaffId}`)
                        .single()

                    if (accountData) {
                        const resolvedStaffId = accountData.staff_id || accountData.id
                        const { data: staffData } = await supabase
                            .from('staff')
                            .select('id, branch_id')
                            .eq('id', resolvedStaffId)
                            .single()
                        if (staffData) {
                            resolvedStaffId = staffData.id  // reuse existing local variable pattern from that function
                            setCurrentStaffId(staffData.id)
                            setCurrentBranchId(staffData.branch_id)
                        }
                    }
                }
            }

            // Verify the branch_menu_items row exists using the primary key
            const { data: existing, error: fetchError } = await supabase
                .from('branch_menu_items')
                .select('id, branch_price')
                .eq('branch_id', currentBranchId)
                .eq('item_id', String(request.item_id))
                .maybeSingle()

            if (fetchError) throw fetchError

            if (!existing) {
                Swal.fire({
                    icon: 'error',
                    title: 'Row Not Found',
                    text: 'No branch_menu_items record found for this item in your branch. Please contact a Super Admin.',
                    confirmButtonColor: '#FF6F3C'
                })
                return
            }

            const now = new Date().toISOString()

            const { error } = await supabase
                .from('branch_menu_items')
                .update({
                    branch_price: parseFloat(request.requested_price),
                    approved_at: now,
                    price_updated_by: resolvedStaffId || null,
                    price_updated_at: now
                })
                .eq('id', existing.id)

            if (error) throw error

            await fetchBranchMenuItems(currentBranchId)
            await fetchMenuItems(currentBranchId)
            await fetchMyPriceRequests()

            Swal.fire({
                icon: 'success',
                title: 'Price Applied!',
                text: `Branch price for "${request.item_name}" has been set to ₱${parseFloat(request.requested_price).toFixed(2)}.`,
                confirmButtonColor: '#FF6F3C',
                timer: 2500
            })
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Failed to Apply Price', text: err.message, confirmButtonColor: '#FF6F3C' })
        } finally {
            setApplyingPriceRequestId(null)
        }
    }

    const handleCancelPriceRequest = async (request) => {
        const result = await Swal.fire({
            title: 'Cancel Price Request?',
            text: `This will cancel the pending price change request for "${request.item_name}".`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc2626',
            cancelButtonColor: '#6b7280',
            confirmButtonText: 'Yes, cancel it',
            cancelButtonText: 'Keep it'
        })

        if (!result.isConfirmed) return

        try {
            const { error } = await supabase
                .from('menu_price_change_requests')
                .update({ status: 'rejected' })
                .eq('id', request.id)

            if (error) throw error

            await fetchMyPriceRequests()

            Swal.fire({
                icon: 'success',
                title: 'Request Cancelled',
                text: `The price change request for "${request.item_name}" has been cancelled.`,
                confirmButtonColor: '#FF6F3C',
                timer: 2000
            })
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Failed to Cancel', text: err.message, confirmButtonColor: '#FF6F3C' })
        }
    }

    const handleCancelMenuChangeRequest = async (request) => {
        const result = await Swal.fire({
            title: 'Cancel Request?',
            text: `This will cancel the pending request for "${request.item_name}".`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc2626',
            cancelButtonColor: '#6b7280',
            confirmButtonText: 'Yes, cancel it',
            cancelButtonText: 'Keep it'
        })

        if (!result.isConfirmed) return

        try {
            const { error } = await supabase
                .from('admin_requests')
                .update({ status: 'rejected' })
                .eq('id', request.id)

            if (error) throw error

            await fetchMyMenuChangeRequests()

            Swal.fire({
                icon: 'success',
                title: 'Request Cancelled',
                text: `The request for "${request.item_name}" has been cancelled.`,
                confirmButtonColor: '#FF6F3C',
                timer: 2000
            })
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Failed to Cancel', text: err.message, confirmButtonColor: '#FF6F3C' })
        }
    }

    const resetVariantRuleForm = () => {
        const emptyRule = {
            id: null,
            variant_id: '',
            ingredient_id: '',
            quantity_delta: '',
            unit: '',
            notes: ''
        }

        setVariantRuleFormData(emptyRule)
        setInitialVariantRuleFormData(emptyRule)
        setVariantRuleVariantSearch('')
        setVariantRuleIngredientSearch('')
        setOpenVariantDropdown(false)
        setOpenIngredientDropdown(false)
    }

    const openVariantRulesModal = async (item) => {
        setSelectedItemForVariantRules(item)
        setShowVariantRulesModal(true)

        const emptyRule = {
            id: null,
            variant_id: '',
            ingredient_id: '',
            quantity_delta: '',
            unit: '',
            notes: ''
        }

        setVariantRuleFormData(emptyRule)
        setInitialVariantRuleFormData(emptyRule)
        setVariantRuleVariantSearch('')
        setVariantRuleIngredientSearch('')
        setOpenVariantDropdown(false)
        setOpenIngredientDropdown(false)

        await Promise.all([
            fetchItemVariants(item.item_id),
            fetchIngredients(),
            fetchVariantRules(item.item_id)
        ])
    }

    const closeVariantRulesModal = () => {
        setShowVariantRulesModal(false)
        setSelectedItemForVariantRules(null)
        setItemVariants([])
        setVariantRules([])
        setVariantRuleTableSearch('')
        resetVariantRuleForm()
    }

    const handleSaveVariantRule = async () => {
        if (!hasVariantRuleChanges) return

        if (!selectedItemForVariantRules?.item_id) {
            Swal.fire({
                icon: 'warning',
                title: 'No item selected',
                text: 'Please select a menu item first.',
                confirmButtonColor: '#FF6F3C'
            })
            return
        }

        if (!variantRuleFormData.variant_id || !variantRuleFormData.ingredient_id || variantRuleFormData.quantity_delta === '') {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Information',
                text: 'Please fill in variant, ingredient, and quantity.',
                confirmButtonColor: '#FF6F3C'
            })
            return
        }

        const quantity = parseFloat(variantRuleFormData.quantity_delta)
        if (isNaN(quantity) || quantity < 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Invalid Quantity',
                text: 'Quantity delta must be 0 or greater.',
                confirmButtonColor: '#FF6F3C'
            })
            return
        }

        try {
            setSavingVariantRule(true)

            const selectedIngredient = ingredients.find(
                ing => String(ing.ingredient_id) === String(variantRuleFormData.ingredient_id)
            )

            if (!selectedIngredient?.unit || !String(selectedIngredient.unit).trim()) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Missing Ingredient Unit',
                    text: 'The selected ingredient has no unit. Please set its unit first in Inventory Management.',
                    confirmButtonColor: '#FF6F3C'
                })
                return
            }

            const payload = {
                item_id: selectedItemForVariantRules.item_id,
                variant_id: variantRuleFormData.variant_id,
                ingredient_id: variantRuleFormData.ingredient_id,
                quantity_delta: quantity,
                unit: String(selectedIngredient.unit).trim(),
                notes: variantRuleFormData.notes.trim() || null
            }

            if (variantRuleFormData.id) {
                const { error } = await supabase
                    .schema('inventory')
                    .from('menu_item_variant_ingredient_rules')
                    .update(payload)
                    .eq('id', variantRuleFormData.id)

                if (error) throw error
            } else {
                const { error } = await supabase
                    .schema('inventory')
                    .from('menu_item_variant_ingredient_rules')
                    .insert([payload])

                if (error) throw error
            }

            resetVariantRuleForm()
            await fetchVariantRules(selectedItemForVariantRules.item_id)

            Swal.fire({
                icon: 'success',
                title: variantRuleFormData.id ? 'Rule Updated!' : 'Rule Added!',
                text: 'Variant ingredient rule has been saved successfully.',
                confirmButtonColor: '#FF6F3C',
                timer: 1800
            })
        } catch (err) {
            console.error("Error saving variant rule:", err)
            Swal.fire({
                icon: 'error',
                title: 'Failed to Save Rule',
                text: err.message,
                confirmButtonColor: '#FF6F3C'
            })
        } finally {
            setSavingVariantRule(false)
        }
    }

    const handleEditVariantRule = (rule) => {
        const selectedVariant = itemVariants.find(
            (variant) => String(variant.variant_id) === String(rule.variant_id)
        )

        const selectedIngredient = ingredients.find(
            (ingredient) => String(ingredient.ingredient_id) === String(rule.ingredient_id)
        )

        const normalizedRuleData = {
            id: rule.id,
            variant_id: rule.variant_id || '',
            ingredient_id: rule.ingredient_id || '',
            quantity_delta: String(rule.quantity_delta ?? ''),
            unit: rule.unit || selectedIngredient?.unit || '',
            notes: rule.notes || ''
        }

        setVariantRuleFormData(normalizedRuleData)
        setInitialVariantRuleFormData(normalizedRuleData)

        setVariantRuleVariantSearch(
            selectedVariant
                ? `${selectedVariant.category ? `${selectedVariant.category} - ` : ''}${selectedVariant.variant_name || ''}`
                : ''
        )

        setVariantRuleIngredientSearch(
            selectedIngredient?.ingredient_name || selectedIngredient?.name || ''
        )

        setOpenVariantDropdown(false)
        setOpenIngredientDropdown(false)
    }

    const handleDeleteVariantRule = async (ruleId) => {
        const result = await Swal.fire({
            title: 'Delete Variant Rule?',
            text: 'This rule will be permanently removed.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc2626',
            cancelButtonColor: '#6b7280',
            confirmButtonText: 'Yes, delete',
            cancelButtonText: 'Cancel'
        })

        if (!result.isConfirmed) return

        try {
            const { error } = await supabase
                .schema('inventory')
                .from('menu_item_variant_ingredient_rules')
                .delete()
                .eq('id', ruleId)

            if (error) throw error

            if (variantRuleFormData.id === ruleId) {
                resetVariantRuleForm()
            }

            await fetchVariantRules(selectedItemForVariantRules.item_id)

            Swal.fire({
                icon: 'success',
                title: 'Rule Deleted',
                text: 'Variant ingredient rule has been removed.',
                confirmButtonColor: '#FF6F3C',
                timer: 1800
            })
        } catch (err) {
            console.error("Error deleting variant rule:", err)
            Swal.fire({
                icon: 'error',
                title: 'Failed to Delete Rule',
                text: err.message,
                confirmButtonColor: '#FF6F3C'
            })
        }
    }

    // === Modifier assignment ──────────────────────────────────────────────────

    const openAssignModifiersModal = async (item) => {
        setSelectedItemForModifiers(item)
        setLoadingAssignments(true)
        setShowAssignModifiersModal(true)

        try {
            await fetchModifiers()

            const { data, error } = await supabase
                .from('menu_modifiers')
                .select('modifier_id')
                .eq('item_id', item.item_id)

            if (error) throw error

            const modifierSet = new Set((data || []).map(r => r.modifier_id))
            setAssignedModifierIds(modifierSet)
            setInitialAssignedModifierIds(new Set(modifierSet))
        } catch (err) {
            console.error("Error fetching assignments:", err)
            Swal.fire({
                icon: 'error',
                title: 'Failed to load assignments',
                text: err.message,
                confirmButtonColor: '#FF6F3C'
            })
        } finally {
            setLoadingAssignments(false)
        }
    }

    const closeAssignModifiersModal = () => {
        setShowAssignModifiersModal(false)
        setSelectedItemForModifiers(null)
        setAssignedModifierIds(new Set())
        setInitialAssignedModifierIds(new Set())
        setAssignModifierCategoryFilter('All')
        setAssignModifierSearch('')
    }

    const toggleModifierAssignment = (modifierId) => {
        setAssignedModifierIds(prev => {
            const next = new Set(prev)
            if (next.has(modifierId)) { next.delete(modifierId) } else { next.add(modifierId) }
            return next
        })
    }

    const toggleBranchSelection = (branchId) => {
        setSelectedBranchIds(prev => {
            const next = new Set(prev)
            if (next.has(branchId)) {
                next.delete(branchId)
            } else {
                next.add(branchId)
            }
            return next
        })
    }

    const allActiveBranchIds = branches.map(branch => branch.branch_id)

    const areAllBranchesSelected =
        branches.length > 0 && selectedBranchIds.size === branches.length

    const handleSelectAllBranches = () => {
        setSelectedBranchIds(new Set(allActiveBranchIds))
    }

    const handleClearAllBranches = () => {
        setSelectedBranchIds(new Set())
    }

    const handleToggleSelectAllBranches = () => {
        if (areAllBranchesSelected) {
            handleClearAllBranches()
        } else {
            handleSelectAllBranches()
        }
    }

    const saveModifierAssignments = async () => {
        if (!hasModifierAssignmentChanges) return

        if (!selectedItemForModifiers) return

        setSavingAssignments(true)

        try {
            const { error: deleteError } = await supabase
                .from('menu_modifiers')
                .delete()
                .eq('item_id', selectedItemForModifiers.item_id)

            if (deleteError) throw deleteError

            if (assignedModifierIds.size > 0) {
                const rows = Array.from(assignedModifierIds).map(modifier_id => ({
                    item_id: selectedItemForModifiers.item_id,
                    modifier_id
                }))

                const { error: insertError } = await supabase
                    .from('menu_modifiers')
                    .insert(rows)

                if (insertError) throw insertError
            }

            closeAssignModifiersModal()

            Swal.fire({
                icon: 'success',
                title: 'Modifiers updated!',
                text: `Modifiers for ${selectedItemForModifiers.name} have been saved`,
                confirmButtonColor: '#FF6F3C',
                timer: 2500
            })
        } catch (err) {
            console.error("Error saving assignments:", err)
            Swal.fire({
                icon: 'error',
                title: 'Failed to save',
                text: err.message,
                confirmButtonColor: '#FF6F3C'
            })
        } finally {
            setSavingAssignments(false)
        }
    }

    // === Archived ───────────────────────────────────────────────────────────

    const openArchivedViewerModal = async () => {
        setShowArchivedViewerModal(true)

        await fetchMyReinstateRequests()

        if (activeTab === 'menu') {
            await fetchArchivedMenuItems()
        } else if (activeTab === 'variants') {
            await fetchArchivedVariants()
        } else if (activeTab === 'modifiers') {
            await fetchArchivedModifiers()
        }
    }

    const closeArchivedViewerModal = () => {
        setShowArchivedViewerModal(false)
        setArchivedMenuItems([])
        setArchivedVariants([])
        setArchivedModifiers([])
        setArchivedSearch('')
        setArchivedCategoryFilter('All')
        setArchivedPage(1)
    }

    // === Reinstate ───────────────────────────────────────────────────────────
    const handleRequestReinstateItem = (item) => {
        if (
            isDuplicateMenuItem(
                item.name,
                item.category,
                item.classification,
                item.item_id
            )
        ) {
            Swal.fire({
                icon: "warning",
                title: "Cannot Reinstate Item",
                text: `"${item.name}" already exists as an active menu item.`,
                confirmButtonColor: "#FF6F3C"
            })
            return
        }
        setReinstateRequestItem(item)
        setReinstateRequestType('menu')
        setReinstateRequestReason('')
        setShowReinstateRequestModal(true)
    }

    const handleRequestReinstateVariant = (variant) => {
        if (isDuplicateActiveVariant(variant)) {
            Swal.fire({
                icon: "warning",
                title: "Cannot Reinstate Variant",
                text: `The variant "${variant.variant_name}" already exists as an active variant under "${normalizeVariantCategory(variant.category || '')}".`,
                confirmButtonColor: "#FF6F3C"
            })
            return
        }
        setReinstateRequestItem(variant)
        setReinstateRequestType('variant')
        setReinstateRequestReason('')
        setShowReinstateRequestModal(true)
    }

    const handleRequestReinstateModifier = (modifier) => {
        if (isDuplicateActiveModifier(modifier)) {
            Swal.fire({
                icon: "warning",
                title: "Cannot Reinstate Modifier",
                text: `The modifier "${modifier.modifier_name}" already exists as an active modifier under "${normalizeModifierCategory(modifier.category || '')}".`,
                confirmButtonColor: "#FF6F3C"
            })
            return
        }
        setReinstateRequestItem(modifier)
        setReinstateRequestType('modifier')
        setReinstateRequestReason('')
        setShowReinstateRequestModal(true)
    }

    const handleSubmitReinstateRequest = async () => {
        if (!reinstateRequestReason.trim()) {
            Swal.fire({ icon: 'warning', title: 'Reason Required', text: 'Please provide a reason for this request.', confirmButtonColor: '#A0826D' })
            return
        }
        try {
            setSubmittingReinstateRequest(true)

            const itemId =
                reinstateRequestType === 'menu' ? reinstateRequestItem.item_id :
                    reinstateRequestType === 'variant' ? reinstateRequestItem.variant_id :
                        reinstateRequestItem.modifier_id
            const itemName =
                reinstateRequestType === 'menu' ? reinstateRequestItem.name :
                    reinstateRequestType === 'variant' ? reinstateRequestItem.variant_name :
                        reinstateRequestItem.modifier_name

            const { error } = await supabase
                .from('admin_requests')
                .insert([{
                    request_type: 'reinstate',
                    item_type: reinstateRequestType,
                    item_id: String(itemId),
                    item_name: itemName,
                    reason: reinstateRequestReason.trim(),
                    branch_id: currentBranchId,
                    status: 'pending',
                    created_at: new Date().toISOString()
                }])
            if (error) throw error

            setShowReinstateRequestModal(false)
            setReinstateRequestItem(null)
            setReinstateRequestReason('')
            await fetchMyReinstateRequests()

            Swal.fire({ icon: 'success', title: 'Request Submitted!', text: `Reinstate request for "${itemName}" sent to Super Admin.`, confirmButtonColor: '#A0826D', timer: 3000 })
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Failed to Submit', text: err.message, confirmButtonColor: '#A0826D' })
        } finally {
            setSubmittingReinstateRequest(false)
        }
    }

    // === Validation ───────────────────────────────────────────────────────────

    const validateItemForm = () => {
        if (itemFormData.name.length > 50) { Swal.fire({ icon: "warning", title: "Invalid Item Name", text: "Item name must not exceed 50 characters", confirmButtonColor: "#FF6F3C" }); return false }
        if (itemFormData.name.trim().length < 2) { Swal.fire({ icon: "warning", title: "Invalid Item Name", text: "Item name must be at least 2 characters long", confirmButtonColor: "#FF6F3C" }); return false }
        const price = parseFloat(itemFormData.item_price)
        if (isNaN(price) || price <= 0) { Swal.fire({ icon: "warning", title: "Invalid Price", text: "Price must be a positive number greater than 0", confirmButtonColor: "#FF6F3C" }); return false }
        if (price > 10000) { Swal.fire({ icon: "warning", title: "Invalid Price", text: "Price must not exceed ₱10,000", confirmButtonColor: "#FF6F3C" }); return false }
        if (itemFormData.description.length > 100) { Swal.fire({ icon: "warning", title: "Invalid Description", text: "Description must not exceed 100 characters", confirmButtonColor: "#FF6F3C" }); return false }
        if (itemFormData.description.trim().length < 10) { Swal.fire({ icon: "warning", title: "Invalid Description", text: "Description must be at least 10 characters long", confirmButtonColor: "#FF6F3C" }); return false }
        if (imageInputMode === 'url' && itemFormData.item_img && itemFormData.item_img.trim() !== "") {
            const urlRegex = /^https?:\/\/.+/i
            if (!urlRegex.test(itemFormData.item_img.trim())) {
                Swal.fire({
                    icon: "warning",
                    title: "Invalid Image URL",
                    text: "Please enter a valid image URL starting with http:// or https://",
                    confirmButtonColor: "#FF6F3C"
                })
                return false
            }
        }
        return true
    }

    const validateVariantForm = () => {
        if (String(variantFormData.category || '').trim().length < 2) {
            Swal.fire({
                icon: "warning",
                title: "Invalid Category",
                text: "Variant category must be at least 2 characters long",
                confirmButtonColor: "#FF6F3C"
            })
            return false
        }

        if (String(variantFormData.category || '').trim().length > 30) {
            Swal.fire({
                icon: "warning",
                title: "Invalid Category",
                text: "Variant category must not exceed 30 characters",
                confirmButtonColor: "#FF6F3C"
            })
            return false
        }

        if (variantFormData.variant_name.length > 30) {
            Swal.fire({
                icon: "warning",
                title: "Invalid Variant Name",
                text: "Variant name must not exceed 30 characters",
                confirmButtonColor: "#FF6F3C"
            })
            return false
        }

        if (variantFormData.variant_name.trim().length < 2) {
            Swal.fire({
                icon: "warning",
                title: "Invalid Variant Name",
                text: "Variant name must be at least 2 characters long",
                confirmButtonColor: "#FF6F3C"
            })
            return false
        }

        const price = parseFloat(variantFormData.price)
        if (isNaN(price) || price < 0) {
            Swal.fire({
                icon: "warning",
                title: "Invalid Price",
                text: "Price must be a valid number (can be 0 for no additional charge)",
                confirmButtonColor: "#FF6F3C"
            })
            return false
        }

        if (price > 1000) {
            Swal.fire({
                icon: "warning",
                title: "Invalid Price",
                text: "Variant price must not exceed ₱1,000",
                confirmButtonColor: "#FF6F3C"
            })
            return false
        }

        return true
    }

    const validateModifierForm = () => {
        if (modifierFormData.modifier_name.length > 50) { Swal.fire({ icon: "warning", title: "Invalid Modifier Name", text: "Modifier name must not exceed 50 characters", confirmButtonColor: "#FF6F3C" }); return false }
        if (modifierFormData.modifier_name.trim().length < 2) { Swal.fire({ icon: "warning", title: "Invalid Modifier Name", text: "Modifier name must be at least 2 characters long", confirmButtonColor: "#FF6F3C" }); return false }
        const price = parseFloat(modifierFormData.price)
        if (isNaN(price) || price < 0) { Swal.fire({ icon: "warning", title: "Invalid Price", text: "Price must be a valid number (can be 0 for no additional charge)", confirmButtonColor: "#FF6F3C" }); return false }
        if (price > 500) { Swal.fire({ icon: "warning", title: "Invalid Price", text: "Modifier price must not exceed ₱500", confirmButtonColor: "#FF6F3C" }); return false }
        return true
    }

    const isDuplicateMenuItem = (name, category, classification, excludeItemId = null) => {
        const normalizedName = String(name || '').trim().toLowerCase()
        const normalizedCategory = normalizeItemCategory(category || '').toLowerCase()
        const normalizedClassification = normalizeItemClassification(classification || '').toLowerCase()

        return menuItems.some((item) => {
            if (excludeItemId && String(item.item_id) === String(excludeItemId)) {
                return false
            }

            return (
                String(item.name || '').trim().toLowerCase() === normalizedName &&
                normalizeItemCategory(item.category || '').toLowerCase() === normalizedCategory &&
                normalizeItemClassification(item.classification || '').toLowerCase() === normalizedClassification
            )
        })
    }

    const isDuplicateActiveMenuItem = (item) => {
        const normalizedName = String(item.name || '').trim().toLowerCase()
        const normalizedCategory = normalizeItemCategory(item.category || '').toLowerCase()
        const normalizedClassification = normalizeItemClassification(item.classification || '').toLowerCase()

        return menuItems.some((activeItem) => {
            return (
                String(activeItem.item_id) !== String(item.item_id) &&
                String(activeItem.name || '').trim().toLowerCase() === normalizedName &&
                normalizeItemCategory(activeItem.category || '').toLowerCase() === normalizedCategory &&
                normalizeItemClassification(activeItem.classification || '').toLowerCase() === normalizedClassification
            )
        })
    }

    const isDuplicateVariant = (category, variantName, excludeVariantId = null) => {
        const normalizedCategory = normalizeVariantCategory(category)
        const normalizedName = normalizeVariantName(variantName)

        return variants.some((variant) => {
            if (excludeVariantId && String(variant.variant_id) === String(excludeVariantId)) {
                return false
            }

            return (
                normalizeVariantCategory(variant.category) === normalizedCategory &&
                normalizeVariantName(variant.variant_name) === normalizedName
            )
        })
    }

    const isDuplicateActiveVariant = (variant) => {
        const normalizedCategory = normalizeVariantCategory(variant.category || '')
        const normalizedName = normalizeVariantName(variant.variant_name || '')

        return variants.some((activeVariant) => {
            return (
                String(activeVariant.variant_id) !== String(variant.variant_id) &&
                normalizeVariantCategory(activeVariant.category || '') === normalizedCategory &&
                normalizeVariantName(activeVariant.variant_name || '') === normalizedName
            )
        })
    }

    const isDuplicateModifier = (modifierName, category, excludeModifierId = null) => {
        const normalizedName = normalizeModifierName(modifierName)
        const normalizedCategory = normalizeModifierCategory(category)

        return modifiers.some((modifier) => {
            if (excludeModifierId && String(modifier.modifier_id) === String(excludeModifierId)) {
                return false
            }

            return (
                normalizeModifierName(modifier.modifier_name) === normalizedName &&
                normalizeModifierCategory(modifier.category) === normalizedCategory
            )
        })
    }

    const isDuplicateActiveModifier = (modifier) => {
        const normalizedCategory = normalizeModifierCategory(modifier.category || '')
        const normalizedName = normalizeModifierName(modifier.modifier_name || '')

        return modifiers.some((activeModifier) => {
            return (
                String(activeModifier.modifier_id) !== String(modifier.modifier_id) &&
                normalizeModifierCategory(activeModifier.category || '') === normalizedCategory &&
                normalizeModifierName(activeModifier.modifier_name || '') === normalizedName
            )
        })
    }

    // === CRUD ─────────────────────────────────────────────────────────────────

    const handleOpenAddItemRequestModal = () => {
        const normalizedName = toTitleCase(itemFormData.name)
        const normalizedCategory = normalizeItemCategory(itemFormData.category)
        const normalizedClassification = normalizeItemClassification(itemFormData.classification)

        if (!itemFormData.name || !itemFormData.item_price || !itemFormData.category || !itemFormData.classification || !itemFormData.description) {
            Swal.fire({ icon: "warning", title: "Missing Information", text: "Please fill in all required fields", confirmButtonColor: "#FF6F3C" })
            return
        }
        if (!validateItemForm()) return
        if (isDuplicateMenuItem(normalizedName, normalizedCategory, normalizedClassification)) {
            Swal.fire({ icon: "warning", title: "Duplicate Item", text: `"${normalizedName}" already exists.`, confirmButtonColor: "#FF6F3C" })
            return
        }
        setAddItemRequestReason('')
        setShowAddItemRequestReasonModal(true)
    }

    const handleSubmitAddItemRequest = async () => {
        if (!addItemRequestReason.trim()) {
            Swal.fire({ icon: 'warning', title: 'Reason Required', text: 'Please provide a reason for this request.', confirmButtonColor: '#A0826D' })
            return
        }
        try {
            setSubmittingAddItemRequest(true)

            let finalImageUrl = itemFormData.item_img.trim() || null
            if (imageInputMode === 'upload' && itemImageFile) {
                setUploadingImage(true)
                finalImageUrl = await uploadMenuItemImage(itemImageFile)
                setUploadingImage(false)
            }

            const normalizedName = toTitleCase(itemFormData.name)
            const changes = JSON.stringify({
                name: normalizedName,
                item_price: parseFloat(itemFormData.item_price),
                category: normalizeItemCategory(itemFormData.category),
                classification: normalizeItemClassification(itemFormData.classification),
                description: itemFormData.description.trim(),
                item_img: finalImageUrl,
                branch_ids: currentBranchId ? [currentBranchId] : []
            })

            const { error } = await supabase
                .from('admin_requests')
                .insert([{
                    request_type: 'add',
                    item_type: 'menu',
                    item_id: null,
                    item_name: normalizedName,
                    reason: addItemRequestReason.trim(),
                    changes,
                    branch_id: currentBranchId,
                    status: 'pending',
                    created_at: new Date().toISOString()
                }])
            if (error) throw error

            setShowAddItemRequestReasonModal(false)
            setAddItemRequestReason('')
            setShowAddItemModal(false)
            resetItemForm()

            Swal.fire({ icon: 'success', title: 'Request Submitted!', text: `Request to add "${normalizedName}" sent to Super Admin.`, confirmButtonColor: '#A0826D', timer: 3000 })
        } catch (err) {
            setUploadingImage(false)
            Swal.fire({ icon: 'error', title: 'Failed to Submit', text: err.message, confirmButtonColor: '#A0826D' })
        } finally {
            setSubmittingAddItemRequest(false)
        }
    }

    const handleOpenAddVariantRequestModal = () => {
        if (!variantFormData.category || !variantFormData.variant_name || variantFormData.price === "") {
            Swal.fire({ icon: "warning", title: "Missing Information", text: "Please fill in all fields", confirmButtonColor: "#FF6F3C" })
            return
        }
        if (!validateVariantForm()) return

        const normalizedCategory = normalizeVariantCategory(variantFormData.category)
        const normalizedVariantName = normalizeVariantName(variantFormData.variant_name)

        if (isDuplicateVariant(normalizedCategory, normalizedVariantName)) {
            Swal.fire({ icon: "warning", title: "Duplicate Variant", text: `"${normalizedVariantName}" already exists under "${normalizedCategory}".`, confirmButtonColor: "#FF6F3C" })
            return
        }

        setAddVariantRequestReason('')
        setShowAddVariantRequestModal(true)
    }

    const handleSubmitAddVariantRequest = async () => {
        if (!addVariantRequestReason.trim()) {
            Swal.fire({ icon: 'warning', title: 'Reason Required', text: 'Please provide a reason for this request.', confirmButtonColor: '#A0826D' })
            return
        }
        try {
            setSubmittingAddVariantRequest(true)

            const normalizedCategory = normalizeVariantCategory(variantFormData.category)
            const normalizedVariantName = normalizeVariantName(variantFormData.variant_name)

            const changes = JSON.stringify({
                category: normalizedCategory,
                variant_name: normalizedVariantName,
                price: parseFloat(variantFormData.price),
                applicable_categories: variantFormData.applicable_categories
            })

            const { error } = await supabase
                .from('admin_requests')
                .insert([{
                    request_type: 'add',
                    item_type: 'variant',
                    item_id: null,
                    item_name: normalizedVariantName,
                    reason: addVariantRequestReason.trim(),
                    changes,
                    branch_id: currentBranchId,
                    status: 'pending',
                    created_at: new Date().toISOString()
                }])
            if (error) throw error

            setShowAddVariantRequestModal(false)
            setAddVariantRequestReason('')
            setShowAddVariantModal(false)
            setVariantFormData({ category: "", variant_name: "", price: "", applicable_categories: [] })
            setVariantCategorySearch("")

            Swal.fire({ icon: 'success', title: 'Request Submitted!', text: `Request to add "${normalizedVariantName}" sent to Super Admin.`, confirmButtonColor: '#A0826D', timer: 3000 })
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Failed to Submit', text: err.message, confirmButtonColor: '#A0826D' })
        } finally {
            setSubmittingAddVariantRequest(false)
        }
    }

    const handleOpenAddModifierRequestModal = () => {
        if (!modifierFormData.modifier_name || !modifierFormData.category || modifierFormData.price === "") {
            Swal.fire({ icon: "warning", title: "Missing Information", text: "Please fill in all fields", confirmButtonColor: "#FF6F3C" })
            return
        }
        if (!validateModifierForm()) return

        const normalizedModifierName = normalizeModifierName(modifierFormData.modifier_name)
        const normalizedCategory = normalizeModifierCategory(modifierFormData.category)

        if (isDuplicateModifier(normalizedModifierName, normalizedCategory)) {
            Swal.fire({ icon: "warning", title: "Duplicate Modifier", text: `"${normalizedModifierName}" already exists under "${normalizedCategory}".`, confirmButtonColor: "#FF6F3C" })
            return
        }

        setAddModifierRequestReason('')
        setShowAddModifierRequestModal(true)
    }

    const handleSubmitAddModifierRequest = async () => {
        if (!addModifierRequestReason.trim()) {
            Swal.fire({ icon: 'warning', title: 'Reason Required', text: 'Please provide a reason for this request.', confirmButtonColor: '#A0826D' })
            return
        }
        try {
            setSubmittingAddModifierRequest(true)

            const normalizedModifierName = normalizeModifierName(modifierFormData.modifier_name)
            const normalizedCategory = normalizeModifierCategory(modifierFormData.category)

            const changes = JSON.stringify({
                modifier_name: normalizedModifierName,
                category: normalizedCategory,
                price: parseFloat(modifierFormData.price),
                applicable_categories: modifierFormData.applicable_categories,
                ingredient_id: modifierFormData.ingredient_id || null
            })

            const { error } = await supabase
                .from('admin_requests')
                .insert([{
                    request_type: 'add',
                    item_type: 'modifier',
                    item_id: null,
                    item_name: normalizedModifierName,
                    reason: addModifierRequestReason.trim(),
                    changes,
                    branch_id: currentBranchId,
                    status: 'pending',
                    created_at: new Date().toISOString()
                }])
            if (error) throw error

            setShowAddModifierRequestModal(false)
            setAddModifierRequestReason('')
            setShowAddModifierModal(false)
            setModifierFormData({ modifier_name: "", category: "", price: "", applicable_categories: [], ingredient_id: "" })
            setModifierIngredientSearch("")

            Swal.fire({ icon: 'success', title: 'Request Submitted!', text: `Request to add "${normalizedModifierName}" sent to Super Admin.`, confirmButtonColor: '#A0826D', timer: 3000 })
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Failed to Submit', text: err.message, confirmButtonColor: '#A0826D' })
        } finally {
            setSubmittingAddModifierRequest(false)
        }
    }

    const handleAddItem = async () => {
        const normalizedName = toTitleCase(itemFormData.name)
        const normalizedCategory = normalizeItemCategory(itemFormData.category)
        const normalizedClassification = normalizeItemClassification(itemFormData.classification)

        if (isDuplicateMenuItem(normalizedName, normalizedCategory, normalizedClassification)) {
            Swal.fire({
                icon: "warning",
                title: "Duplicate Item",
                text: `"${normalizedName}" already exists under "${normalizedCategory}" (${normalizedClassification}).`,
                confirmButtonColor: "#FF6F3C"
            })
            return
        }

        if (!itemFormData.name ||
            !itemFormData.item_price ||
            !itemFormData.category ||
            !itemFormData.classification ||
            !itemFormData.description
        ) {
            Swal.fire({
                icon: "warning",
                title: "Missing Information",
                text: "Please fill in all required fields",
                confirmButtonColor: "#FF6F3C"
            })
            return
        }

        if (selectedBranchIds.size === 0) {
            Swal.fire({
                icon: "warning",
                title: "No Branch Selected",
                text: "Please select at least one branch where this menu item is available.",
                confirmButtonColor: "#FF6F3C"
            })
            return
        }

        if (!validateItemForm()) return

        try {
            let finalImageUrl = itemFormData.item_img.trim() || null

            if (imageInputMode === 'upload' && itemImageFile) {
                setUploadingImage(true)
                finalImageUrl = await uploadMenuItemImage(itemImageFile)
                setUploadingImage(false)
            }

            const { data, error } = await supabase
                .from('menu_items')
                .insert([{
                    name: normalizedName,
                    item_price: parseFloat(itemFormData.item_price),
                    category: normalizedCategory,
                    classification: normalizedClassification,
                    description: itemFormData.description.trim(),
                    item_img: finalImageUrl,
                    status: 'available'
                }])
                .select()
                .single()

            if (error) throw error

            const branchRows = Array.from(selectedBranchIds).map(branch_id => ({
                item_id: data.item_id,
                branch_id
            }))

            const { error: branchError } = await supabase
                .from('branch_menu_items')
                .insert(branchRows)

            if (branchError) throw branchError

            resetItemForm()
            setShowAddItemModal(false)

            Swal.fire({
                icon: "success",
                title: "Item Added!",
                text: `${itemFormData.name} has been added to the menu`,
                confirmButtonColor: "#FF6F3C",
                timer: 3000
            })

            fetchMenuItems()
        } catch (err) {
            setUploadingImage(false)
            Swal.fire({
                icon: "error",
                title: "Failed to Add Item",
                text: err.message,
                confirmButtonColor: "#FF6F3C"
            })
        }
    }

    const uploadMenuItemImage = async (file) => {
        if (!file) return null

        const allowedTypes = ['image/jpeg', 'image/png', 'image/webp']
        if (!allowedTypes.includes(file.type)) {
            throw new Error('Only JPG, PNG, and WEBP images are allowed.')
        }

        const maxSizeInBytes = 5 * 1024 * 1024
        if (file.size > maxSizeInBytes) {
            throw new Error('Image size must not exceed 5MB.')
        }

        const fileExt = file.name.split('.').pop()

        const slugify = (value = "") =>
            String(value)
                .trim()
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, '-')
                .replace(/^-+|-+$/g, '')

        const now = new Date()
        const pad = (n) => String(n).padStart(2, '0')
        const datetime = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`

        const namePart = slugify(itemFormData.name) || 'item'
        const categoryPart = slugify(itemFormData.category) || 'uncategorized'

        const fileName = `${namePart}_${categoryPart}_${datetime}.${fileExt}`
        const filePath = `menu-items/${fileName}`

        const { error: uploadError } = await supabase
            .storage
            .from('menu-images')
            .upload(filePath, file, {
                cacheControl: '3600',
                upsert: false
            })

        if (uploadError) throw uploadError

        const { data } = supabase
            .storage
            .from('menu-images')
            .getPublicUrl(filePath)

        return data.publicUrl
    }

    const handleEditClick = async (item) => {
        const normalizedItemData = {
            name: normalizeItemName(item.name || ''),
            item_price: String(item.item_price ?? ''),
            effective_price: item.effective_price ?? parseFloat(item.item_price ?? 0),
            has_price_override: item.has_price_override ?? false,
            master_price: item.master_price ?? parseFloat(item.item_price ?? 0),
            category: normalizeItemCategory(item.category || ''),
            classification: normalizeItemClassification(item.classification || ''),
            description: item.description || '',
            item_img: item.item_img || ''
        }

        setEditingItem(item)
        setItemFormData(normalizedItemData)
        setInitialItemFormData(normalizedItemData)
        setItemCategorySearch(normalizeItemCategory(item.category || ""))
        setItemClassificationSearch(normalizeItemClassification(item.classification || ""))
        setOpenItemCategoryDropdown(false)
        setOpenItemClassificationDropdown(false)

        try {
            const { data, error } = await supabase
                .from('branch_menu_items')
                .select('branch_id')
                .eq('item_id', item.item_id)

            if (error) throw error

            const branchSet = new Set((data || []).map(row => row.branch_id))
            setSelectedBranchIds(branchSet)
            setInitialSelectedBranchIds(new Set(branchSet))
            setItemImageFile(null)
            setImageInputMode(item.item_img ? 'url' : 'upload')
            setShowEditItemModal(true)
        } catch (err) {
            console.error("Error loading branch assignments:", err)
            Swal.fire({
                icon: "error",
                title: "Failed to Load Branches",
                text: err.message,
                confirmButtonColor: "#FF6F3C"
            })
        }
    }

    const handleUpdateItem = async () => {
        if (!editingItem) return

        const normalizedName = normalizeItemName(itemFormData.name)
        const normalizedCategory = normalizeItemCategory(itemFormData.category)
        const normalizedClassification = normalizeItemClassification(itemFormData.classification)

        if (
            !itemFormData.name ||
            !itemFormData.item_price ||
            !itemFormData.category ||
            !itemFormData.classification ||
            !itemFormData.description
        ) {
            Swal.fire({
                icon: "warning",
                title: "Missing Information",
                text: "Please fill in all required fields",
                confirmButtonColor: "#FF6F3C"
            })
            return
        }

        if (selectedBranchIds.size === 0) {
            Swal.fire({
                icon: "warning",
                title: "No Branch Selected",
                text: "Please select at least one branch where this menu item is available.",
                confirmButtonColor: "#FF6F3C"
            })
            return
        }

        if (!validateItemForm()) return

        if (
            isDuplicateMenuItem(
                normalizedName,
                normalizedCategory,
                normalizedClassification,
                editingItem.item_id
            )
        ) {
            Swal.fire({
                icon: "warning",
                title: "Duplicate Item",
                text: `"${normalizedName}" already exists under "${normalizedCategory}" (${normalizedClassification}).`,
                confirmButtonColor: "#FF6F3C"
            })
            return
        }

        try {
            let finalImageUrl = itemFormData.item_img.trim() || null

            if (imageInputMode === 'upload' && itemImageFile) {
                setUploadingImage(true)
                finalImageUrl = await uploadMenuItemImage(itemImageFile)
                setUploadingImage(false)
            }

            const { error } = await supabase
                .from('menu_items')
                .update({
                    name: normalizedName,
                    item_price: parseFloat(itemFormData.item_price),
                    category: normalizedCategory,
                    classification: normalizedClassification,
                    description: itemFormData.description.trim(),
                    prep_time_minutes: parseInt(itemFormData.prep_time_minutes),
                    item_img: finalImageUrl
                })
                .eq('item_id', editingItem.item_id)

            if (error) throw error

            const { error: deleteBranchError } = await supabase
                .from('branch_menu_items')
                .delete()
                .eq('item_id', editingItem.item_id)

            if (deleteBranchError) throw deleteBranchError

            const branchRows = Array.from(selectedBranchIds).map((branch_id) => ({
                item_id: editingItem.item_id,
                branch_id
            }))

            const { error: insertBranchError } = await supabase
                .from('branch_menu_items')
                .insert(branchRows)

            if (insertBranchError) throw insertBranchError

            setShowEditItemModal(false)
            setEditingItem(null)
            resetItemForm()

            Swal.fire({
                icon: "success",
                title: "Item Updated!",
                text: `${normalizedName} has been updated`,
                confirmButtonColor: "#FF6F3C",
                timer: 3000
            })

            fetchMenuItems()
        } catch (err) {
            setUploadingImage(false)
            Swal.fire({
                icon: "error",
                title: "Failed to Update Item",
                text: err.message,
                confirmButtonColor: "#FF6F3C"
            })
        }
    }

    const handleArchiveItem = async (item) => {
        const result = await Swal.fire({
            title: "Archive Menu Item?",
            text: `Are you sure you want to archive ${item.name}? It will no longer appear in active menus.`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d97706",
            cancelButtonColor: "#6b7280",
            confirmButtonText: "Yes, archive",
            cancelButtonText: "Cancel"
        })

        if (!result.isConfirmed) return

        try {
            const { error } = await supabase
                .from('menu_items')
                .update({
                    is_archived: true,
                    archived_at: new Date().toISOString()
                })
                .eq('item_id', item.item_id)

            if (error) throw error

            Swal.fire({
                icon: "success",
                title: "Item Archived",
                text: `${item.name} has been archived.`,
                confirmButtonColor: "#FF6F3C",
                timer: 1800
            })

            fetchMenuItems()
        } catch (err) {
            Swal.fire({
                icon: 'error',
                title: "Failed to Archive",
                text: err.message,
                confirmButtonColor: "#FF6F3C"
            })
        }
    }

    const handleAddVariant = async () => {
        if (!variantFormData.category || !variantFormData.variant_name || variantFormData.price === "") {
            Swal.fire({
                icon: "warning",
                title: "Missing Information",
                text: "Please fill in all fields",
                confirmButtonColor: "#FF6F3C"
            })
            return
        }

        if (!validateVariantForm()) return

        const normalizedCategory = normalizeVariantCategory(variantFormData.category)
        const normalizedVariantName = normalizeVariantName(variantFormData.variant_name)

        if (isDuplicateVariant(normalizedCategory, normalizedVariantName)) {
            Swal.fire({
                icon: "warning",
                title: "Duplicate Variant",
                text: `The variant "${normalizedVariantName}" already exists under "${normalizedCategory}".`,
                confirmButtonColor: "#FF6F3C"
            })
            return
        }

        try {
            setSavingVariant(true)

            const { error } = await supabase
                .from('item_variants')
                .insert([{
                    category: normalizedCategory,
                    variant_name: normalizedVariantName,
                    price: parseFloat(variantFormData.price),
                    applicable_categories: variantFormData.applicable_categories
                }])

            if (error) throw error

            Swal.fire({
                icon: "success",
                title: "Variant Added!",
                text: "Variant has been added successfully",
                confirmButtonColor: "#FF6F3C",
                timer: 1800
            })

            setVariantFormData({
                category: "",
                variant_name: "",
                price: "",
                applicable_categories: []
            })

            setVariantCategorySearch("")
            setOpenVariantCategoryDropdown(false)
            setShowAddVariantModal(false)
            fetchVariants()

        } catch (err) {
            console.error("Error adding variant:", err)
            Swal.fire({
                icon: "error",
                title: "Failed to Add Variant",
                text: err.message,
                confirmButtonColor: "#FF6F3C"
            })
        } finally {
            setSavingVariant(false)
        }
    }

    const openAssignVariantsModal = async (item) => {
        setSelectedItemForVariants(item)
        setLoadingVariantAssignments(true)
        setShowAssignVariantsModal(true)

        try {
            await fetchVariants()

            const { data, error } = await supabase
                .from('menu_variants')
                .select('variant_id')
                .eq('item_id', item.item_id)

            if (error) throw error

            const variantSet = new Set((data || []).map(r => r.variant_id))
            setAssignedVariantIds(variantSet)
            setInitialAssignedVariantIds(new Set(variantSet))
        } catch (err) {
            console.error("Error fetching variant assignments:", err)
            Swal.fire({
                icon: 'error',
                title: 'Failed to load assignments',
                text: err.message,
                confirmButtonColor: '#FF6F3C'
            })
        } finally {
            setLoadingVariantAssignments(false)
        }
    }

    const closeAssignVariantsModal = () => {
        setShowAssignVariantsModal(false)
        setSelectedItemForVariants(null)
        setAssignedVariantIds(new Set())
        setInitialAssignedVariantIds(new Set())
        setAssignVariantCategoryFilter('All')
        setAssignVariantSearch('')
    }

    const toggleVariantAssignment = (variantId) => {
        setAssignedVariantIds(prev => {
            const next = new Set(prev)
            if (next.has(variantId)) {
                next.delete(variantId)
            } else {
                next.add(variantId)
            }
            return next
        })
    }

    const saveVariantAssignments = async () => {
        if (!hasAssignVariantChanges) return

        if (!selectedItemForVariants) return

        setSavingVariantAssignments(true)

        try {
            const { error: deleteError } = await supabase
                .from('menu_variants')
                .delete()
                .eq('item_id', selectedItemForVariants.item_id)

            if (deleteError) throw deleteError

            if (assignedVariantIds.size > 0) {
                const rows = Array.from(assignedVariantIds).map(variant_id => ({
                    item_id: selectedItemForVariants.item_id,
                    variant_id
                }))

                const { error: insertError } = await supabase
                    .from('menu_variants')
                    .insert(rows)

                if (insertError) throw insertError
            }

            closeAssignVariantsModal()

            Swal.fire({
                icon: 'success',
                title: 'Variants updated!',
                text: `Variants for ${selectedItemForVariants.name} have been saved`,
                confirmButtonColor: '#FF6F3C',
                timer: 2500
            })
        } catch (err) {
            console.error("Error saving variant assignments:", err)
            Swal.fire({
                icon: 'error',
                title: 'Failed to save',
                text: err.message,
                confirmButtonColor: '#FF6F3C'
            })
        } finally {
            setSavingVariantAssignments(false)
        }
    }

    const handleEditVariantClick = (variant) => {
        const normalizedCategory = normalizeVariantCategory(variant.category || "")
        const normalizedName = normalizeVariantName(variant.variant_name || "")

        const normalizedVariantData = {
            category: normalizedCategory,
            variant_name: normalizedName,
            price: String(variant.price ?? ""),
            applicable_categories: variant.applicable_categories || []
        }

        setEditingVariant(variant)
        setVariantFormData(normalizedVariantData)
        setInitialVariantFormData(normalizedVariantData)
        setVariantCategorySearch(normalizedCategory)
        setOpenVariantCategoryDropdown(false)
    }

    const handleUpdateVariant = async () => {
        if (!editingVariant) return

        if (!variantFormData.category || !variantFormData.variant_name || variantFormData.price === "") {
            Swal.fire({
                icon: "warning",
                title: "Missing Information",
                text: "Please fill in all fields",
                confirmButtonColor: "#FF6F3C"
            })
            return
        }

        if (!validateVariantForm()) return

        const normalizedCategory = normalizeVariantCategory(variantFormData.category)
        const normalizedVariantName = normalizeVariantName(variantFormData.variant_name)

        if (isDuplicateVariant(normalizedCategory, normalizedVariantName, editingVariant.variant_id)) {
            Swal.fire({
                icon: "warning",
                title: "Duplicate Variant",
                text: `The variant "${normalizedVariantName}" already exists under "${normalizedCategory}".`,
                confirmButtonColor: "#FF6F3C"
            })
            return
        }

        try {
            setSavingVariant(true)

            const { error } = await supabase
                .from('item_variants')
                .update({
                    category: normalizedCategory,
                    variant_name: normalizedVariantName,
                    price: parseFloat(variantFormData.price),
                    applicable_categories: variantFormData.applicable_categories
                })
                .eq('variant_id', editingVariant.variant_id)

            if (error) throw error

            Swal.fire({
                icon: "success",
                title: "Variant Updated!",
                text: `${normalizedVariantName} has been updated.`,
                confirmButtonColor: "#FF6F3C",
                timer: 1800
            })

            setEditingVariant(null)
            setVariantFormData({
                category: "",
                variant_name: "",
                price: "",
                applicable_categories: []
            })

            setVariantCategorySearch("")
            setOpenVariantCategoryDropdown(false)
            setShowEditVariantModal(false)
            setInitialVariantFormData(null)

            fetchVariants()
        } catch (err) {
            console.error("Error updating variant:", err)
            Swal.fire({
                icon: "error",
                title: "Failed to Update Variant",
                text: err.message,
                confirmButtonColor: "#FF6F3C"
            })
        } finally {
            setSavingVariant(false)
        }
    }

    const handleArchiveVariant = async (variant) => {
        const result = await Swal.fire({
            title: "Archive Variant?",
            text: `Are you sure you want to archive "${variant.variant_name}"? It will no longer be available for new assignments or orders.`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d97706",
            cancelButtonColor: "#6b7280",
            confirmButtonText: "Yes, archive",
            cancelButtonText: "Cancel"
        })

        if (!result.isConfirmed) return

        try {
            const { error } = await supabase
                .from('item_variants')
                .update({
                    is_archived: true,
                    archived_at: new Date().toISOString()
                })
                .eq('variant_id', variant.variant_id)

            if (error) throw error

            Swal.fire({
                icon: "success",
                title: "Variant Archived",
                text: `${variant.variant_name} has been archived.`,
                confirmButtonColor: "#FF6F3C",
                timer: 1800
            })

            fetchVariants()
        } catch (err) {
            console.error("Error archiving variant:", err)
            Swal.fire({
                icon: "error",
                title: "Failed to Archive Variant",
                text: err.message,
                confirmButtonColor: "#FF6F3C"
            })
        }
    }

    const handleAddModifier = async () => {
        if (!modifierFormData.modifier_name || !modifierFormData.category || modifierFormData.price === "") {
            Swal.fire({
                icon: "warning",
                title: "Missing Information",
                text: "Please fill in all fields",
                confirmButtonColor: "#FF6F3C"
            })
            return
        }

        if (!validateModifierForm()) return

        const normalizedModifierName = normalizeModifierName(modifierFormData.modifier_name)
        const normalizedCategory = normalizeModifierCategory(modifierFormData.category)

        if (isDuplicateModifier(normalizedModifierName, normalizedCategory)) {
            Swal.fire({
                icon: "warning",
                title: "Duplicate Modifier",
                text: `The modifier "${normalizedModifierName}" already exists under "${normalizedCategory}".`,
                confirmButtonColor: "#FF6F3C"
            })
            return
        }

        try {
            const { error } = await supabase
                .from('item_modifiers')
                .insert([{
                    modifier_name: normalizedModifierName,
                    category: normalizedCategory,
                    price: parseFloat(modifierFormData.price),
                    applicable_categories: modifierFormData.applicable_categories,
                    ingredient_id: modifierFormData.ingredient_id || null
                }])

            if (error) throw error

            setModifierFormData({
                modifier_name: "",
                category: "",
                price: "",
                applicable_categories: [],
                ingredient_id: ""
            })

            setShowAddModifierModal(false)
            setModifierIngredientSearch("")

            Swal.fire({
                icon: "success",
                title: "Modifier Added!",
                text: "Modifier has been added successfully",
                confirmButtonColor: "#FF6F3C",
                timer: 2000
            })

            fetchModifiers()

        } catch (err) {
            Swal.fire({
                icon: "error",
                title: "Failed to Add Modifier",
                text: err.message,
                confirmButtonColor: "#FF6F3C"
            })
        }
    }

    const handleEditModifierClick = (modifier) => {
        const normalizedModifier = {
            modifier_name: normalizeModifierName(modifier.modifier_name || ""),
            category: normalizeModifierCategory(modifier.category || ""),
            price: String(modifier.price ?? ""),
            applicable_categories: modifier.applicable_categories || [],
            ingredient_id: modifier.ingredient_id || ""
        }

        setEditingModifier(modifier)
        setModifierFormData(normalizedModifier)
        setInitialModifierFormData(normalizedModifier)

        const linkedIngredient = ingredients.find(
            ing => String(ing.ingredient_id) === String(modifier.ingredient_id || '')
        )
        setModifierIngredientSearch(linkedIngredient?.ingredient_name || linkedIngredient?.name || "")
        setOpenModifierIngredientDropdown(false)

        setShowEditModifierModal(true)
    }

    const handleUpdateModifier = async () => {
        if (!modifierFormData.modifier_name || !modifierFormData.category || modifierFormData.price === "") {
            Swal.fire({
                icon: "warning",
                title: "Missing Information",
                text: "Please fill in all fields",
                confirmButtonColor: "#FF6F3C"
            })
            return
        }

        if (!validateModifierForm()) return

        const normalizedModifierName = normalizeModifierName(modifierFormData.modifier_name)
        const normalizedCategory = normalizeModifierCategory(modifierFormData.category)

        if (isDuplicateModifier(normalizedModifierName, normalizedCategory, editingModifier.modifier_id)) {
            Swal.fire({
                icon: "warning",
                title: "Duplicate Modifier",
                text: `The modifier "${normalizedModifierName}" already exists under "${normalizedCategory}".`,
                confirmButtonColor: "#FF6F3C"
            })
            return
        }

        try {
            const { error } = await supabase
                .from('item_modifiers')
                .update({
                    modifier_name: normalizedModifierName,
                    category: normalizedCategory,
                    price: parseFloat(modifierFormData.price),
                    applicable_categories: modifierFormData.applicable_categories,
                    ingredient_id: modifierFormData.ingredient_id || null
                })
                .eq('modifier_id', editingModifier.modifier_id)

            if (error) throw error

            setShowEditModifierModal(false)
            setEditingModifier(null)
            setModifierIngredientSearch("")

            setModifierFormData({
                modifier_name: "",
                category: "",
                price: "",
                applicable_categories: [],
                ingredient_id: ""
            })

            Swal.fire({
                icon: "success",
                title: "Modifier Updated!",
                text: `${normalizedModifierName} has been updated`,
                confirmButtonColor: "#FF6F3C",
                timer: 3000
            })

            fetchModifiers()
        } catch (err) {
            Swal.fire({
                icon: "error",
                title: "Failed to Update Modifier",
                text: err.message,
                confirmButtonColor: "#FF6F3C"
            })
        }
    }

    const handleArchiveModifier = async (modifier) => {
        const result = await Swal.fire({
            title: "Archive Modifier?",
            text: `Are you sure you want to archive "${modifier.modifier_name}"?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d97706",
            cancelButtonColor: "#6b7280",
            confirmButtonText: "Yes, archive",
            cancelButtonText: "Cancel"
        })

        if (!result.isConfirmed) return

        try {
            const { error } = await supabase
                .from('item_modifiers')
                .update({
                    is_archived: true,
                    archived_at: new Date().toISOString()
                })
                .eq('modifier_id', modifier.modifier_id)

            if (error) throw error

            Swal.fire({
                icon: "success",
                title: "Modifier Archived",
                text: `"${modifier.modifier_name}" has been archived`,
                confirmButtonColor: "#FF6F3C",
                timer: 1800
            })

            fetchModifiers()
        } catch (err) {
            Swal.fire({
                icon: 'error',
                title: "Failed to Archive",
                text: err.message,
                confirmButtonColor: "#FF6F3C"
            })
        }
    }
    const handleEditRequestSubmit = async () => {
        if (!editRequestReason.trim()) {
            Swal.fire({ icon: 'warning', title: 'Reason Required', text: 'Please provide a reason for the update request.', confirmButtonColor: '#A0826D' })
            return
        }

        try {
            setSubmittingEditRequest(true)

            let itemId, itemName, changes

            if (editRequestType === 'variant') {
                itemId = String(editingVariant.variant_id)
                itemName = editingVariant.variant_name
                changes = JSON.stringify({
                    category: normalizeVariantCategory(variantFormData.category),
                    variant_name: normalizeVariantName(variantFormData.variant_name),
                    price: parseFloat(variantFormData.price),
                    applicable_categories: variantFormData.applicable_categories
                })
            } else {
                itemId = String(editingModifier.modifier_id)
                itemName = editingModifier.modifier_name
                changes = JSON.stringify({
                    modifier_name: normalizeModifierName(modifierFormData.modifier_name),
                    category: normalizeModifierCategory(modifierFormData.category),
                    price: parseFloat(modifierFormData.price),
                    applicable_categories: modifierFormData.applicable_categories,
                    ingredient_id: modifierFormData.ingredient_id || null
                })
            }

            const { error } = await supabase
                .from('admin_requests')
                .insert([{
                    request_type: 'edit',
                    item_type: editRequestType,
                    item_id: itemId,
                    item_name: itemName,
                    reason: editRequestReason.trim(),
                    changes,
                    status: 'pending',
                    created_at: new Date().toISOString()
                }])

            if (error) throw error

            setShowEditRequestModal(false)
            setEditRequestReason('')

            if (editRequestType === 'variant') {
                setShowEditVariantModal(false)
                setEditingVariant(null)
                setVariantFormData({ category: '', variant_name: '', price: '', applicable_categories: [] })
                setInitialVariantFormData(null)
            } else {
                setShowEditModifierModal(false)
                setEditingModifier(null)
                setModifierFormData({ modifier_name: '', category: '', price: '', applicable_categories: [], ingredient_id: '' })
                setInitialModifierFormData(null)
                setModifierIngredientSearch('')
            }

            Swal.fire({
                icon: 'success',
                title: 'Request Submitted!',
                text: `Your update request for "${itemName}" has been sent to Super Admin for approval.`,
                confirmButtonColor: '#A0826D',
                timer: 3000
            })
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Failed to Submit', text: err.message, confirmButtonColor: '#A0826D' })
        } finally {
            setSubmittingEditRequest(false)
        }
    }

    const handleAssignVariantRequestSubmit = async () => {
        if (!assignVariantRequestReason.trim()) {
            Swal.fire({ icon: 'warning', title: 'Reason Required', text: 'Please provide a reason for this request.', confirmButtonColor: '#A0826D' })
            return
        }

        try {
            setSubmittingAssignVariantRequest(true)

            const changes = JSON.stringify({
                item_id: selectedItemForVariants.item_id,
                assigned_variant_ids: Array.from(assignedVariantIds)
            })

            const { error } = await supabase
                .from('admin_requests')
                .insert([{
                    request_type: 'assign_variants',
                    item_type: 'menu',
                    item_id: String(selectedItemForVariants.item_id),
                    item_name: selectedItemForVariants.name,
                    reason: assignVariantRequestReason.trim(),
                    changes,
                    status: 'pending',
                    created_at: new Date().toISOString()
                }])

            if (error) throw error

            setShowAssignVariantRequestModal(false)
            setAssignVariantRequestReason('')
            closeAssignVariantsModal()

            Swal.fire({
                icon: 'success',
                title: 'Request Submitted!',
                text: `Variant assignment request for "${selectedItemForVariants.name}" sent to Super Admin.`,
                confirmButtonColor: '#A0826D',
                timer: 3000
            })
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Failed to Submit', text: err.message, confirmButtonColor: '#A0826D' })
        } finally {
            setSubmittingAssignVariantRequest(false)
        }
    }

    const handleAssignModifierRequestSubmit = async () => {
        if (!assignModifierRequestReason.trim()) {
            Swal.fire({ icon: 'warning', title: 'Reason Required', text: 'Please provide a reason for this request.', confirmButtonColor: '#A0826D' })
            return
        }

        try {
            setSubmittingAssignModifierRequest(true)

            const changes = JSON.stringify({
                item_id: selectedItemForModifiers.item_id,
                assigned_modifier_ids: Array.from(assignedModifierIds)
            })

            const { error } = await supabase
                .from('admin_requests')
                .insert([{
                    request_type: 'assign_modifiers',
                    item_type: 'menu',
                    item_id: String(selectedItemForModifiers.item_id),
                    item_name: selectedItemForModifiers.name,
                    reason: assignModifierRequestReason.trim(),
                    changes,
                    status: 'pending',
                    created_at: new Date().toISOString()
                }])

            if (error) throw error

            setShowAssignModifierRequestModal(false)
            setAssignModifierRequestReason('')
            closeAssignModifiersModal()

            Swal.fire({
                icon: 'success',
                title: 'Request Submitted!',
                text: `Modifier assignment request for "${selectedItemForModifiers.name}" sent to Super Admin.`,
                confirmButtonColor: '#A0826D',
                timer: 3000
            })
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Failed to Submit', text: err.message, confirmButtonColor: '#A0826D' })
        } finally {
            setSubmittingAssignModifierRequest(false)
        }
    }

    const handleVariantRuleRequestSubmit = async () => {
        if (!variantRuleRequestReason.trim()) {
            Swal.fire({ icon: 'warning', title: 'Reason Required', text: 'Please provide a reason for this request.', confirmButtonColor: '#A0826D' })
            return
        }

        try {
            setSubmittingVariantRuleRequest(true)

            let requestType, changes, itemName

            if (pendingVariantRuleAction === 'delete') {
                requestType = 'variant_rule_delete'
                itemName = getVariantLabelById(pendingVariantRuleId)
                changes = JSON.stringify({ rule_id: pendingVariantRuleId })
            } else if (pendingVariantRuleAction === 'update') {
                requestType = 'variant_rule_update'
                const selectedIngredient = ingredients.find(ing => String(ing.ingredient_id) === String(variantRuleFormData.ingredient_id))
                itemName = getVariantLabelById(variantRuleFormData.variant_id)
                changes = JSON.stringify({
                    rule_id: variantRuleFormData.id,
                    item_id: selectedItemForVariantRules.item_id,
                    variant_id: variantRuleFormData.variant_id,
                    ingredient_id: variantRuleFormData.ingredient_id,
                    quantity_delta: parseFloat(variantRuleFormData.quantity_delta),
                    unit: String(selectedIngredient?.unit || '').trim(),
                    notes: variantRuleFormData.notes.trim() || null
                })
            } else {
                requestType = 'variant_rule_add'
                const selectedIngredient = ingredients.find(ing => String(ing.ingredient_id) === String(variantRuleFormData.ingredient_id))
                itemName = getVariantLabelById(variantRuleFormData.variant_id)
                changes = JSON.stringify({
                    item_id: selectedItemForVariantRules.item_id,
                    variant_id: variantRuleFormData.variant_id,
                    ingredient_id: variantRuleFormData.ingredient_id,
                    quantity_delta: parseFloat(variantRuleFormData.quantity_delta),
                    unit: String(selectedIngredient?.unit || '').trim(),
                    notes: variantRuleFormData.notes.trim() || null
                })
            }

            const { error } = await supabase
                .from('admin_requests')
                .insert([{
                    request_type: requestType,
                    item_type: 'variant_rule',
                    item_id: String(selectedItemForVariantRules.item_id),
                    item_name: itemName,
                    reason: variantRuleRequestReason.trim(),
                    changes,
                    status: 'pending',
                    created_at: new Date().toISOString()
                }])

            if (error) throw error

            setShowVariantRuleRequestModal(false)
            setVariantRuleRequestReason('')
            setPendingVariantRuleAction(null)
            setPendingVariantRuleId(null)

            if (pendingVariantRuleAction !== 'delete') {
                resetVariantRuleForm()
            }

            Swal.fire({
                icon: 'success',
                title: 'Request Submitted!',
                text: `Variant rule ${pendingVariantRuleAction} request sent to Super Admin for approval.`,
                confirmButtonColor: '#A0826D',
                timer: 3000
            })
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Failed to Submit', text: err.message, confirmButtonColor: '#A0826D' })
        } finally {
            setSubmittingVariantRuleRequest(false)
        }
    }

    const handleDeleteRequest = (item, type) => {
        setDeleteRequestItem(item)
        setDeleteRequestType(type)
        setDeleteRequestReason('')
        setShowDeleteRequestModal(true)
    }

    const handleSubmitDeleteRequest = async () => {
        if (!deleteRequestReason.trim()) {
            Swal.fire({
                icon: 'warning',
                title: 'Reason Required',
                text: 'Please provide a reason for the deletion request.',
                confirmButtonColor: '#A0826D'
            })
            return
        }

        try {
            setSubmittingDeleteRequest(true)

            const itemName =
                deleteRequestType === 'menu' ? deleteRequestItem.name :
                    deleteRequestType === 'variant' ? deleteRequestItem.variant_name :
                        deleteRequestItem.modifier_name

            const itemId =
                deleteRequestType === 'menu' ? deleteRequestItem.item_id :
                    deleteRequestType === 'variant' ? deleteRequestItem.variant_id :
                        deleteRequestItem.modifier_id

            const { error } = await supabase
                .from('admin_requests')
                .insert([{
                    request_type: 'delete',
                    item_type: deleteRequestType,
                    item_id: String(itemId),
                    item_name: itemName,
                    reason: deleteRequestReason.trim(),
                    branch_id: currentBranchId,
                    status: 'pending',
                    created_at: new Date().toISOString()
                }])

            if (error) throw error

            setShowDeleteRequestModal(false)
            setDeleteRequestItem(null)
            setDeleteRequestReason('')

            Swal.fire({
                icon: 'success',
                title: 'Request Submitted!',
                text: `Your deletion request for "${itemName}" has been sent to the Super Admin for approval.`,
                confirmButtonColor: '#A0826D',
                timer: 3000
            })
        } catch (err) {
            console.error('Error submitting delete request:', err)
            Swal.fire({
                icon: 'error',
                title: 'Failed to Submit Request',
                text: err.message,
                confirmButtonColor: '#A0826D'
            })
        } finally {
            setSubmittingDeleteRequest(false)
        }
    }

    const handlePriceChangeRequest = (item, type) => {
        setPriceChangeRequestItem(item)
        setPriceChangeRequestType(type)
        setPriceChangeRequestedPrice('')
        setPriceChangeRequestReason('')
        setShowPriceChangeRequestModal(true)
    }

    const handleSubmitPriceChangeRequest = async () => {
        if (!priceChangeRequestedPrice || isNaN(parseFloat(priceChangeRequestedPrice))) {
            Swal.fire({ icon: 'warning', title: 'Invalid Price', text: 'Please enter a valid price.', confirmButtonColor: '#FF6F3C' })
            return
        }

        const newPrice = parseFloat(priceChangeRequestedPrice)

        if (newPrice <= 0) {
            Swal.fire({ icon: 'warning', title: 'Invalid Price', text: 'Price must be greater than 0.', confirmButtonColor: '#FF6F3C' })
            return
        }

        const currentPrice =
            priceChangeRequestType === 'menu_item'
                ? (priceChangeRequestItem?.has_price_override
                    ? priceChangeRequestItem?.branch_price
                    : priceChangeRequestItem?.master_price ?? priceChangeRequestItem?.item_price)
                : priceChangeRequestItem?.price

        if (newPrice === parseFloat(currentPrice)) {
            Swal.fire({ icon: 'warning', title: 'No Change', text: 'The requested price is the same as the current price.', confirmButtonColor: '#FF6F3C' })
            return
        }

        if (!priceChangeRequestReason.trim()) {
            Swal.fire({ icon: 'warning', title: 'Reason Required', text: 'Please provide a reason for this price change.', confirmButtonColor: '#FF6F3C' })
            return
        }

        try {
            setSubmittingPriceChangeRequest(true)

            let resolvedStaffId = currentStaffId
            let resolvedBranchId = currentBranchId

            if (!resolvedStaffId || !resolvedBranchId) {
                const sessionStaffId = getAuthItem('staffId')
                if (sessionStaffId) {
                    const { data: accountData } = await supabase
                        .from('staff_accounts')
                        .select('staff_id')
                        .eq('id', sessionStaffId)
                        .single()

                    if (accountData?.staff_id) {
                        const { data: staffData } = await supabase
                            .from('staff')
                            .select('id, branch_id')
                            .eq('id', accountData.staff_id)
                            .single()

                        if (staffData) {
                            resolvedStaffId = staffData.id
                            resolvedBranchId = staffData.branch_id
                            setCurrentStaffId(staffData.id)
                            setCurrentBranchId(staffData.branch_id)
                        }
                    }
                }
            }

            const itemId =
                priceChangeRequestType === 'menu_item' ? priceChangeRequestItem?.item_id :
                    priceChangeRequestType === 'variant' ? priceChangeRequestItem?.variant_id :
                        priceChangeRequestItem?.modifier_id

            const itemName =
                priceChangeRequestType === 'menu_item' ? priceChangeRequestItem?.name :
                    priceChangeRequestType === 'variant' ? priceChangeRequestItem?.variant_name :
                        priceChangeRequestItem?.modifier_name

            // Block if a pending request already exists for this item from this branch
            const { data: existingRequests, error: existingError } = await supabase
                .from('menu_price_change_requests')
                .select('id')
                .eq('item_id', String(itemId))
                .eq('item_type', priceChangeRequestType)
                .eq('branch_id', resolvedBranchId)
                .eq('status', 'pending')
                .limit(1)

            if (existingError) throw existingError

            if (existingRequests && existingRequests.length > 0) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Request Already Pending',
                    text: `A pending price change request for "${itemName}" already exists. Please wait for it to be reviewed before submitting another.`,
                    confirmButtonColor: '#FF6F3C'
                })
                setSubmittingPriceChangeRequest(false)
                return
            }

            const { error } = await supabase
                .from('menu_price_change_requests')
                .insert([{
                    item_type: priceChangeRequestType,
                    item_id: String(itemId),
                    item_name: itemName,
                    current_price: parseFloat(currentPrice),
                    requested_price: newPrice,
                    reason: priceChangeRequestReason.trim(),
                    status: 'pending',
                    branch_id: resolvedBranchId,
                    requested_by_staff_id: resolvedStaffId
                }])

            if (error) throw error

            setShowPriceChangeRequestModal(false)
            setPriceChangeRequestItem(null)
            setPriceChangeRequestedPrice('')
            setPriceChangeRequestReason('')

            Swal.fire({
                icon: 'success',
                title: 'Request Submitted!',
                text: `Price change request for "${itemName}" has been sent to Super Admin for approval.`,
                confirmButtonColor: '#FF6F3C',
                timer: 3000
            })
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Failed to Submit', text: err.message, confirmButtonColor: '#FF6F3C' })
        } finally {
            setSubmittingPriceChangeRequest(false)
        }
    }

    const formatBranchName = (name) =>
        name?.replace("Coffee Gus·to ", "") || ""

    const normalizeItemFormData = (data = {}) => ({
        name: String(data.name || '').trim(),
        item_price: String(data.item_price || '').trim(),
        category: String(data.category || '').trim(),
        classification: String(data.classification || '').trim(),
        description: String(data.description || '').trim(),
        item_img: String(data.item_img || '').trim()
    })

    const toTitleCase = (value = "") => {
        return String(value)
            .trim()
            .toLowerCase()
            .split(/\s+/)
            .filter(Boolean)
            .map(word =>
                word
                    .split('-')
                    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
                    .join('-')
            )
            .join(" ")
    }

    const normalizeItemName = (value = "") => {
        return toTitleCase(value)
    }

    const normalizeItemCategory = (value = "") => {
        return toTitleCase(value)
    }

    const normalizeItemClassification = (value = "") => {
        return toTitleCase(value)
    }

    const normalizeModifierCategory = (value = "") => {
        return toTitleCase(value)
    }

    const normalizeModifierName = (value = "") => {
        return toTitleCase(value)
    }

    const normalizeVariantCategory = (value = "") => {
        return toTitleCase(value)
    }

    const normalizeVariantName = (value = "") => {
        return toTitleCase(value)
    }

    const normalizeVariantFormData = (data = {}) => ({
        category: String(data.category || '').trim(),
        variant_name: String(data.variant_name || '').trim(),
        price: String(data.price || '').trim(),
        applicable_categories: [...(data.applicable_categories || [])].sort()
    })

    const normalizeVariantRuleFormData = (data = {}) => ({
        id: data.id ?? null,
        variant_id: String(data.variant_id || '').trim(),
        ingredient_id: String(data.ingredient_id || '').trim(),
        quantity_delta: String(data.quantity_delta || '').trim(),
        unit: String(data.unit || '').trim(),
        notes: String(data.notes || '').trim()
    })

    const areSetsEqual = (setA = new Set(), setB = new Set()) => {
        if (setA.size !== setB.size) return false
        for (const value of setA) {
            if (!setB.has(value)) return false
        }
        return true
    }

    const normalizeModifierFormData = (data = {}) => ({
        modifier_name: String(data.modifier_name || '').trim(),
        category: String(data.category || '').trim(),
        price: String(data.price || '').trim(),
        applicable_categories: [...(data.applicable_categories || [])].sort(),
        ingredient_id: String(data.ingredient_id || '').trim()
    })

    const hasAddItemChanges =
        JSON.stringify(normalizeItemFormData(itemFormData)) !==
        JSON.stringify(normalizeItemFormData({
            name: '',
            item_price: '',
            category: '',
            classification: '',
            description: '',
            item_img: ''
        })) ||
        selectedBranchIds.size > 0 ||
        itemImageFile !== null ||
        imageInputMode !== 'upload'

    const hasEditItemChanges =
        initialItemFormData !== null &&
        (
            JSON.stringify(normalizeItemFormData(itemFormData)) !==
            JSON.stringify(normalizeItemFormData(initialItemFormData)) ||
            !areSetsEqual(selectedBranchIds, initialSelectedBranchIds) ||
            itemImageFile !== null ||
            (initialItemFormData?.item_img ? imageInputMode !== 'url' : imageInputMode !== 'upload')
        )

    const hasAssignVariantChanges =
        !areSetsEqual(assignedVariantIds, initialAssignedVariantIds)

    const hasAddVariantChanges =
        JSON.stringify(normalizeVariantFormData(variantFormData)) !==
        JSON.stringify(normalizeVariantFormData({
            category: '',
            variant_name: '',
            price: ''
        }))

    const hasEditVariantChanges =
        initialVariantFormData !== null &&
        JSON.stringify(normalizeVariantFormData(variantFormData)) !==
        JSON.stringify(normalizeVariantFormData(initialVariantFormData))

    const hasVariantRuleChanges =
        JSON.stringify(normalizeVariantRuleFormData(variantRuleFormData)) !==
        JSON.stringify(normalizeVariantRuleFormData(initialVariantRuleFormData || {
            id: null,
            variant_id: '',
            ingredient_id: '',
            quantity_delta: '',
            unit: '',
            notes: ''
        }))

    const hasAddModifierChanges =
        JSON.stringify(normalizeModifierFormData(modifierFormData)) !==
        JSON.stringify(normalizeModifierFormData({
            modifier_name: '',
            category: '',
            price: '',
            ingredient_id: ''
        }))

    const hasEditModifierChanges =
        initialModifierFormData !== null &&
        JSON.stringify(normalizeModifierFormData(modifierFormData)) !==
        JSON.stringify(normalizeModifierFormData(initialModifierFormData))

    const hasModifierAssignmentChanges =
        !areSetsEqual(assignedModifierIds, initialAssignedModifierIds)

    // === Helpers ───────────────────────────────────────────────────────────────

    const filteredItems = [...menuItems]
        .filter(item => {
            const matchesSearch = item.name?.toLowerCase().includes(searchQuery.toLowerCase())
            const matchesCategory = filterCategory === "All" || item.category === filterCategory
            const matchesClassification = filterClassification === "All" || item.classification === filterClassification
            return matchesSearch && matchesCategory && matchesClassification
        })
        .sort((a, b) => (a.name || '').localeCompare(b.name || ''))

    const totalItemsInSelectedCategory = filterCategory === "All"
        ? menuItems.length
        : menuItems.filter(item => item.category === filterCategory).length

    const filteredVariantOptions = useMemo(() => {
        const query = variantRuleVariantSearch.toLowerCase()

        return [...itemVariants]
            .filter((variant) => {
                return (
                    String(variant.variant_name || '').toLowerCase().includes(query) ||
                    String(variant.category || '').toLowerCase().includes(query)
                )
            })
            .sort((a, b) => {
                const categoryCompare = String(a.category || '').localeCompare(String(b.category || ''))
                if (categoryCompare !== 0) return categoryCompare
                return String(a.variant_name || '').localeCompare(String(b.variant_name || ''))
            })
    }, [itemVariants, variantRuleVariantSearch])

    const filteredIngredientOptions = useMemo(() => {
        const query = variantRuleIngredientSearch.toLowerCase()

        return [...ingredients]
            .filter((ingredient) => {
                return (
                    String(ingredient.ingredient_name || ingredient.name || '').toLowerCase().includes(query) ||
                    String(ingredient.unit || '').toLowerCase().includes(query) ||
                    String(ingredient.category || '').toLowerCase().includes(query)
                )
            })
            .sort((a, b) =>
                String(a.ingredient_name || a.name || '').localeCompare(String(b.ingredient_name || b.name || ''))
            )
    }, [ingredients, variantRuleIngredientSearch])

    const getVariantLabelById = (variantId) => {
        const variant = itemVariants.find(
            (v) => String(v.variant_id) === String(variantId)
        )

        if (!variant) return '—'

        return `${variant.category ? `${variant.category} - ` : ''}${variant.variant_name || ''}`
    }

    const getIngredientLabelById = (ingredientId) => {
        const ingredient = ingredients.find(
            (ing) => String(ing.ingredient_id) === String(ingredientId)
        )

        return ingredient?.ingredient_name || ingredient?.name || '—'
    }

    const filteredModifiers = [...modifiers]
        .filter(modifier => {
            const matchesSearch = modifier.modifier_name?.toLowerCase().includes(modifierSearchQuery.toLowerCase())
            const matchesCategory = filterModifierCategory === "All" || modifier.category === filterModifierCategory
            return matchesSearch && matchesCategory
        })
        .sort((a, b) => (a.modifier_name || '').localeCompare(b.modifier_name || ''))

    const modifiersByCategory = Object.fromEntries(
        Object.entries(
            modifiers.reduce((acc, mod) => {
                if (!acc[mod.category]) acc[mod.category] = []
                acc[mod.category].push(mod)
                return acc
            }, {})
        )
            .sort(([categoryA], [categoryB]) => categoryA.localeCompare(categoryB))
            .map(([category, mods]) => [
                category,
                [...mods].sort((a, b) =>
                    (a.modifier_name || '').localeCompare(b.modifier_name || '')
                )
            ])
    )

    const handlePriceKeyDown = (e) => {
        // Allow backspace, delete, tab, escape, enter, decimal point
        const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', '.']
        if (allowedKeys.includes(e.key)) return
        // Block if not a digit
        if (!/^\d$/.test(e.key)) e.preventDefault()
    }

    const resetItemForm = () => {
        setItemFormData({
            name: '',
            item_price: '',
            category: '',
            classification: '',
            description: '',
            prep_time_minutes: '',
            item_img: ''
        })
        setSelectedBranchIds(new Set())
        setItemImageFile(null)
        setImageInputMode('upload')
        setItemCategorySearch('')
        setItemClassificationSearch('')
        setOpenItemCategoryDropdown(false)
        setOpenItemClassificationDropdown(false)
    }

    const confirmDiscardChanges = async (hasChanges, onConfirm) => {
        if (!hasChanges) {
            onConfirm()
            return
        }
        const result = await Swal.fire({
            title: 'Discard changes?',
            text: 'You have unsaved changes. Are you sure you want to close?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d97706',
            cancelButtonColor: '#6b7280',
            confirmButtonText: 'Yes, discard',
            cancelButtonText: 'Keep editing'
        })
        if (result.isConfirmed) onConfirm()
    }

    const getCategoryBadgeStyle = (category) => {
        switch (category) {
            case 'Add-ons': return 'bg-blue-100 text-blue-800'
            case 'Toppings': return 'bg-yellow-100 text-yellow-800'
            case 'Sinkers': return 'bg-orange-100 text-orange-800'
            default: return 'bg-gray-100 text-gray-800'
        }
    }

    const existingItemCategories = useMemo(() => {
        const normalized = menuItems
            .map((item) => normalizeItemCategory(item.category))
            .filter(Boolean)

        return [...new Set(normalized)].sort((a, b) => a.localeCompare(b))
    }, [menuItems])

    const currentBranchName = useMemo(() => {
        const branch = branches.find(b => b.branch_id === currentBranchId)
        return branch ? formatBranchName(branch.name) : ''
    }, [branches, currentBranchId])

    const filteredItemCategoryOptions = useMemo(() => {
        const query = String(itemCategorySearch || '').trim().toLowerCase()

        return existingItemCategories.filter((category) =>
            String(category || '').toLowerCase().includes(query)
        )
    }, [existingItemCategories, itemCategorySearch])

    const existingItemClassifications = useMemo(() => {
        const normalized = menuItems
            .map((item) => normalizeItemClassification(item.classification))
            .filter(Boolean)

        return [...new Set(normalized)].sort((a, b) => a.localeCompare(b))
    }, [menuItems])

    const filteredItemClassificationOptions = useMemo(() => {
        const query = String(itemClassificationSearch || '').trim().toLowerCase()

        return existingItemClassifications.filter((classification) =>
            String(classification || '').toLowerCase().includes(query)
        )
    }, [existingItemClassifications, itemClassificationSearch])

    const existingVariantCategories = useMemo(() => {
        const normalized = variants
            .map((variant) => normalizeVariantCategory(variant.category))
            .filter(Boolean)

        return [...new Set(normalized)].sort((a, b) => a.localeCompare(b))
    }, [variants])

    const filteredVariantCategoryOptions = useMemo(() => {
        const query = String(variantCategorySearch || '').trim().toLowerCase()

        return existingVariantCategories.filter((category) =>
            String(category || '').toLowerCase().includes(query)
        )
    }, [existingVariantCategories, variantCategorySearch])

    const existingModifierCategories = useMemo(() => {
        const normalized = modifiers
            .map((mod) => normalizeModifierCategory(mod.category))
            .filter(Boolean)
        return [...new Set(normalized)].sort((a, b) => a.localeCompare(b))
    }, [modifiers])

    const filteredModifierCategoryOptions = useMemo(() => {
        const query = String(modifierCategorySearch || '').trim().toLowerCase()
        return existingModifierCategories.filter((category) =>
            String(category || '').toLowerCase().includes(query)
        )
    }, [existingModifierCategories, modifierCategorySearch])

    // Branch menu computed values
    const itemBranchMap = useMemo(() => {
        const map = {}
        allBranchMenuItems.forEach(item => {
            if (!map[item.item_id]) map[item.item_id] = new Set()
            map[item.item_id].add(item.branch_id)
        })
        return map
    }, [allBranchMenuItems])

    const totalBranchCount = branches.length

    const uniqueItemsList = useMemo(() => {
        return Object.keys(itemBranchMap)
            .map(itemId => {
                const item = allBranchMenuItems.find(i => i.item_id === itemId)
                const branchCount = itemBranchMap[itemId].size
                return {
                    item_id: itemId,
                    name: item?.name || 'Unknown',
                    category: item?.category || '—',
                    classification: item?.classification || '—',
                    item_img: item?.item_img || null,
                    branchCount,
                    isInAllBranches: branchCount >= totalBranchCount
                }
            })
            // Only keep items NOT catered by every active branch
            .filter(item => !item.isInAllBranches)
    }, [itemBranchMap, allBranchMenuItems, totalBranchCount])

    const menuSummary = useMemo(() => {
        const relevantItemIds = selectedBranchForMenu === 'all'
            ? new Set(menuItems.map(i => i.item_id))
            : new Set(
                allBranchMenuItems
                    .filter(i => i.branch_id === selectedBranchForMenu)
                    .map(i => i.item_id)
            )

        const sourceItems = menuItems.filter(item => relevantItemIds.has(item.item_id))

        const drinkKeywords = ['coffee', 'tea', 'beverage', 'drink', 'juice', 'shake', 'smoothie']
        const foodKeywords = ['food', 'pastry', 'snack', 'meal', 'dessert', 'bread', 'sandwich']

        const coffeeSet = new Set()
        const foodSet = new Set()
        const otherSet = new Set()

        sourceItems.forEach(item => {
            const cat = String(item.category || '').toLowerCase()
            const cls = String(item.classification || '').toLowerCase()
            const isDrink = drinkKeywords.some(k => cat.includes(k) || cls.includes(k))
            const isFood = foodKeywords.some(k => cat.includes(k) || cls.includes(k))
            if (isDrink) coffeeSet.add(item.item_id)
            if (isFood) foodSet.add(item.item_id)
            if (!isDrink && !isFood) otherSet.add(item.item_id)
        })

        const totalCategories = new Set(sourceItems.map(i => i.category).filter(Boolean)).size
        const totalClassifications = new Set(sourceItems.map(i => i.classification).filter(Boolean)).size

        const assignmentSourceItems = selectedBranchForMenu === 'all'
            ? allBranchMenuItems
            : allBranchMenuItems.filter(i => i.branch_id === selectedBranchForMenu)

        return {
            totalAssignments: assignmentSourceItems.length,
            uniqueItems: sourceItems.length,
            coffeeItems: coffeeSet.size,
            foodItems: foodSet.size,
            otherItems: otherSet.size,
            totalCategories,
            totalClassifications,
        }
    }, [menuItems, allBranchMenuItems, selectedBranchForMenu])

    const branchBreakdown = useMemo(() => {
        const grouped = {}
        allBranchMenuItems.forEach(item => {
            if (!grouped[item.branch_id]) {
                grouped[item.branch_id] = {
                    branch_id: item.branch_id,
                    branch_name: item.branch_name,
                    itemSet: new Set(),
                    coffeeSet: new Set(),
                    foodSet: new Set(),
                }
            }
            grouped[item.branch_id].itemSet.add(item.item_id)
            if (String(item.category).toLowerCase().includes('coffee')) {
                grouped[item.branch_id].coffeeSet.add(item.item_id)
            }
            const category = String(item.category).toLowerCase()
            const classification = String(item.classification).toLowerCase()
            if (
                classification.includes('food') || category.includes('food') ||
                category.includes('pastry') || category.includes('snack') ||
                category.includes('meal') || category.includes('dessert')
            ) {
                grouped[item.branch_id].foodSet.add(item.item_id)
            }
        })
        return Object.values(grouped).map(branch => ({
            branch_id: branch.branch_id,
            branch_name: branch.branch_name,
            totalItems: branch.itemSet.size,
            coffeeItems: branch.coffeeSet.size,
            foodItems: branch.foodSet.size,
        })).sort((a, b) => a.branch_name.localeCompare(b.branch_name))
    }, [allBranchMenuItems])

    const filteredBranchMenuItems = [...branchMenuItems]
        .filter(item => item.branch_id === currentBranchId)
        .filter(item => {
            const query = menuItemSearch.toLowerCase()
            return (
                String(item.name || '').toLowerCase().includes(query) ||
                String(item.category || '').toLowerCase().includes(query) ||
                String(item.classification || '').toLowerCase().includes(query) ||
                String(item.branch_name || '').toLowerCase().includes(query)
            )
        })
        .sort((a, b) => a.name.localeCompare(b.name))

    const totalMenuOverviewPages = Math.ceil(filteredBranchMenuItems.length / MENU_PAGE_SIZE)

    const paginatedBranchMenuItems = filteredBranchMenuItems.slice(
        (menuOverviewPage - 1) * MENU_PAGE_SIZE,
        menuOverviewPage * MENU_PAGE_SIZE
    )

    const VariantRuleGroups = ({ groupEntries, getVariantLabelById, getIngredientLabelById, handleEditVariantRule, query, onRequestDelete }) => {
        const [collapsedGroups, setCollapsedGroups] = useState({})

        const toggleGroup = (variantId) => {
            setCollapsedGroups(prev => ({ ...prev, [variantId]: !prev[variantId] }))
        }

        return (
            <div className="divide-y divide-gray-100">
                {groupEntries.map(([variantId, rules]) => {
                    const isCollapsed = collapsedGroups[variantId]
                    const variantLabel = getVariantLabelById(variantId)

                    const visibleRules = query
                        ? rules.filter(r =>
                            getVariantLabelById(r.variant_id).toLowerCase().includes(query) ||
                            getIngredientLabelById(r.ingredient_id).toLowerCase().includes(query) ||
                            String(r.notes || '').toLowerCase().includes(query)
                        )
                        : rules

                    return (
                        <div key={variantId}>
                            {/* Group header */}
                            <button
                                type="button"
                                onClick={() => toggleGroup(variantId)}
                                className="w-full flex items-center justify-between px-4 py-3 bg-gray-50 hover:bg-gray-100 transition-colors text-left"
                            >
                                <div className="flex items-center gap-2">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" strokeWidth="2"
                                        className={`text-gray-400 transition-transform duration-150 flex-shrink-0 ${isCollapsed ? '-rotate-90' : ''}`}
                                    >
                                        <path d="M6 9l6 6 6-6" />
                                    </svg>
                                    <span className="text-sm font-semibold text-gray-800">{variantLabel}</span>
                                    <span className="px-1.5 py-0.5 rounded-full text-[10px] font-bold bg-[#FF6F3C]/10 text-[#FF6F3C]">
                                        {visibleRules.length} rule{visibleRules.length !== 1 ? 's' : ''}
                                    </span>
                                </div>
                            </button>

                            {/* Group rows */}
                            {!isCollapsed && (
                                <div>
                                    {/* Column headers */}
                                    <div className="grid grid-cols-12 gap-2 px-4 py-2 bg-white border-b border-gray-100 text-xs font-medium text-gray-400 uppercase tracking-wider">
                                        <div className="col-span-4">Ingredient</div>
                                        <div className="col-span-2">Qty</div>
                                        <div className="col-span-2">Unit</div>
                                        <div className="col-span-2">Notes</div>
                                        <div className="col-span-2 text-right">Actions</div>
                                    </div>
                                    {visibleRules.map((rule) => (
                                        <div
                                            key={rule.id}
                                            className="grid grid-cols-12 gap-2 px-4 py-3 items-center border-b border-gray-50 last:border-b-0 hover:bg-gray-50 transition-colors"
                                        >
                                            <div className="col-span-4 text-sm text-gray-800">
                                                {getIngredientLabelById(rule.ingredient_id)}
                                            </div>
                                            <div className="col-span-2 text-sm text-gray-800">
                                                {parseFloat(rule.quantity_delta).toFixed(2)}
                                            </div>
                                            <div className="col-span-2 text-sm text-gray-600">
                                                {rule.unit || '—'}
                                            </div>
                                            <div className="col-span-2 text-sm text-gray-400 truncate" title={rule.notes || ''}>
                                                {rule.notes || '—'}
                                            </div>
                                            <div className="col-span-2 flex items-center justify-end gap-2">
                                                <button
                                                    onClick={() => handleEditVariantRule(rule)}
                                                    className="p-1 text-blue-600 hover:bg-blue-50 rounded"
                                                    title="Edit rule"
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                                                        <path fill="currentColor" d="m14.06 9l.94.94L5.92 19H5v-.92zm3.6-6c-.25 0-.51.1-.7.29l-1.83 1.83l3.75 3.75l1.83-1.83c.39-.39.39-1.04 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29m-3.6 3.19L3 17.25V21h3.75L17.81 9.94z" />
                                                    </svg>
                                                </button>
                                                {/* <button
                                                    onClick={() => onRequestDelete(rule)}
                                                    className="p-1 text-red-600 hover:bg-red-50 rounded"
                                                    title="Request Delete"
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                                                        <path fill="currentColor" d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zM17 6H7v13h10zM9 17h2V8H9zm4 0h2V8h-2z" />
                                                    </svg>
                                                </button> */}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    )
                })}
            </div>
        )
    }

    const ApplicableCategoriesSelector = ({ value, onChange }) => {
        return (
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Applicable Item Categories
                    <span className="ml-1 text-xs font-normal text-gray-500">(check each category this applies to)</span>
                </label>
                {existingItemCategories.length === 0 ? (
                    <p className="text-sm text-gray-500 italic">No item categories found. Add menu items first.</p>
                ) : (
                    <div className="grid grid-cols-2 gap-2 border border-gray-200 rounded-lg p-3 max-h-40 overflow-y-auto">
                        {existingItemCategories.map(cat => {
                            const checked = value.includes(cat)
                            return (
                                <label
                                    key={cat}
                                    className={`flex items-center gap-2 p-2 rounded cursor-pointer border text-sm ${checked ? 'bg-indigo-50 border-indigo-300' : 'border-gray-200 hover:bg-gray-50'
                                        }`}
                                >
                                    <input
                                        type="checkbox"
                                        checked={checked}
                                        onChange={() => {
                                            if (checked) {
                                                onChange(value.filter(c => c !== cat))
                                            } else {
                                                onChange([...value, cat])
                                            }
                                        }}
                                        className="accent-indigo-600"
                                    />
                                    <span className={checked ? 'text-indigo-800 font-medium' : 'text-gray-700'}>{cat}</span>
                                </label>
                            )
                        })}
                    </div>
                )}
                <p className="text-xs text-gray-500 mt-1">
                    {value.length === 0
                        ? 'No categories selected — this will not appear in any assign modal.'
                        : `${value.length} categor${value.length === 1 ? 'y' : 'ies'} selected`}
                </p>
            </div>
        )
    }

    // ─── Pagination  ─────────────────────────────────────────────
    function Pagination({ page, totalItems, pageSize, onPageChange }) {
        const totalPages = Math.ceil(totalItems / pageSize)
        if (totalPages <= 1) return null

        return (
            <div className="flex flex-col sm:flex-row items-center justify-between gap-2 px-4 py-3 rounded-b-xl">
                <span style={{ fontSize: 13, color: C.midgrey }} className="text-center sm:text-left">
                    Showing <span className="font-medium text-gray-700">{Math.min((page - 1) * pageSize + 1, totalItems)}–{Math.min(page * pageSize, totalItems)}</span> of <span className="font-medium text-gray-700">{totalItems}</span> items
                </span>
                <div className="flex items-center gap-1 overflow-x-auto max-w-full scrollbar-hide">
                    <button
                        onClick={() => onPageChange(Math.max(1, page - 1))}
                        disabled={page === 1}
                        style={{
                            padding: "3px 10px", borderRadius: 8,
                            border: `1px solid ${C.border}`, background: C.card,
                            color: page === 1 ? C.border : C.textSoft,
                            fontSize: 13, cursor: page === 1 ? "not-allowed" : "pointer",
                            flexShrink: 0,
                        }}>
                        <span className="hidden sm:inline">← Prev</span>
                        <span className="sm:hidden">←</span>
                    </button>
                    {Array.from({ length: totalPages }, (_, i) => i + 1)
                        .filter(n => n === 1 || n === totalPages || Math.abs(n - page) <= 1)
                        .reduce((acc, n, idx, arr) => {
                            if (idx > 0 && n - arr[idx - 1] > 1) acc.push("…")
                            acc.push(n)
                            return acc
                        }, [])
                        .map((n, idx) =>
                            n === "…" ? (
                                <span key={`e-${idx}`} style={{ fontSize: 16, color: C.midgrey, padding: "0 2px", flexShrink: 0 }}>…</span>
                            ) : (
                                <button key={n} onClick={() => onPageChange(n)}
                                    style={{
                                        width: 26, height: 26, borderRadius: 8,
                                        border: `1px solid ${n === page ? C.nude : C.border}`,
                                        background: n === page ? C.nude : C.card,
                                        color: n === page ? "#fff" : C.textSoft,
                                        fontSize: 13, fontWeight: n === page ? 600 : 400,
                                        cursor: "pointer", flexShrink: 0,
                                    }}>
                                    {n}
                                </button>
                            )
                        )
                    }
                    <button
                        onClick={() => onPageChange(Math.min(totalPages, page + 1))}
                        disabled={page === totalPages}
                        style={{
                            padding: "3px 10px", borderRadius: 8,
                            border: `1px solid ${C.border}`, background: C.card,
                            color: page === totalPages ? C.border : C.textSoft,
                            fontSize: 13, cursor: page === totalPages ? "not-allowed" : "pointer",
                            flexShrink: 0,
                        }}>
                        <span className="hidden sm:inline">Next →</span>
                        <span className="sm:hidden">→</span>
                    </button>
                </div>
            </div>
        )
    }

    const pagedFilteredItems = filteredItems.slice((menuItemsPage - 1) * ITEMS_PAGE_SIZE, menuItemsPage * ITEMS_PAGE_SIZE)

    const filteredVariants = variants.filter(variant => {
        const matchesSearch =
            String(variant.variant_name || '').toLowerCase().includes(variantSearchQuery.toLowerCase()) ||
            String(variant.category || '').toLowerCase().includes(variantSearchQuery.toLowerCase())
        const matchesCategory = filterVariantCategory === "All" || variant.category === filterVariantCategory
        return matchesSearch && matchesCategory
    }).sort((a, b) => {
        const cat = String(a.category || '').localeCompare(String(b.category || ''))
        if (cat !== 0) return cat
        return String(a.variant_name || '').localeCompare(String(b.variant_name || ''))
    })
    const pagedVariants = filteredVariants.slice((variantsPage - 1) * ITEMS_PAGE_SIZE, variantsPage * ITEMS_PAGE_SIZE)

    const pagedModifiers = filteredModifiers.slice((modifiersPage - 1) * ITEMS_PAGE_SIZE, modifiersPage * ITEMS_PAGE_SIZE)
    const pagedMyPriceRequests = myPriceRequests.slice((priceRequestsPage - 1) * MENU_PAGE_SIZE, priceRequestsPage * MENU_PAGE_SIZE)
    const pagedUniqueItems = uniqueItemsList.slice((uniqueItemsPage - 1) * MENU_PAGE_SIZE, uniqueItemsPage * MENU_PAGE_SIZE)

    return (
        <div className="flex-1 overflow-y-auto bg-gray-50">

            <div className="p-8">
                {/* Tab Navigation */}
                <div className="flex gap-1 mb-6 bg-white rounded-lg shadow-sm p-1 w-full sm:w-fit overflow-x-auto">
                    <button
                        onClick={() => { setActiveTab("menu_overview"); setMenuItemSearch("") }}
                        className={`px-6 py-2.5 rounded-md font-medium text-sm transition-all flex-shrink-0 whitespace-nowrap ${activeTab === "menu_overview" ? 'bg-[#A0826D] text-white shadow-sm' : 'text-gray-600 hover:bg-gray-100'}`}
                    >
                        Branch Menu Overview
                    </button>

                    <button
                        onClick={() => { setActiveTab("menu"); setSearchQuery(""); setFilterCategory("All"); setFilterClassification("All"); setAvailableClassificationsForCategory([]) }}
                        className={`px-6 py-2.5 rounded-md font-medium text-sm transition-all ${activeTab === "menu" ? 'bg-[#FF6F3C] text-white shadow-sm' : 'text-gray-600 hover:bg-gray-100'}`}
                    >
                        Menu Items
                        {loading ? (
                            <span className={`ml-2 inline-flex px-2 py-0.5 rounded-full text-xs font-semibold ${activeTab === "menu" ? 'bg-white' : 'bg-orange-100'}`}>
                                <SkeletonBlock className="w-4 h-3" />
                            </span>
                        ) : menuItems.length > 0 && (
                            <span className={`ml-2 px-2 py-0.5 rounded-full text-xs font-semibold ${activeTab === "menu" ? 'bg-white text-[#FF6F3C]' : 'bg-orange-100 text-orange-700'}`}>
                                {menuItems.length}
                            </span>
                        )}
                    </button>

                    <button
                        onClick={() => { setActiveTab("variants"); setVariantSearchQuery("") }}
                        className={`px-6 py-2.5 rounded-md font-medium text-sm transition-all ${activeTab === "variants" ? 'bg-indigo-600 text-white shadow-sm' : 'text-gray-600 hover:bg-gray-100'}`}
                    >
                        Variants
                        {loadingVariants ? (
                            <span className={`ml-2 inline-flex px-2 py-0.5 rounded-full text-xs font-semibold ${activeTab === "variants" ? 'bg-white' : 'bg-indigo-100'}`}>
                                <SkeletonBlock className="w-4 h-3" />
                            </span>
                        ) : variants.length > 0 && (
                            <span className={`ml-2 px-2 py-0.5 rounded-full text-xs font-semibold ${activeTab === "variants" ? 'bg-white text-indigo-600' : 'bg-indigo-100 text-indigo-700'}`}>
                                {variants.length}
                            </span>
                        )}
                    </button>

                    <button
                        onClick={() => { setActiveTab("modifiers"); setModifierSearchQuery("") }}
                        className={`px-6 py-2.5 rounded-md font-medium text-sm transition-all ${activeTab === "modifiers" ? 'bg-purple-600 text-white shadow-sm' : 'text-gray-600 hover:bg-gray-100'}`}
                    >
                        Modifiers
                        {loadingModifiers ? (
                            <span className={`ml-2 inline-flex px-2 py-0.5 rounded-full text-xs font-semibold ${activeTab === "modifiers" ? 'bg-white' : 'bg-purple-100'}`}>
                                <SkeletonBlock className="w-4 h-3" />
                            </span>
                        ) : modifiers.length > 0 && (
                            <span className={`ml-2 px-2 py-0.5 rounded-full text-xs font-semibold ${activeTab === "modifiers" ? 'bg-white text-purple-600' : 'bg-purple-100 text-purple-700'}`}>
                                {modifiers.length}
                            </span>
                        )}
                    </button>
                </div>

                {/* BRANCH MENU OVERVIEW TAB */}
                {activeTab === "menu_overview" && (
                    <div className="space-y-6">
                        {/* Stats cards */}
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                            {/* Overall Menu Items */}
                            <div className="bg-white rounded-lg p-6 shadow-sm">
                                <div className="flex items-start justify-between mb-4">
                                    <div>
                                        <p className="text-sm text-gray-600 mb-1">
                                            {selectedBranchForMenu === 'all' ? 'Overall Menu Items' : 'Branch Menu Items'}
                                        </p>
                                        {branchMenuLoading ? (
                                            <SkeletonBlock className="h-9 w-16 mb-0.5" />
                                        ) : (
                                            <h2 className="text-3xl font-bold text-gray-800">{menuItems.length}</h2>
                                        )}
                                        <p className="text-sm text-orange-600 mt-2">Distinct products offered</p>
                                    </div>
                                    <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="text-white">
                                            <path fill="currentColor" d="M3 5h18v14H3zm2 2v10h14V7zm2 2h10v2H7zm0 4h7v2H7z" />
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            {/* Drink Items */}
                            <div className="bg-white rounded-lg p-6 shadow-sm">
                                <div className="flex items-start justify-between mb-4">
                                    <div>
                                        <p className="text-sm text-gray-600 mb-1">Drink Items</p>
                                        {branchMenuLoading ? (
                                            <SkeletonBlock className="h-9 w-16 mb-0.5" />
                                        ) : (
                                            <h2 className="text-3xl font-bold text-gray-800">{menuSummary.coffeeItems}</h2>
                                        )}
                                        <p className="text-sm text-green-600 mt-2">Category-based count</p>
                                    </div>
                                    <div className="w-12 h-12 bg-green-500 rounded-lg flex items-center justify-center">
                                        <svg viewBox="0 0 34 42" className="w-6 h-6 text-white" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M28.6523 1.13536C28.4808 0.794927 28.2183 0.508646 27.894 0.308246C27.5697 0.107846 27.1963 0.00115539 26.8151 0H6.17222C5.38779 0 4.68593 0.4335 4.335 1.13536L2.84872 4.12858H0V8.25715H33.0286V4.12858H30.1799L28.6936 1.13536H28.6523ZM4.10793 39.3866C4.1905 40.46 5.07815 41.2858 6.17222 41.2858H26.8151C27.8885 41.2858 28.7968 40.46 28.8794 39.3866L31.1088 10.3214H1.8785L4.10793 39.3866ZM26.3197 18.5786L25.3701 30.9643H7.61722L6.66765 18.5786H26.3403H26.3197Z" fill="currentColor" />
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            {/* Food Items */}
                            <div className="bg-white rounded-lg p-6 shadow-sm">
                                <div className="flex items-start justify-between mb-4">
                                    <div>
                                        <p className="text-sm text-gray-600 mb-1">Food / Snack Items</p>
                                        {branchMenuLoading ? (
                                            <SkeletonBlock className="h-9 w-16 mb-0.5" />
                                        ) : (
                                            <h2 className="text-3xl font-bold text-gray-800">{menuSummary.foodItems}</h2>
                                        )}
                                        <p className="text-sm text-purple-600 mt-2">Classification-based count</p>
                                    </div>
                                    <div className="w-12 h-12 bg-purple-500 rounded-lg flex items-center justify-center">
                                        <svg viewBox="0 0 14 14" className="w-6 h-6 text-white" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clipPath="url(#clip0)">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M1.184 1.09403C1.95082 0.38682 2.95686-0.00401942 4 3.11725e-05H10C11.05 3.11725e-05 12.064 0.390031 12.816 1.09403C13.1868 1.43548 13.4833 1.84966 13.687 2.31075C13.8907 2.77184 13.9973 3.26996 14 3.77403C14 4.16503 13.833 4.53403 13.549 4.80003C13.2635 5.06388 12.8888 5.20999 12.5 5.20903H1.5C1.11124 5.20999 0.736509 5.06388 0.451 4.80003C0.309087 4.66919 0.195765 4.51041 0.118153 4.33367C0.0405398 4.15694 0.000313367 3.96606 0 3.77303C0.00272084 3.26896 0.109255 2.77084 0.312961 2.30975C0.516666 1.84866 0.813175 1.43548 1.184 1.09403ZM0.77 6.75003C0.571088 6.75003 0.380322 6.82905 0.23967 6.9697C0.0990176 7.11035 0.02 7.30112 0.02 7.50003C0.02 7.69894 0.0990176 7.88971 0.23967 8.03036C0.380322 8.17101 0.571088 8.25003 0.77 8.25003H13.23C13.4289 8.25003 13.6197 8.17101 13.7603 8.03036C13.901 7.88971 13.98 7.69894 13.98 7.50003C13.98 7.30112 13.901 7.11035 13.7603 6.9697C13.6197 6.82905 13.4289 6.75003 13.23 6.75003H0.77ZM0.306 10.017C0.496 9.84103 0.746 9.74703 1 9.74703H2.5C2.57258 9.74727 2.64424 9.76331 2.71 9.79403L5.406 11.046L6.66 9.88103C6.75252 9.79543 6.87395 9.74792 7 9.74803H13C13.254 9.74803 13.504 9.84103 13.694 10.018C13.7899 10.1065 13.8666 10.2138 13.9193 10.3332C13.9719 10.4526 13.9994 10.5815 14 10.712C13.9971 11.1522 13.9034 11.587 13.7248 11.9893C13.5462 12.3915 13.2865 12.7527 12.962 13.05C12.2901 13.6652 11.411 14.0044 10.5 14H3.5C2.58903 14.0044 1.7099 13.6652 1.038 13.05C0.713492 12.7527 0.453819 12.3915 0.275217 11.9893C0.0966144 11.587 0.00292289 11.1522 0 10.712C0.000468548 10.5814 0.0278855 10.4522 0.0805369 10.3326C0.133188 10.213 0.209942 10.1056 0.306 10.017Z" fill="currentColor" />
                                            </g>
                                            <defs><clipPath id="clip0"><rect width="14" height="14" fill="white" /></clipPath></defs>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Branch Menu Overview — merged with assigned items table */}
                        <div className="bg-white rounded-lg shadow-sm">
                            <div className="px-6 py-4 border-b border-gray-200 space-y-4">
                                {/* Title + search row */}
                                <div className="flex flex-col xl:flex-row xl:items-center xl:justify-between gap-4">
                                    <div className="flex flex-col xl:flex-row xl:items-center xl:justify-between gap-4">
                                        <div>
                                            <h2 className="text-xl font-bold text-gray-800">Branch Menu Overview</h2>
                                            <p className="text-sm text-gray-500 mt-1">Menu item assignments per branch</p>
                                        </div>
                                    </div>
                                    <div className="relative w-full xl:w-72">
                                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                                                <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10a7 7 0 1 0 14 0a7 7 0 1 0-14 0m18 11l-6-6" />
                                            </svg>
                                        </span>
                                        <input
                                            type="text"
                                            placeholder="Search menu items..."
                                            value={menuItemSearch}
                                            onChange={(e) => { setMenuItemSearch(e.target.value); setMenuOverviewPage(1) }}
                                            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#A0826D] text-sm"
                                        />
                                    </div>
                                </div>


                                {/* Summary pills */}
                                <div className="flex gap-3 flex-wrap">
                                    <span className="px-3 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-700">
                                        {branchMenuLoading ? <SkeletonBlock className="w-4 h-3 inline-block" /> : menuSummary.totalCategories} Categories
                                    </span>
                                    <span className="px-3 py-1 rounded-full text-xs font-semibold bg-purple-100 text-purple-700">
                                        {branchMenuLoading ? <SkeletonBlock className="w-4 h-3 inline-block" /> : menuSummary.totalClassifications} Classifications
                                    </span>
                                    <span className="px-3 py-1 rounded-full text-xs font-semibold bg-orange-100 text-orange-700">
                                        {branchMenuLoading ? <SkeletonBlock className="w-4 h-3 inline-block" /> : menuSummary.uniqueItems} Active Items
                                    </span>
                                    {/* <span className="px-3 py-1 rounded-full text-xs font-semibold bg-gray-100 text-gray-600">
                                        {branchMenuLoading ? <SkeletonBlock className="w-4 h-3 inline-block" /> : menuSummary.totalAssignments} Total Assignments
                                    </span> */}
                                </div>

                                {/* Sub-tab toggle */}
                                <div className="flex bg-gray-100 rounded-lg p-1 w-full sm:w-fit overflow-x-auto scrollbar-hide">
                                    <button
                                        onClick={() => setBranchOverviewSubTab('menu_items')}
                                        className={`px-4 py-2 rounded-md text-sm font-medium transition-all flex-shrink-0 whitespace-nowrap ${branchOverviewSubTab === 'menu_items' ? 'bg-[#A0826D] text-white shadow-sm' : 'text-gray-600 hover:bg-gray-200'}`}
                                    >
                                        Menu Items
                                    </button>

                                    <button
                                        onClick={() => setBranchOverviewSubTab('price_requests')}
                                        className={`px-4 py-2 rounded-md text-sm font-medium transition-all flex-shrink-0 whitespace-nowrap ${branchOverviewSubTab === 'price_requests' ? 'bg-[#A0826D] text-white shadow-sm' : 'text-gray-600 hover:bg-gray-200'}`}
                                    >
                                        Price Change Requests
                                        {loadingMyPriceRequests ? (
                                            <span className="ml-1.5 inline-flex px-1.5 py-0.5 rounded-full bg-red-500">
                                                <SkeletonBlock className="w-3 h-2.5" />
                                            </span>
                                        ) : myPriceRequests.filter(r => r.status === 'approved').length > 0 && (
                                            <span className="ml-1.5 px-1.5 py-0.5 rounded-full text-[10px] font-bold bg-red-500 text-white">
                                                {myPriceRequests.filter(r => r.status === 'approved').length}
                                            </span>
                                        )}
                                    </button>

                                    <button
                                        onClick={() => setBranchOverviewSubTab('menu_change_requests')}
                                        className={`px-4 py-2 rounded-md text-sm font-medium transition-all flex-shrink-0 whitespace-nowrap ${branchOverviewSubTab === 'menu_change_requests' ? 'bg-[#A0826D] text-white shadow-sm' : 'text-gray-600 hover:bg-gray-200'}`}
                                    >
                                        Menu Item Requests
                                        {loadingMyMenuChangeRequests ? (
                                            <span className="ml-1.5 inline-flex px-1.5 py-0.5 rounded-full bg-red-500">
                                                <SkeletonBlock className="w-3 h-2.5" />
                                            </span>
                                        ) : myMenuChangeRequests.filter(r => r.status === 'pending' && r.item_type === 'menu').length > 0 && (
                                            <span className="ml-1.5 px-1.5 py-0.5 rounded-full text-[10px] font-bold bg-red-500 text-white">
                                                {myMenuChangeRequests.filter(r => r.status === 'pending' && r.item_type === 'menu').length}
                                            </span>
                                        )}
                                    </button>

                                    <button
                                        onClick={() => setBranchOverviewSubTab('variant_change_requests')}
                                        className={`px-4 py-2 rounded-md text-sm font-medium transition-all flex-shrink-0 whitespace-nowrap ${branchOverviewSubTab === 'variant_change_requests' ? 'bg-[#A0826D] text-white shadow-sm' : 'text-gray-600 hover:bg-gray-200'}`}
                                    >
                                        Variant Requests
                                        {loadingMyMenuChangeRequests ? (
                                            <span className="ml-1.5 inline-flex px-1.5 py-0.5 rounded-full bg-red-500">
                                                <SkeletonBlock className="w-3 h-2.5" />
                                            </span>
                                        ) : myMenuChangeRequests.filter(r => r.status === 'pending' && r.item_type === 'variant').length > 0 && (
                                            <span className="ml-1.5 px-1.5 py-0.5 rounded-full text-[10px] font-bold bg-red-500 text-white">
                                                {myMenuChangeRequests.filter(r => r.status === 'pending' && r.item_type === 'variant').length}
                                            </span>
                                        )}
                                    </button>

                                    <button
                                        onClick={() => setBranchOverviewSubTab('modifier_change_requests')}
                                        className={`px-4 py-2 rounded-md text-sm font-medium transition-all flex-shrink-0 whitespace-nowrap ${branchOverviewSubTab === 'modifier_change_requests' ? 'bg-[#A0826D] text-white shadow-sm' : 'text-gray-600 hover:bg-gray-200'}`}
                                    >
                                        Modifier Requests
                                        {loadingMyMenuChangeRequests ? (
                                            <span className="ml-1.5 inline-flex px-1.5 py-0.5 rounded-full bg-red-500">
                                                <SkeletonBlock className="w-3 h-2.5" />
                                            </span>
                                        ) : myMenuChangeRequests.filter(r => r.status === 'pending' && r.item_type === 'modifier').length > 0 && (
                                            <span className="ml-1.5 px-1.5 py-0.5 rounded-full text-[10px] font-bold bg-red-500 text-white">
                                                {myMenuChangeRequests.filter(r => r.status === 'pending' && r.item_type === 'modifier').length}
                                            </span>
                                        )}
                                    </button>

                                </div>
                            </div>

                            {/* Assigned items table */}
                            {branchOverviewSubTab === 'menu_items' && <div className="overflow-x-auto">
                                <table className="w-full">
                                    <thead className="bg-gray-50 border-b border-gray-200">
                                        <tr>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Item</th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Category</th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Classification</th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Price</th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Branch</th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                        {branchMenuLoading ? (
                                            <tr>
                                                <td colSpan="5" className="px-6 py-8 text-center text-gray-500">Loading menu items...</td>
                                            </tr>
                                        ) : filteredBranchMenuItems.length === 0 ? (
                                            <tr>
                                                <td colSpan="5" className="px-6 py-8 text-center text-gray-500">No menu items found for the selected branch.</td>
                                            </tr>
                                        ) : (
                                            paginatedBranchMenuItems.map((item) => (
                                                <tr key={item.id} className="hover:bg-gray-50 transition-colors">
                                                    <td className="px-6 py-4 whitespace-nowrap">
                                                        <div className="flex items-center gap-3">
                                                            {item.item_img ? (
                                                                <img src={item.item_img} alt={item.name} className="w-10 h-10 rounded-lg object-cover border border-gray-200" />
                                                            ) : (
                                                                <div className="w-10 h-10 rounded-lg bg-gray-100 border border-gray-200 flex items-center justify-center text-[10px] text-gray-400">N/A</div>
                                                            )}
                                                            <p className="text-sm font-medium text-gray-800">{item.name}</p>
                                                        </div>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{item.category}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{item.classification}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap">
                                                        <div className="flex flex-col">
                                                            <span className="text-sm font-semibold text-gray-800">
                                                                ₱{parseFloat(item.effective_price || 0).toFixed(2)}
                                                            </span>
                                                            {item.has_price_override && (
                                                                <span className="text-xs text-gray-400 line-through">
                                                                    ₱{parseFloat(item.master_price || 0).toFixed(2)}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{item.branch_name}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>}

                            {branchOverviewSubTab === 'menu_items' && <Pagination
                                page={menuOverviewPage}
                                totalItems={filteredBranchMenuItems.length}
                                pageSize={MENU_PAGE_SIZE}
                                onPageChange={setMenuOverviewPage}
                            />}

                            {/* Footer count when no pagination needed */}
                            {branchOverviewSubTab === 'menu_items' && !branchMenuLoading && filteredBranchMenuItems.length > 0 && filteredBranchMenuItems.length <= MENU_PAGE_SIZE && (
                                <div className="px-6 py-3 border-t border-gray-200 bg-gray-50 rounded-b-lg">
                                    <p className="text-sm text-gray-500">
                                        Showing <span className="font-medium text-gray-700">{filteredBranchMenuItems.length}</span> item{filteredBranchMenuItems.length !== 1 ? 's' : ''}
                                    </p>
                                </div>
                            )}

                            {/* Price Change Requests sub-tab */}
                            {branchOverviewSubTab === 'price_requests' && (
                                <div className="overflow-x-auto">
                                    {loadingMyPriceRequests ? (
                                        <div className="px-6 py-10 text-center text-gray-500 text-sm">Loading price requests...</div>
                                    ) : myPriceRequests.length === 0 ? (
                                        <div className="px-6 py-10 text-center text-gray-500 text-sm">No price change requests from your branch yet.</div>
                                    ) : (
                                        <table className="w-full">
                                            <thead className="bg-gray-50 border-b border-gray-200">
                                                <tr>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Item</th>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Type</th>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Price Change</th>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Reason</th>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
                                                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody className="bg-white divide-y divide-gray-200">
                                                {pagedMyPriceRequests.map(request => (
                                                    <tr key={request.id} className="hover:bg-gray-50">
                                                        <td className="px-6 py-3">
                                                            <p className="text-sm font-medium text-gray-800">{request.item_name}</p>
                                                        </td>
                                                        <td className="px-6 py-3">
                                                            <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${request.item_type === 'menu_item' ? 'bg-orange-100 text-orange-700' :
                                                                request.item_type === 'variant' ? 'bg-indigo-100 text-indigo-700' :
                                                                    'bg-purple-100 text-purple-700'
                                                                }`}>
                                                                {request.item_type.replace('_', ' ')}
                                                            </span>
                                                        </td>
                                                        <td className="px-6 py-3 whitespace-nowrap">
                                                            <span className="line-through text-red-400 text-sm">₱{parseFloat(request.current_price).toFixed(2)}</span>
                                                            <span className="mx-1.5 text-gray-400">→</span>
                                                            <span className="text-emerald-600 font-bold text-sm">₱{parseFloat(request.requested_price).toFixed(2)}</span>
                                                        </td>
                                                        <td className="px-6 py-3 max-w-xs">
                                                            <p className="text-sm text-gray-600 truncate" title={request.reason}>{request.reason}</p>
                                                        </td>
                                                        <td className="px-6 py-3">
                                                            <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${request.status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
                                                                request.status === 'approved' ? 'bg-green-100 text-green-800' :
                                                                    'bg-red-100 text-red-800'
                                                                }`}>
                                                                {request.status}
                                                            </span>
                                                        </td>
                                                        <td className="px-6 py-3 whitespace-nowrap text-xs text-gray-500">
                                                            {new Date(request.created_at).toLocaleDateString('en-PH', { month: 'short', day: 'numeric', year: 'numeric' })}
                                                        </td>
                                                        <td className="px-6 py-3">
                                                            <div className="flex items-center gap-2 justify-end">
                                                                {request.status === 'pending' && (
                                                                    <button
                                                                        onClick={() => handleCancelPriceRequest(request)}
                                                                        className="px-2.5 py-1 rounded-lg text-xs font-medium bg-red-100 text-red-700 hover:bg-red-200 whitespace-nowrap"
                                                                    >
                                                                        Cancel
                                                                    </button>
                                                                )}
                                                                {request.status === 'approved' && request.item_type === 'menu_item' && (() => {
                                                                    const alreadyApplied = branchMenuItems.some(
                                                                        item => String(item.item_id) === String(request.item_id) &&
                                                                            item.has_price_override &&
                                                                            parseFloat(item.branch_price) === parseFloat(request.requested_price)
                                                                    )
                                                                    return alreadyApplied ? (
                                                                        <span className="text-xs text-gray-400 italic">Already applied</span>
                                                                    ) : (
                                                                        <button
                                                                            onClick={() => handleApplyBranchPrice(request)}
                                                                            disabled={applyingPriceRequestId === request.id}
                                                                            className={`px-2.5 py-1 rounded-lg text-xs font-medium whitespace-nowrap ${applyingPriceRequestId === request.id
                                                                                ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
                                                                                : 'bg-emerald-600 text-white hover:bg-emerald-700'
                                                                                }`}
                                                                        >
                                                                            {applyingPriceRequestId === request.id ? 'Applying...' : 'Apply Price'}
                                                                        </button>
                                                                    )
                                                                })()}
                                                                {(request.status === 'rejected' || (request.status === 'approved' && request.item_type !== 'menu_item')) && (
                                                                    <span className="text-xs text-gray-400 italic">—</span>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )}
                                    <Pagination
                                        page={priceRequestsPage}
                                        totalItems={myPriceRequests.length}
                                        pageSize={MENU_PAGE_SIZE}
                                        onPageChange={setPriceRequestsPage}
                                    />
                                </div>
                            )}

                            {/* Menu Item Requests sub-tab */}
                            {branchOverviewSubTab === 'menu_change_requests' && (() => {
                                const filteredRequests = myMenuChangeRequests.filter(r => r.item_type === 'menu')
                                return (
                                    <div className="overflow-x-auto">
                                        {loadingMyMenuChangeRequests ? (
                                            <div className="px-6 py-10 text-center text-gray-500 text-sm">Loading requests...</div>
                                        ) : filteredRequests.length === 0 ? (
                                            <div className="px-6 py-10 text-center text-gray-500 text-sm">No menu item requests from your branch yet.</div>
                                        ) : (
                                            <table className="w-full">
                                                <thead className="bg-gray-50 border-b border-gray-200">
                                                    <tr>
                                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Item</th>
                                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Type</th>
                                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Reason</th>
                                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
                                                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="bg-white divide-y divide-gray-200">
                                                    {filteredRequests
                                                        .slice((menuChangeRequestsPage - 1) * MENU_PAGE_SIZE, menuChangeRequestsPage * MENU_PAGE_SIZE)
                                                        .map(request => (
                                                            <tr key={request.id} className="hover:bg-gray-50">
                                                                <td className="px-6 py-3">
                                                                    <p className="text-sm font-medium text-gray-800">{request.item_name}</p>
                                                                </td>
                                                                <td className="px-6 py-3">
                                                                    <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${request.request_type === 'add' ? 'bg-green-100 text-green-700' : request.request_type === 'reinstate' ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-700'}`}>
                                                                        {request.request_type === 'add' ? 'New Item' : request.request_type === 'reinstate' ? 'Reinstate Item' : 'Delete Item'}
                                                                    </span>
                                                                </td>
                                                                <td className="px-6 py-3 max-w-xs">
                                                                    <p className="text-sm text-gray-600 truncate" title={request.reason}>{request.reason}</p>
                                                                </td>
                                                                <td className="px-6 py-3">
                                                                    <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${request.status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
                                                                        request.status === 'approved' ? 'bg-green-100 text-green-800' :
                                                                            'bg-red-100 text-red-800'
                                                                        }`}>
                                                                        {request.status}
                                                                    </span>
                                                                </td>
                                                                <td className="px-6 py-3 whitespace-nowrap text-xs text-gray-500">
                                                                    {new Date(request.created_at).toLocaleDateString('en-PH', { month: 'short', day: 'numeric', year: 'numeric' })}
                                                                </td>
                                                                <td className="px-6 py-3 text-right">
                                                                    {request.status === 'pending' && (
                                                                        <button
                                                                            onClick={() => handleCancelMenuChangeRequest(request)}
                                                                            className="px-2.5 py-1 rounded-lg text-xs font-medium bg-red-100 text-red-700 hover:bg-red-200 whitespace-nowrap"
                                                                        >
                                                                            Cancel
                                                                        </button>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </table>
                                        )}
                                        <Pagination
                                            page={menuChangeRequestsPage}
                                            totalItems={filteredRequests.length}
                                            pageSize={MENU_PAGE_SIZE}
                                            onPageChange={setMenuChangeRequestsPage}
                                        />
                                    </div>
                                )
                            })()}

                            {/* Variant Requests sub-tab */}
                            {branchOverviewSubTab === 'variant_change_requests' && (() => {
                                const filteredRequests = myMenuChangeRequests.filter(r => r.item_type === 'variant')
                                return (
                                    <div className="overflow-x-auto">
                                        {loadingMyMenuChangeRequests ? (
                                            <div className="px-6 py-10 text-center text-gray-500 text-sm">Loading requests...</div>
                                        ) : filteredRequests.length === 0 ? (
                                            <div className="px-6 py-10 text-center text-gray-500 text-sm">No variant requests from your branch yet.</div>
                                        ) : (
                                            <table className="w-full">
                                                <thead className="bg-gray-50 border-b border-gray-200">
                                                    <tr>
                                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Variant</th>
                                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Type</th>
                                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Reason</th>
                                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
                                                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="bg-white divide-y divide-gray-200">
                                                    {filteredRequests
                                                        .slice((variantChangeRequestsPage - 1) * MENU_PAGE_SIZE, variantChangeRequestsPage * MENU_PAGE_SIZE)
                                                        .map(request => (
                                                            <tr key={request.id} className="hover:bg-gray-50">
                                                                <td className="px-6 py-3">
                                                                    <p className="text-sm font-medium text-gray-800">{request.item_name}</p>
                                                                </td>
                                                                <td className="px-6 py-3">
                                                                    <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${request.request_type === 'add' ? 'bg-green-100 text-green-700' : request.request_type === 'reinstate' ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-700'}`}>
                                                                        {request.request_type === 'add' ? 'New Variant' : request.request_type === 'reinstate' ? 'Reinstate Variant' : 'Delete Variant'}
                                                                    </span>
                                                                </td>
                                                                <td className="px-6 py-3 max-w-xs">
                                                                    <p className="text-sm text-gray-600 truncate" title={request.reason}>{request.reason}</p>
                                                                </td>
                                                                <td className="px-6 py-3">
                                                                    <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${request.status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
                                                                        request.status === 'approved' ? 'bg-green-100 text-green-800' :
                                                                            'bg-red-100 text-red-800'
                                                                        }`}>
                                                                        {request.status}
                                                                    </span>
                                                                </td>
                                                                <td className="px-6 py-3 whitespace-nowrap text-xs text-gray-500">
                                                                    {new Date(request.created_at).toLocaleDateString('en-PH', { month: 'short', day: 'numeric', year: 'numeric' })}
                                                                </td>
                                                                <td className="px-6 py-3 text-right">
                                                                    {request.status === 'pending' && (
                                                                        <button
                                                                            onClick={() => handleCancelMenuChangeRequest(request)}
                                                                            className="px-2.5 py-1 rounded-lg text-xs font-medium bg-red-100 text-red-700 hover:bg-red-200 whitespace-nowrap"
                                                                        >
                                                                            Cancel
                                                                        </button>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </table>
                                        )}
                                        <Pagination
                                            page={variantChangeRequestsPage}
                                            totalItems={filteredRequests.length}
                                            pageSize={MENU_PAGE_SIZE}
                                            onPageChange={setVariantChangeRequestsPage}
                                        />
                                    </div>
                                )
                            })()}

                            {/* Modifier Requests sub-tab */}
                            {branchOverviewSubTab === 'modifier_change_requests' && (() => {
                                const filteredRequests = myMenuChangeRequests.filter(r => r.item_type === 'modifier')
                                return (
                                    <div className="overflow-x-auto">
                                        {loadingMyMenuChangeRequests ? (
                                            <div className="px-6 py-10 text-center text-gray-500 text-sm">Loading requests...</div>
                                        ) : filteredRequests.length === 0 ? (
                                            <div className="px-6 py-10 text-center text-gray-500 text-sm">No modifier requests from your branch yet.</div>
                                        ) : (
                                            <table className="w-full">
                                                <thead className="bg-gray-50 border-b border-gray-200">
                                                    <tr>
                                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Modifier</th>
                                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Type</th>
                                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Reason</th>
                                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
                                                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="bg-white divide-y divide-gray-200">
                                                    {filteredRequests
                                                        .slice((modifierChangeRequestsPage - 1) * MENU_PAGE_SIZE, modifierChangeRequestsPage * MENU_PAGE_SIZE)
                                                        .map(request => (
                                                            <tr key={request.id} className="hover:bg-gray-50">
                                                                <td className="px-6 py-3">
                                                                    <p className="text-sm font-medium text-gray-800">{request.item_name}</p>
                                                                </td>
                                                                <td className="px-6 py-3">
                                                                    <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${request.request_type === 'add' ? 'bg-green-100 text-green-700' : request.request_type === 'reinstate' ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-700'}`}>
                                                                        {request.request_type === 'add' ? 'New Modifier' : request.request_type === 'reinstate' ? 'Reinstate Modifier' : 'Delete Modifier'}
                                                                    </span>
                                                                </td>
                                                                <td className="px-6 py-3 max-w-xs">
                                                                    <p className="text-sm text-gray-600 truncate" title={request.reason}>{request.reason}</p>
                                                                </td>
                                                                <td className="px-6 py-3">
                                                                    <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${request.status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
                                                                        request.status === 'approved' ? 'bg-green-100 text-green-800' :
                                                                            'bg-red-100 text-red-800'
                                                                        }`}>
                                                                        {request.status}
                                                                    </span>
                                                                </td>
                                                                <td className="px-6 py-3 whitespace-nowrap text-xs text-gray-500">
                                                                    {new Date(request.created_at).toLocaleDateString('en-PH', { month: 'short', day: 'numeric', year: 'numeric' })}
                                                                </td>
                                                                <td className="px-6 py-3 text-right">
                                                                    {request.status === 'pending' && (
                                                                        <button
                                                                            onClick={() => handleCancelMenuChangeRequest(request)}
                                                                            className="px-2.5 py-1 rounded-lg text-xs font-medium bg-red-100 text-red-700 hover:bg-red-200 whitespace-nowrap"
                                                                        >
                                                                            Cancel
                                                                        </button>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </table>
                                        )}
                                        <Pagination
                                            page={modifierChangeRequestsPage}
                                            totalItems={filteredRequests.length}
                                            pageSize={MENU_PAGE_SIZE}
                                            onPageChange={setModifierChangeRequestsPage}
                                        />
                                    </div>
                                )
                            })()}
                        </div>

                        {/* Unique menu items collapsible */}
                        <div className="bg-white rounded-lg shadow-sm">
                            <div
                                className="px-6 py-4 border-b border-gray-200 flex items-center justify-between cursor-pointer hover:bg-gray-50 transition-colors"
                                onClick={() => setUniqueItemsCollapsed(v => !v)}
                            >
                                <div>
                                    <h2 className="text-xl font-bold text-gray-800">
                                        Unique Menu Items ({branchMenuLoading ?
                                            <SkeletonBlock className="w-4 h-4 inline-block" />
                                            : uniqueItemsList.length})
                                    </h2>
                                    <p className="text-sm text-gray-500 mt-0.5">Items not available in every active branch</p>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" strokeWidth="2"
                                    className={`text-gray-400 transition-transform duration-200 ${uniqueItemsCollapsed ? '-rotate-90' : ''}`}
                                >
                                    <path d="M6 9l6 6 6-6" />
                                </svg>
                            </div>
                            {!uniqueItemsCollapsed && (
                                <div>
                                    {uniqueItemsList.length === 0 ? (
                                        <div className="px-6 py-6 text-gray-500 text-sm">No items found.</div>
                                    ) : (
                                        <div className="max-h-80 overflow-y-auto divide-y">
                                            {pagedUniqueItems.map(item => (
                                                <div key={item.item_id} className="px-6 py-3 flex justify-between items-center">
                                                    <div className="flex items-center gap-3">
                                                        {item.item_img ? (
                                                            <img src={item.item_img} alt={item.name} className="w-10 h-10 rounded-lg object-cover border border-gray-200" />
                                                        ) : (
                                                            <div className="w-10 h-10 rounded-lg bg-gray-100 border border-gray-200 flex items-center justify-center text-[10px] text-gray-400">N/A</div>
                                                        )}
                                                        <div>
                                                            <p className="font-medium text-gray-800">{item.name}</p>
                                                            <p className="text-xs text-gray-500">{item.category} • {item.classification}</p>
                                                        </div>
                                                    </div>
                                                    <div className="text-right">
                                                        <p className="text-sm font-medium text-gray-700">{item.branchCount} / {totalBranchCount} branches</p>
                                                        {item.isInAllBranches ? (
                                                            <span className="text-xs text-green-600 font-medium">Available everywhere</span>
                                                        ) : (
                                                            <span className="text-xs text-orange-600 font-medium">Branch Exclusive</span>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                    {/* {!uniqueItemsCollapsed && uniqueItemsList.length > 0 && (
                                        <div className="px-6 py-3 border-t border-gray-100 bg-gray-50">
                                            <p className="text-sm text-gray-500">
                                                Showing <span className="font-medium text-gray-700">{pagedUniqueItems.length}</span> of{' '}
                                                <span className="font-medium text-gray-700">{uniqueItemsList.length}</span> item{uniqueItemsList.length !== 1 ? 's' : ''}
                                            </p>
                                        </div>
                                    )} */}
                                    {!uniqueItemsCollapsed && (
                                        <Pagination
                                            page={uniqueItemsPage}
                                            totalItems={uniqueItemsList.length}
                                            pageSize={MENU_PAGE_SIZE}
                                            onPageChange={setUniqueItemsPage}
                                        />
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {activeTab === "menu" && (
                    <div className="bg-white rounded-lg shadow-sm">
                        <div className="p-6 border-b border-gray-200">
                            <div className="flex flex-col gap-4">
                                <div className="flex flex-col gap-2 lg:flex-row lg:items-start lg:justify-between">
                                    <div>
                                        <h2 className="text-xl font-bold text-gray-800">Menu Items</h2>
                                        <p className="text-sm text-gray-500">
                                            {currentBranchName ? `Manage menu items for ${currentBranchName}` : 'Manage your branch menu items'}
                                        </p>
                                    </div>

                                    <div className="flex flex-wrap items-center gap-3">
                                        <div className="relative">
                                            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                                                    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10a7 7 0 1 0 14 0a7 7 0 1 0-14 0m18 11l-6-6" />
                                                </svg>
                                            </span>
                                            <input
                                                type="text"
                                                placeholder="Search Menu items..."
                                                value={searchQuery}
                                                onChange={(e) => setSearchQuery(e.target.value)}
                                                className="pl-9 pr-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#FF6F3C] w-52"
                                            />
                                        </div>

                                        <button
                                            onClick={openArchivedViewerModal}
                                            className="p-2 bg-gray-100 text-gray-700 hover:bg-gray-200 rounded-lg"
                                            title="View Archived"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                                <path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m3 6v10h12V9zm2 2h8v2H8zm0 4h8v2H8zM5 5v2h14V5z" />
                                            </svg>
                                        </button>

                                        <button
                                            onClick={() => { resetItemForm(); setShowAddItemModal(true) }}
                                            className="px-4 py-2 bg-[#FF6F3C] text-white rounded-lg font-medium hover:bg-[#ff4c0b] flex items-center gap-2"
                                        >
                                            <span>+</span>
                                            <span>Request Add Item</span>
                                        </button>
                                    </div>
                                </div>

                                <div className="flex flex-col gap-2">
                                    {/* Level 1: Category buttons */}
                                    <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide">
                                        {['All', ...[...new Set(menuItems.map(item => item.category).filter(Boolean))].sort()].map(cat => (
                                            <button
                                                key={cat}
                                                onClick={() => {
                                                    setFilterCategory(cat)
                                                    setFilterClassification('All')
                                                    if (cat === 'All') {
                                                        setAvailableClassificationsForCategory([])
                                                    } else {
                                                        const classifications = [
                                                            ...new Set(
                                                                menuItems
                                                                    .filter(item => item.category === cat)
                                                                    .map(item => item.classification)
                                                                    .filter(Boolean)
                                                            )
                                                        ].sort()
                                                        setAvailableClassificationsForCategory(classifications)
                                                    }
                                                }}
                                                className={`px-4 py-2 rounded-lg font-medium text-sm transition-colors flex-shrink-0 whitespace-nowrap ${filterCategory === cat
                                                ? 'bg-[#FF6F3C] text-white'
                                                : 'text-gray-600 hover:bg-gray-100'
                                                }`}
                                            >
                                                {cat}
                                                {cat !== 'All' && (
                                                    <span className={`ml-1.5 px-1.5 py-0.5 rounded-full text-[10px] font-bold ${filterCategory === cat
                                                        ? 'bg-white/30 text-white'
                                                        : 'bg-gray-100 text-gray-500'
                                                        }`}>
                                                        {loading ? <SkeletonBlock className="w-3 h-2.5 inline-block" /> : menuItems.filter(i => i.category === cat).length}
                                                    </span>
                                                )}
                                            </button>
                                        ))}
                                    </div>

                                    {/* Level 2: Classification chips — only shown when a category is selected */}
                                    {filterCategory !== 'All' && availableClassificationsForCategory.length > 0 && (
                                        <div className="flex items-center gap-2 overflow-x-auto pb-1 pl-1 scrollbar-hide">
                                            <span className="text-xs text-gray-400 font-medium shrink-0">
                                                {filterCategory}:
                                            </span>
                                            {['All', ...availableClassificationsForCategory].map(cls => (
                                                <button
                                                    key={cls}
                                                    onClick={() => setFilterClassification(cls)}
                                                    className={`px-3 py-1 rounded-full text-xs font-semibold border transition-all flex-shrink-0 whitespace-nowrap ${filterClassification === cls
                                                        ? 'bg-[#303030] border-[#303030] text-white'
                                                        : 'bg-white border-gray-300 text-gray-600 hover:border-gray-500'
                                                        }`}
                                                >
                                                    {cls === 'All' ? `All ${filterCategory}` : cls}
                                                    {cls !== 'All' && (
                                                        <span className={`ml-1 ${filterClassification === cls ? 'opacity-70' : 'text-gray-400'}`}>
                                                            ({loading ? <SkeletonBlock className="w-3 h-2.5 inline-block" /> : menuItems.filter(i => i.category === filterCategory && i.classification === cls).length})
                                                        </span>
                                                    )}
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="overflow-x-auto">
                            <table className="w-full">
                                <thead className="bg-gray-50 border-b border-gray-200">
                                    <tr>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Item</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Category</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Classification</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Price</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {loading ? (
                                        <tr><td colSpan="6" className="px-6 py-8 text-center text-gray-500">Loading menu items...</td></tr>
                                    ) : filteredItems.length === 0 ? (
                                        <tr><td colSpan="6" className="px-6 py-8 text-center text-gray-500">No menu items found</td></tr>
                                    ) : (
                                        pagedFilteredItems.map((item) => (
                                            <tr key={item.item_id} className="hover:bg-gray-50">
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <div className="flex items-center gap-3">
                                                        {item.item_img && (
                                                            <img src={item.item_img} alt={item.name} className="w-12 h-12 rounded-lg object-cover" />
                                                        )}
                                                        <p className="font-medium text-gray-800">{item.name}</p>
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <span className="px-3 py-1 rounded-full text-sm font-medium bg-gray-100 text-gray-700">
                                                        {item.category}
                                                    </span>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <span className="px-3 py-1 rounded-full text-sm font-medium bg-orange-50 text-orange-700 border border-orange-100">
                                                        {item.classification}
                                                    </span>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <div className="flex flex-col">
                                                        <span className="text-sm font-semibold text-gray-800">
                                                            ₱{parseFloat(item.effective_price ?? item.item_price).toFixed(2)}
                                                        </span>
                                                        {item.has_price_override && (
                                                            <span className="text-xs text-gray-400 line-through">
                                                                ₱{parseFloat(item.master_price ?? item.item_price).toFixed(2)}
                                                            </span>
                                                        )}
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <span className={`px-3 py-1 rounded-full text-sm font-medium ${item.status === 'available'
                                                        ? 'bg-green-100 text-green-800'
                                                        : 'bg-red-100 text-red-800'
                                                        }`}>
                                                        {item.status}
                                                    </span>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <div className="flex items-center gap-2 justify-end">
                                                        <button
                                                            onClick={() => handleEditClick(item)}
                                                            className="p-1 text-gray-600 hover:bg-gray-100 rounded"
                                                            title="View details"
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                                                <path fill="currentColor" d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3" />
                                                            </svg>
                                                        </button>
                                                        {(() => {
                                                            const hasPending = myPriceRequests.some(
                                                                r => r.item_id === item.item_id &&
                                                                    r.item_type === 'menu_item' &&
                                                                    r.status === 'pending'
                                                            )
                                                            return (
                                                                <button
                                                                    onClick={() => !hasPending && handlePriceChangeRequest(item, 'menu_item')}
                                                                    disabled={hasPending}
                                                                    className={`p-1 rounded ${hasPending ? 'text-gray-300 cursor-not-allowed' : 'text-emerald-600 hover:bg-emerald-50'}`}
                                                                   title={hasPending ? 'A price change request is already pending for this item' : 'Request Price Change'}
                                                                >
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                                                        <text x="12" y="17.5" textAnchor="middle" fontSize="18" fontWeight="700" fill="currentColor" fontFamily="Arial, sans-serif">₱</text>
                                                                    </svg>
                                                                </button>
                                                            )
                                                        })()}

                                                        <button
                                                            onClick={() => handleDeleteRequest(item, 'menu')}
                                                            className="p-1 text-red-600 hover:bg-red-50 rounded"
                                                            title="Request Delete"
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zM17 6H7v13h10zM9 17h2V8H9zm4 0h2V8h-2z" /></svg>
                                                        </button>

                                                        <div className="relative">
                                                            {/* <button
                                                                onClick={() => setOpenMenuItemId(prev => prev === item.item_id ? null : item.item_id)}
                                                                className="p-1 text-gray-500 hover:bg-gray-100 rounded"
                                                                title="More options"
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                                                    <path fill="currentColor" d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m0-6c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m0 12c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2" />
                                                                </svg>
                                                            </button>
                                                            {openMenuItemId === item.item_id && (
                                                                <div className="absolute right-0 mt-1 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-20">
                                                                    <button
                                                                        onClick={() => { openAssignVariantsModal(item); setOpenMenuItemId(null) }}
                                                                        className="w-full flex items-center gap-2 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 rounded-t-lg"
                                                                    >
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z" /></svg>
                                                                        Assign Variants
                                                                    </button>
                                                                    <button
                                                                        onClick={() => { openAssignModifiersModal(item); setOpenMenuItemId(null) }}
                                                                        className="w-full flex items-center gap-2 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50"
                                                                    >
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z" /></svg>
                                                                        Assign Modifiers
                                                                    </button>
                                                                    <button
                                                                        onClick={() => { openVariantRulesModal(item); setOpenMenuItemId(null) }}
                                                                        className="w-full flex items-center gap-2 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 rounded-b-lg"
                                                                    >
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M14 17H5v-2h9zm5-4H5v-2h14zm0-4H5V7h14z" /></svg>
                                                                        Manage Variant Rules
                                                                    </button>
                                                                </div>
                                                            )} */}
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <Pagination
                            page={menuItemsPage}
                            totalItems={filteredItems.length}
                            pageSize={ITEMS_PAGE_SIZE}
                            onPageChange={setMenuItemsPage}
                        />
                    </div>
                )}

                {/* VARIANTS TAB */}
                {activeTab === "variants" && (
                    <div className="bg-white rounded-lg shadow-sm">
                        <div className="p-6 border-b border-gray-200">
                            <div className="flex flex-col gap-4">
                                <div className="flex flex-col gap-2 lg:flex-row lg:items-start lg:justify-between">
                                    <div>
                                        <h2 className="text-xl font-bold text-gray-800">Variants</h2>
                                        <p className="text-sm text-gray-500">Manage size, temperature, and other variant options</p>
                                    </div>

                                    <div className="flex flex-wrap items-center gap-3">
                                        <div className="relative">
                                            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                                                    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10a7 7 0 1 0 14 0a7 7 0 1 0-14 0m18 11l-6-6" />
                                                </svg>
                                            </span>
                                            <input
                                                type="text"
                                                placeholder="Search variants..."
                                                value={variantSearchQuery}
                                                onChange={(e) => setVariantSearchQuery(e.target.value)}
                                                className="pl-9 pr-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 w-52"
                                            />
                                        </div>

                                        <button
                                            onClick={openArchivedViewerModal}
                                            className="p-2 bg-gray-100 text-gray-700 hover:bg-gray-200 rounded-lg"
                                            title="View Archived"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                                <path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m3 6v10h12V9zm2 2h8v2H8zm0 4h8v2H8zM5 5v2h14V5z" />
                                            </svg>
                                        </button>

                                        <button
                                            onClick={() => {
                                                setVariantFormData({ category: "", variant_name: "", price: "", applicable_categories: [] })
                                                setVariantCategorySearch("")
                                                setOpenVariantCategoryDropdown(false)
                                                setViewOnlyVariant(false)
                                                setShowAddVariantModal(true)
                                            }}
                                            className="px-4 py-2 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700 flex items-center gap-2"
                                        >
                                            <span>+</span>
                                            <span>Request Add Variant</span>
                                        </button>
                                    </div>
                                </div>

                                <div className="flex gap-4 overflow-x-auto pb-1 scrollbar-hide">
                                    {["All", ...new Set(variants.map(v => v.category).filter(Boolean))].map(cat => (
                                        <button
                                            key={cat}
                                            onClick={() => setFilterVariantCategory(cat)}
                                            className={`px-4 py-2 rounded-lg text-sm font-medium flex-shrink-0 whitespace-nowrap ${filterVariantCategory === cat
                                                ? 'bg-indigo-600 text-white'
                                                : 'text-gray-600 hover:bg-gray-100'
                                                }`}
                                        >
                                            {cat}
                                            {cat !== 'All' && (
                                                <span className={`ml-1.5 px-1.5 py-0.5 rounded-full text-[10px] font-bold ${filterVariantCategory === cat
                                                    ? 'bg-white/30 text-white'
                                                    : 'bg-gray-100 text-gray-500'
                                                    }`}>
                                                    {loadingVariants ? <SkeletonBlock className="w-3 h-2.5 inline-block" /> : variants.filter(v => v.category === cat).length}
                                                </span>
                                            )}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="overflow-x-auto">
                            <table className="w-full">
                                <thead className="bg-gray-50 border-b border-gray-200">
                                    <tr>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Variant Name</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Category</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Price</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Applicable Categories</th>
                                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>                                 </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {loadingVariants ? (
                                        <tr><td colSpan="4" className="px-6 py-8 text-center text-gray-500">Loading variants...</td></tr>
                                    ) : filteredVariants.length === 0 ? (
                                        <tr><td colSpan="4" className="px-6 py-8 text-center text-gray-500">No variants found</td></tr>
                                    ) : (
                                        pagedVariants.map((variant) => (
                                            <tr key={variant.variant_id} className="hover:bg-gray-50">
                                                <td className="px-6 py-4 whitespace-nowrap font-medium text-gray-800">
                                                    {variant.variant_name}
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-gray-800">
                                                    {variant.category}
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-gray-800">
                                                    ₱{parseFloat(variant.price || 0).toFixed(2)}
                                                </td>
                                                <td className="px-6 py-4">
                                                    {(variant.applicable_categories || []).length === 0 ? (
                                                        <span className="text-xs text-gray-400 italic">None</span>
                                                    ) : (
                                                        <div className="flex flex-wrap gap-1">
                                                            {variant.applicable_categories.map(cat => (
                                                                <span key={cat} className="px-2 py-0.5 rounded-full text-xs font-medium bg-indigo-50 text-indigo-700 border border-indigo-100">
                                                                    {cat}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    )}
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <div className="flex items-center gap-2 justify-end">
                                                        <button
                                                            onClick={() => {
                                                                handleEditVariantClick(variant)
                                                                setViewOnlyVariant(true)
                                                                setShowEditVariantModal(true)
                                                            }}
                                                            className="p-1 text-gray-600 hover:bg-gray-100 rounded"
                                                            title="View variant"
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3" /></svg>
                                                        </button>
                                                        {(() => {
                                                            const hasPending = myPriceRequests.some(
                                                                r => r.item_id === variant.variant_id &&
                                                                    r.item_type === 'variant' &&
                                                                    r.status === 'pending'
                                                            )
                                                            return (
                                                                <button
                                                                    onClick={() => !hasPending && handlePriceChangeRequest(variant, 'variant')}
                                                                    disabled={hasPending}
                                                                    className={`p-1 rounded ${hasPending ? 'text-gray-300 cursor-not-allowed' : 'text-emerald-600 hover:bg-emerald-50'}`}
                                                                      title={hasPending ? 'A price change request is already pending' : 'Request Price Change'}
                                                                >
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                                                        <text x="12" y="17.5" textAnchor="middle" fontSize="18" fontWeight="700" fill="currentColor" fontFamily="Arial, sans-serif">₱</text>
                                                                    </svg>
                                                                </button>
                                                            )
                                                        })()}

                                                        <button
                                                            onClick={() => handleDeleteRequest(variant, 'variant')}  
                                                            className="p-1 text-red-600 hover:bg-red-50 rounded"
                                                            title="Request Delete"
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                                                <path fill="currentColor" d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zM17 6H7v13h10zM9 17h2V8H9zm4 0h2V8h-2z" />
                                                            </svg>
                                                        </button>

                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                            <Pagination
                                page={variantsPage}
                                totalItems={filteredVariants.length}
                                pageSize={ITEMS_PAGE_SIZE}
                                onPageChange={setVariantsPage}
                            />
                        </div>
                    </div>
                )}

                {/* MODIFIERS TAB */}
                {activeTab === "modifiers" && (
                    <div className="bg-white rounded-lg shadow-sm">
                        <div className="p-6 border-b border-gray-200">
                            <div className="flex flex-col gap-4">
                                <div className="flex flex-col gap-2 lg:flex-row lg:items-start lg:justify-between">
                                    <div>
                                        <h2 className="text-xl font-bold text-gray-800">Modifiers</h2>
                                        <p className="text-sm text-gray-500">Manage add-ons, toppings, and other optional modifiers</p>
                                    </div>

                                    <div className="flex flex-wrap items-center gap-3">
                                        <div className="relative">
                                            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                                                    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10a7 7 0 1 0 14 0a7 7 0 1 0-14 0m18 11l-6-6" />
                                                </svg>
                                            </span>
                                            <input
                                                type="text"
                                                placeholder="Search modifiers..."
                                                value={modifierSearchQuery}
                                                onChange={(e) => setModifierSearchQuery(e.target.value)}
                                                className="pl-9 pr-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 w-52"
                                            />
                                        </div>

                                        <button
                                            onClick={openArchivedViewerModal}
                                            className="p-2 bg-gray-100 text-gray-700 hover:bg-gray-200 rounded-lg"
                                            title="View Archived"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                                <path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m3 6v10h12V9zm2 2h8v2H8zm0 4h8v2H8zM5 5v2h14V5z" />
                                            </svg>
                                        </button>

                                        <button
                                            onClick={() => {
                                                setModifierFormData({ modifier_name: "", category: "", price: "", applicable_categories: [], ingredient_id: "" })
                                                setModifierCategorySearch("")
                                                setModifierIngredientSearch("")
                                                setViewOnlyModifier(false)
                                                setShowAddModifierModal(true)
                                            }}
                                            className="px-4 py-2 bg-purple-600 text-white rounded-lg font-medium hover:bg-purple-700 flex items-center gap-2"
                                        >
                                            <span>+</span>
                                            <span>Request Add Modifier</span>
                                        </button>
                                    </div>
                                </div>

                                <div className="flex gap-4 overflow-x-auto pb-1 scrollbar-hide">
                                    {['All', ...new Set(modifiers.map(m => m.category).filter(Boolean))].map(cat => (
                                        <button
                                            key={cat}
                                            onClick={() => setFilterModifierCategory(cat)}
                                            className={`px-4 py-2 rounded-lg text-sm font-medium flex-shrink-0 whitespace-nowrap ${filterModifierCategory === cat
                                                ? 'bg-purple-600 text-white'
                                                : 'text-gray-600 hover:bg-gray-100'
                                                }`}
                                        >
                                            {cat}
                                            {cat !== 'All' && (
                                                <span className={`ml-1.5 px-1.5 py-0.5 rounded-full text-[10px] font-bold ${filterModifierCategory === cat
                                                    ? 'bg-white/30 text-white'
                                                    : 'bg-gray-100 text-gray-500'
                                                    }`}>
                                                    {loadingModifiers ? <SkeletonBlock className="w-3 h-2.5 inline-block" /> : modifiers.filter(m => m.category === cat).length}
                                                </span>
                                            )}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="overflow-x-auto">
                            <table className="w-full">
                                <thead className="bg-gray-50 border-b border-gray-200">
                                    <tr>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Modifier Name</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Category</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Price</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Applicable Categories</th>
                                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {loadingModifiers ? (
                                        <tr><td colSpan="4" className="px-6 py-8 text-center text-gray-500">Loading modifiers...</td></tr>
                                    ) : filteredModifiers.length === 0 ? (
                                        <tr><td colSpan="4" className="px-6 py-8 text-center text-gray-500">{modifierSearchQuery || filterModifierCategory !== "All" ? "No modifiers match your search" : "No modifiers found. Add your first modifier!"}</td></tr>
                                    ) : (
                                        pagedModifiers.map((modifier) => (
                                            <tr key={modifier.modifier_id} className="hover:bg-gray-50">
                                                <td className="px-6 py-4 whitespace-nowrap"><p className="font-medium text-gray-800">{modifier.modifier_name}</p></td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <span className={`px-3 py-1 rounded-full text-sm font-medium ${getCategoryBadgeStyle(modifier.category)}`}>{modifier.category}</span>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-gray-800">
                                                    {parseFloat(modifier.price) === 0 ? <span className="text-gray-400 text-sm">No charge</span> : `₱${parseFloat(modifier.price).toFixed(2)}`}
                                                </td>
                                                <td className="px-6 py-4">
                                                    {(modifier.applicable_categories || []).length === 0 ? (
                                                        <span className="text-xs text-gray-400 italic">None</span>
                                                    ) : (
                                                        <div className="flex flex-wrap gap-1">
                                                            {modifier.applicable_categories.map(cat => (
                                                                <span key={cat} className="px-2 py-0.5 rounded-full text-xs font-medium bg-purple-50 text-purple-700 border border-purple-100">
                                                                    {cat}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    )}
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <div className="flex items-center gap-2 justify-end">
                                                        <button
                                                            onClick={() => {
                                                                handleEditModifierClick(modifier)
                                                                setViewOnlyModifier(true)
                                                                setShowEditModifierModal(true)
                                                            }}
                                                            className="p-1 text-gray-600 hover:bg-gray-100 rounded" title="View modifier">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3" /></svg>
                                                        </button>

                                                        <button
                                                            onClick={() => handlePriceChangeRequest(modifier, 'modifier')}
                                                            className="p-1 text-emerald-600 hover:bg-emerald-50 rounded"
                                                            title="Request Price Change"
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                                                <text x="12" y="17.5" textAnchor="middle" fontSize="18" fontWeight="700" fill="currentColor" fontFamily="Arial, sans-serif">₱</text>
                                                            </svg>
                                                        </button>

                                                        <button
                                                            onClick={() => handleDeleteRequest(modifier, 'modifier')}
                                                            className="p-1 text-red-600 hover:bg-red-50 rounded"
                                                            title="Request Delete"
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                                                <path fill="currentColor" d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zM17 6H7v13h10zM9 17h2V8H9zm4 0h2V8h-2z" />
                                                            </svg>
                                                        </button>

                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                            <Pagination
                                page={modifiersPage}
                                totalItems={filteredModifiers.length}
                                pageSize={ITEMS_PAGE_SIZE}
                                onPageChange={setModifiersPage}
                            />
                        </div>
                    </div>
                )}

            </div>

            {/* Assign Variants Modal */}
            {showAssignVariantsModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={closeAssignVariantsModal}></div>

                    <div className="relative bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[85vh] flex flex-col">
                        <div className="border-b border-gray-200 px-6 py-4 flex-shrink-0">
                            <h2 className="text-xl font-bold text-gray-800">Assign Variants</h2>
                            <p className="text-sm text-gray-500 mt-0.5">
                                Select which variants apply to <span className="font-medium text-gray-700">{selectedItemForVariants?.name}</span>
                            </p>
                        </div>

                        {/* Category filter bar */}
                        <div className="px-6 py-3 border-b border-gray-100 flex-shrink-0 flex flex-wrap gap-2">
                            {['All', ...new Set(variants.map(v => v.category).filter(Boolean))].map(cat => (
                                <button
                                    key={cat}
                                    onClick={() => setAssignVariantCategoryFilter(cat)}
                                    className={`px-3 py-1 rounded-full text-xs font-medium transition-colors ${assignVariantCategoryFilter === cat
                                        ? 'bg-indigo-600 text-white'
                                        : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                                        }`}
                                >
                                    {cat}
                                </button>
                            ))}
                        </div>

                        {/* Search bar */}
                        <div className="px-6 py-3 border-b border-gray-100 flex-shrink-0">
                            <div className="relative">
                                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                                        <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10a7 7 0 1 0 14 0a7 7 0 1 0-14 0m18 11l-6-6" />
                                    </svg>
                                </span>
                                <input
                                    type="text"
                                    placeholder="Search variants..."
                                    value={assignVariantSearch}
                                    onChange={(e) => setAssignVariantSearch(e.target.value)}
                                    className="w-full pl-9 pr-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-400"
                                />
                            </div>
                        </div>

                        <div className="overflow-y-auto flex-1 px-6 py-4">
                            {loadingVariantAssignments ? (
                                <div className="flex items-center justify-center py-12">
                                    <div className="text-gray-400 text-sm">Loading variants...</div>
                                </div>
                            ) : variants.length === 0 ? (
                                <div className="text-center py-10">
                                    <p className="text-gray-500 text-sm">No variants exist yet.</p>
                                    <p className="text-gray-400 text-xs mt-1">Add variants from the Variants tab first.</p>
                                </div>
                            ) : (() => {
                                const itemCategory = selectedItemForVariants?.category || ''

                                const relevantVariants = variants.filter(v => {
                                    if (v.is_archived) return false
                                    const cats = v.applicable_categories || []
                                    const isApplicable = cats.length > 0 && cats.includes(itemCategory)
                                    const matchesFilter = assignVariantCategoryFilter === 'All' || v.category === assignVariantCategoryFilter
                                    const matchesSearch = assignVariantSearch === '' ||
                                        String(v.variant_name || '').toLowerCase().includes(assignVariantSearch.toLowerCase()) ||
                                        String(v.category || '').toLowerCase().includes(assignVariantSearch.toLowerCase())
                                    return isApplicable && matchesFilter && matchesSearch
                                })

                                if (relevantVariants.length === 0) {
                                    return (
                                        <div className="text-center py-10">
                                            <p className="text-gray-500 text-sm">
                                                {assignVariantSearch ? 'No variants match your search.' : 'No variants available for this item\'s category.'}
                                            </p>
                                            {!assignVariantSearch && (
                                                <p className="text-gray-400 text-xs mt-1">Update variant applicable categories in the Variants tab.</p>
                                            )}
                                        </div>
                                    )
                                }

                                const grouped = Object.entries(
                                    relevantVariants.reduce((acc, variant) => {
                                        if (!acc[variant.category]) acc[variant.category] = []
                                        acc[variant.category].push(variant)
                                        return acc
                                    }, {})
                                ).sort(([a], [b]) => a.localeCompare(b))

                                return (
                                    <div className="space-y-5">
                                        {grouped.map(([category, categoryVariants]) => (
                                            <div key={category}>
                                                <div className="flex items-center gap-2 mb-2">
                                                    <span className="px-2.5 py-0.5 rounded-full text-xs font-semibold bg-indigo-100 text-indigo-700">
                                                        {category}
                                                    </span>
                                                    <span className="text-xs text-gray-400">
                                                        {categoryVariants.filter(v => assignedVariantIds.has(v.variant_id)).length} / {categoryVariants.length} selected
                                                    </span>
                                                </div>
                                                <div className="space-y-1.5 pl-1">
                                                    {categoryVariants
                                                        .sort((a, b) => String(a.variant_name || '').localeCompare(String(b.variant_name || '')))
                                                        .map((variant) => {
                                                            const isChecked = assignedVariantIds.has(variant.variant_id)
                                                            return (
                                                                <label
                                                                    key={variant.variant_id}
                                                                    className={`flex items-center justify-between gap-3 px-3 py-2.5 rounded-lg border cursor-pointer transition-colors ${isChecked
                                                                        ? 'bg-indigo-50 border-indigo-300'
                                                                        : 'bg-white border-gray-200 hover:bg-gray-50'
                                                                        }`}
                                                                >
                                                                    <div className="flex items-center gap-3">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={isChecked}
                                                                            onChange={() => toggleVariantAssignment(variant.variant_id)}
                                                                            className="w-4 h-4 accent-indigo-600 cursor-pointer"
                                                                        />
                                                                        <div>
                                                                            <span className={`text-sm font-medium ${isChecked ? 'text-indigo-800' : 'text-gray-700'}`}>
                                                                                {variant.variant_name}
                                                                            </span>
                                                                            {(variant.applicable_categories || []).length > 0 && (
                                                                                <p className="text-xs text-gray-400 mt-0.5">
                                                                                    {variant.applicable_categories.join(', ')}
                                                                                </p>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <span className={`text-sm flex-shrink-0 ${isChecked ? 'text-indigo-600' : 'text-gray-400'}`}>
                                                                        {parseFloat(variant.price) === 0 ? 'No charge' : `+₱${parseFloat(variant.price).toFixed(2)}`}
                                                                    </span>
                                                                </label>
                                                            )
                                                        })}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )
                            })()}
                        </div>

                        <div className="border-t border-gray-200 px-6 py-4 flex-shrink-0 flex items-center justify-between">
                            <span className="text-sm text-gray-500">
                                {assignedVariantIds.size} variant{assignedVariantIds.size !== 1 ? 's' : ''} selected
                            </span>
                            <div className="flex gap-3">
                                <button onClick={closeAssignVariantsModal} className="px-5 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300">
                                    Cancel
                                </button>
                                <button
                                    onClick={() => {
                                        setAssignVariantRequestReason('')
                                        setShowAssignVariantRequestModal(true)
                                    }}
                                    disabled={!hasAssignVariantChanges}
                                    className={`px-5 py-2 rounded-lg font-medium ${!hasAssignVariantChanges
                                        ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                        : 'bg-indigo-600 text-white hover:bg-indigo-700'
                                        }`}
                                >
                                    Request Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}



            {/* Assign Modifiers Modal */}
            {showAssignModifiersModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={closeAssignModifiersModal}></div>
                    <div className="relative bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[85vh] flex flex-col">
                        <div className="border-b border-gray-200 px-6 py-4 flex-shrink-0">
                            <h2 className="text-xl font-bold text-gray-800">Assign Modifiers</h2>
                            <p className="text-sm text-gray-500 mt-0.5">
                                Select which modifiers apply to <span className="font-medium text-gray-700">{selectedItemForModifiers?.name}</span>
                            </p>
                        </div>

                        {/* Category filter bar */}
                        <div className="px-6 py-3 border-b border-gray-100 flex-shrink-0 flex flex-wrap gap-2">
                            {['All', ...new Set(modifiers.map(m => m.category).filter(Boolean))].map(cat => (
                                <button
                                    key={cat}
                                    onClick={() => setAssignModifierCategoryFilter(cat)}
                                    className={`px-3 py-1 rounded-full text-xs font-medium transition-colors ${assignModifierCategoryFilter === cat
                                        ? 'bg-purple-600 text-white'
                                        : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                                        }`}
                                >
                                    {cat}
                                </button>
                            ))}
                        </div>

                        {/* Search bar */}
                        <div className="px-6 py-3 border-b border-gray-100 flex-shrink-0">
                            <div className="relative">
                                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                                        <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10a7 7 0 1 0 14 0a7 7 0 1 0-14 0m18 11l-6-6" />
                                    </svg>
                                </span>
                                <input
                                    type="text"
                                    placeholder="Search modifiers..."
                                    value={assignModifierSearch}
                                    onChange={(e) => setAssignModifierSearch(e.target.value)}
                                    className="w-full pl-9 pr-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-400"
                                />
                            </div>
                        </div>

                        <div className="overflow-y-auto flex-1 px-6 py-4">
                            {loadingAssignments ? (
                                <div className="flex items-center justify-center py-12">
                                    <div className="text-gray-400 text-sm">Loading modifiers...</div>
                                </div>
                            ) : modifiers.length === 0 ? (
                                <div className="text-center py-10">
                                    <p className="text-gray-500 text-sm">No modifiers exist yet.</p>
                                    <p className="text-gray-400 text-xs mt-1">Add modifiers from the Modifiers tab first.</p>
                                </div>
                            ) : (() => {
                                const itemCategory = selectedItemForModifiers?.category || ''

                                const relevantModifiers = modifiers.filter(m => {
                                    if (m.is_archived) return false
                                    const cats = m.applicable_categories || []
                                    const isApplicable = cats.length > 0 && cats.includes(itemCategory)
                                    const matchesFilter = assignModifierCategoryFilter === 'All' || m.category === assignModifierCategoryFilter
                                    const matchesSearch = assignModifierSearch === '' ||
                                        String(m.modifier_name || '').toLowerCase().includes(assignModifierSearch.toLowerCase()) ||
                                        String(m.category || '').toLowerCase().includes(assignModifierSearch.toLowerCase())
                                    return isApplicable && matchesFilter && matchesSearch
                                })

                                if (relevantModifiers.length === 0) {
                                    return (
                                        <div className="text-center py-10">
                                            <p className="text-gray-500 text-sm">
                                                {assignModifierSearch ? 'No modifiers match your search.' : 'No modifiers available for this item\'s category.'}
                                            </p>
                                            {!assignModifierSearch && (
                                                <p className="text-gray-400 text-xs mt-1">Update modifier applicable categories in the Modifiers tab.</p>
                                            )}
                                        </div>
                                    )
                                }

                                const grouped = Object.entries(
                                    relevantModifiers.reduce((acc, mod) => {
                                        if (!acc[mod.category]) acc[mod.category] = []
                                        acc[mod.category].push(mod)
                                        return acc
                                    }, {})
                                ).sort(([a], [b]) => a.localeCompare(b))

                                return (
                                    <div className="space-y-5">
                                        {grouped.map(([category, mods]) => (
                                            <div key={category}>
                                                <div className="flex items-center gap-2 mb-2">
                                                    <span className={`px-2.5 py-0.5 rounded-full text-xs font-semibold ${getCategoryBadgeStyle(category)}`}>
                                                        {category}
                                                    </span>
                                                    <span className="text-xs text-gray-400">
                                                        {mods.filter(m => assignedModifierIds.has(m.modifier_id)).length} / {mods.length} selected
                                                    </span>
                                                </div>
                                                <div className="space-y-1.5 pl-1">
                                                    {mods.map(modifier => {
                                                        const isChecked = assignedModifierIds.has(modifier.modifier_id)
                                                        return (
                                                            <label
                                                                key={modifier.modifier_id}
                                                                className={`flex items-center justify-between gap-3 px-3 py-2.5 rounded-lg border cursor-pointer transition-colors ${isChecked
                                                                    ? 'bg-orange-50 border-orange-300'
                                                                    : 'bg-white border-gray-200 hover:bg-gray-50'
                                                                    }`}
                                                            >
                                                                <div className="flex items-center gap-3">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={isChecked}
                                                                        onChange={() => toggleModifierAssignment(modifier.modifier_id)}
                                                                        className="w-4 h-4 accent-orange-500 cursor-pointer"
                                                                    />
                                                                    <div>
                                                                        <span className={`text-sm font-medium ${isChecked ? 'text-orange-800' : 'text-gray-700'}`}>
                                                                            {modifier.modifier_name}
                                                                        </span>
                                                                        {(modifier.applicable_categories || []).length > 0 && (
                                                                            <p className="text-xs text-gray-400 mt-0.5">
                                                                                {modifier.applicable_categories.join(', ')}
                                                                            </p>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <span className={`text-sm flex-shrink-0 ${isChecked ? 'text-orange-600' : 'text-gray-400'}`}>
                                                                    {parseFloat(modifier.price) === 0 ? 'Free' : `+₱${parseFloat(modifier.price).toFixed(2)}`}
                                                                </span>
                                                            </label>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )
                            })()}
                        </div>

                        <div className="border-t border-gray-200 px-6 py-4 flex-shrink-0 flex items-center justify-between">
                            <span className="text-sm text-gray-500">
                                {assignedModifierIds.size} modifier{assignedModifierIds.size !== 1 ? 's' : ''} selected
                            </span>
                            <div className="flex gap-3">
                                <button onClick={closeAssignModifiersModal} className="px-5 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300">
                                    Cancel
                                </button>
                                <button
                                    onClick={() => {
                                        setAssignModifierRequestReason('')
                                        setShowAssignModifierRequestModal(true)
                                    }}
                                    disabled={!hasModifierAssignmentChanges}
                                    className={`px-5 py-2 rounded-lg font-medium ${!hasModifierAssignmentChanges
                                        ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                        : 'bg-[#FF6F3C] text-white hover:bg-[#ff4c0b]'
                                        }`}
                                >
                                    Request Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Add Item Modal */}
            {showAddItemModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => confirmDiscardChanges(hasAddItemChanges, () => { setShowAddItemModal(false); resetItemForm() })}></div>
                    <div className="relative bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                        <div className="border-b border-gray-200 px-6 py-4"><h2 className="text-xl font-bold text-gray-800">Add New Menu Item</h2></div>
                        <div className="px-6 py-6 space-y-4">
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">                                <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Item Name <span className="text-red-500">*</span></label>
                                <input
                                    type="text"
                                    placeholder="e.g. Iced Caramel Macchiato"
                                    value={itemFormData.name}
                                    onChange={(e) => setItemFormData({ ...itemFormData, name: e.target.value })}
                                    maxLength={50}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#A0826D]"
                                />
                                <p className="text-xs text-gray-500 mt-1">{itemFormData.name.length}/50 characters</p>
                            </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Base Price <span className="text-red-500">*</span></label>
                                    <input
                                        type="number"
                                        placeholder="e.g. 180.00"
                                        step="0.01"
                                        min="0"
                                        max="9999"
                                        value={itemFormData.item_price}
                                        onChange={(e) => {
                                            const raw = e.target.value.replace('.', '').replace('-', '')
                                            if (raw.length <= MAX_PRICE_LENGTH) {
                                                setItemFormData({ ...itemFormData, item_price: e.target.value })
                                            }
                                        }}
                                        onKeyDown={handlePriceKeyDown}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#A0826D]"
                                    />
                                    <p className="text-xs text-gray-500 mt-1">{String(itemFormData.item_price).replace('.', '').replace('-', '').length} / 4 digits</p>
                                </div>
                                <div className="relative" ref={itemCategoryDropdownRef}>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Category <span className="text-red-500">*</span>
                                    </label>

                                    <input
                                        type="text"
                                        value={itemFormData.category}
                                        onFocus={() => {
                                            setItemCategorySearch(itemFormData.category || "")
                                            setOpenItemCategoryDropdown(true)
                                        }}
                                        onChange={(e) => {
                                            setItemFormData({ ...itemFormData, category: e.target.value })
                                            setItemCategorySearch(e.target.value)
                                            setOpenItemCategoryDropdown(true)
                                        }}
                                        maxLength={30}
                                        placeholder="Search or type a category..."
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#A0826D]"
                                    />

                                    {openItemCategoryDropdown && (
                                        <div className="absolute z-20 mt-1 w-full max-h-56 overflow-y-auto rounded-lg border border-gray-300 bg-white shadow-lg">
                                            {filteredItemCategoryOptions.length === 0 ? (
                                                <div className="px-3 py-2 text-sm text-gray-500">
                                                    No existing categories found. Continue typing to create a new one.
                                                </div>
                                            ) : (
                                                filteredItemCategoryOptions.map((category) => (
                                                    <button
                                                        key={category}
                                                        type="button"
                                                        onClick={() => {
                                                            setItemFormData({ ...itemFormData, category })
                                                            setItemCategorySearch(category)
                                                            setOpenItemCategoryDropdown(false)
                                                        }}
                                                        className="w-full border-b border-gray-100 px-3 py-2 text-left hover:bg-gray-50 last:border-b-0"
                                                    >
                                                        <div className="text-sm font-medium text-gray-800">
                                                            {category}
                                                        </div>
                                                    </button>
                                                ))
                                            )}
                                        </div>
                                    )}

                                    <p className="text-xs text-gray-500 mt-1">
                                        Select an existing category or type a new one.
                                    </p>
                                </div>
                                <div className="relative" ref={itemClassificationDropdownRef}>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Classification <span className="text-red-500">*</span>
                                    </label>

                                    <input
                                        type="text"
                                        value={itemFormData.classification}
                                        onFocus={() => {
                                            setItemClassificationSearch(itemFormData.classification || "")
                                            setOpenItemClassificationDropdown(true)
                                        }}
                                        onChange={(e) => {
                                            setItemFormData({ ...itemFormData, classification: e.target.value })
                                            setItemClassificationSearch(e.target.value)
                                            setOpenItemClassificationDropdown(true)
                                        }}
                                        maxLength={30}
                                        placeholder="Search or type a classification..."
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#A0826D]"
                                    />

                                    {openItemClassificationDropdown && (
                                        <div className="absolute z-20 mt-1 w-full max-h-56 overflow-y-auto rounded-lg border border-gray-300 bg-white shadow-lg">
                                            {filteredItemClassificationOptions.length === 0 ? (
                                                <div className="px-3 py-2 text-sm text-gray-500">
                                                    No existing classifications found. Continue typing to create a new one.
                                                </div>
                                            ) : (
                                                filteredItemClassificationOptions.map((classification) => (
                                                    <button
                                                        key={classification}
                                                        type="button"
                                                        onClick={() => {
                                                            setItemFormData({ ...itemFormData, classification })
                                                            setItemClassificationSearch(classification)
                                                            setOpenItemClassificationDropdown(false)
                                                        }}
                                                        className="w-full border-b border-gray-100 px-3 py-2 text-left hover:bg-gray-50 last:border-b-0"
                                                    >
                                                        <div className="text-sm font-medium text-gray-800">
                                                            {classification}
                                                        </div>
                                                    </button>
                                                ))
                                            )}
                                        </div>
                                    )}

                                    <p className="text-xs text-gray-500 mt-1">
                                        Select an existing classification or type a new one.
                                    </p>
                                </div>
                                <div className="col-span-2">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Item Image</label>

                                    <div className="inline-flex mb-3 rounded-lg bg-gray-100 p-1">
                                        <button
                                            type="button"
                                            onClick={() => setImageInputMode('upload')}
                                            className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${imageInputMode === 'upload'
                                                ? 'bg-[#FF6F3C] text-white shadow-sm'
                                                : 'bg-transparent text-gray-600 hover:text-gray-800'
                                                }`}
                                        >
                                            Upload Image
                                        </button>

                                        <button
                                            type="button"
                                            onClick={() => setImageInputMode('url')}
                                            className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${imageInputMode === 'url'
                                                ? 'bg-[#FF6F3C] text-white shadow-sm'
                                                : 'bg-transparent text-gray-600 hover:text-gray-800'
                                                }`}
                                        >
                                            Use Image URL
                                        </button>
                                    </div>

                                    {imageInputMode === 'upload' ? (
                                        <div className="space-y-2">
                                            <input
                                                type="file"
                                                accept="image/png,image/jpeg,image/webp"
                                                onChange={(e) => setItemImageFile(e.target.files?.[0] || null)}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#A0826D]"
                                            />
                                            <p className="text-xs text-gray-500">
                                                Accepted: JPG, PNG, WEBP. Max size: 5MB.
                                            </p>
                                        </div>
                                    ) : (
                                        <input
                                            type="text"
                                            value={itemFormData.item_img}
                                            onChange={(e) => setItemFormData({ ...itemFormData, item_img: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#A0826D]"
                                            placeholder="https://images.example.com/spanish-latte.jpg"
                                        />
                                    )}

                                    {(itemFormData.item_img || itemImageFile) && (
                                        <p className="text-xs text-gray-500 mt-2">
                                            {itemImageFile ? `Selected file: ${itemImageFile.name}` : 'Image URL provided'}
                                        </p>
                                    )}
                                </div>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Description <span className="text-red-500">*</span></label>
                                <textarea
                                    value={itemFormData.description}
                                    placeholder="e.g. Freshly brewed espresso with milk and caramel drizzle, served over ice."
                                    onChange={(e) => setItemFormData({ ...itemFormData, description: e.target.value })} rows="3"
                                    maxLength={100}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#A0826D]"></textarea>
                                <p className="text-xs text-gray-500 mt-1">{itemFormData.description.length}/100 characters (min: 10)</p>
                            </div>

                        </div>
                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3">
                            <button onClick={() => confirmDiscardChanges(hasAddItemChanges, () => { setShowAddItemModal(false); resetItemForm() })} className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300">Cancel</button>
                            <button
                                onClick={handleOpenAddItemRequestModal}
                                disabled={!hasAddItemChanges}
                                className={`px-6 py-2 rounded-lg font-medium ${!hasAddItemChanges
                                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                    : 'bg-[#FF6F3C] text-white hover:bg-[#7A4D32]'
                                    }`}
                            >
                                Request Add
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Item Modal */}
            {showEditItemModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => { setShowEditItemModal(false); setEditingItem(null); resetItemForm(); }}></div>
                    <div className="relative bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                        <div className="border-b border-gray-200 px-6 py-4">
                            <h2 className="text-xl font-bold text-gray-800">Item Details</h2>
                            <p className="text-sm text-gray-500 mt-1">View only — contact Super Admin to make changes.</p>
                        </div>
                        <div className="px-6 py-6 space-y-4">
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">                                <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Item Name <span className="text-red-500">*</span></label>
                                <input type="text" value={itemFormData.name} readOnly className="w-full px-3 py-2 border border-gray-200 rounded-lg bg-gray-50 text-gray-700 cursor-default" />
                            </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Price</label>
                                    <input
                                        type="text"
                                        value={`₱${parseFloat(itemFormData.effective_price ?? itemFormData.item_price ?? 0).toFixed(2)}`}
                                        readOnly
                                        className="w-full px-3 py-2 border border-gray-200 rounded-lg bg-gray-50 text-gray-700 cursor-default"
                                    />
                                    {itemFormData.has_price_override && (
                                        <p className="text-xs text-gray-400 mt-1">
                                            Branch price override · Master price: ₱{parseFloat(itemFormData.master_price ?? 0).toFixed(2)}
                                        </p>
                                    )}
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Category</label>
                                    <input type="text" value={itemFormData.category} readOnly className="w-full px-3 py-2 border border-gray-200 rounded-lg bg-gray-50 text-gray-700 cursor-default" />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Classification</label>
                                    <input type="text" value={itemFormData.classification} readOnly className="w-full px-3 py-2 border border-gray-200 rounded-lg bg-gray-50 text-gray-700 cursor-default" />
                                </div>
                                <div className="col-span-2">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Item Image</label>
                                    {itemFormData.item_img ? (
                                        <img src={itemFormData.item_img} alt={itemFormData.name} className="w-24 h-24 rounded-lg object-cover border border-gray-200" />
                                    ) : (
                                        <p className="text-sm text-gray-400 italic">No image available</p>
                                    )}
                                </div>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Description <span className="text-red-500">*</span></label>
                                <textarea value={itemFormData.description || 'No description.'} readOnly rows="3" className="w-full px-3 py-2 border border-gray-200 rounded-lg bg-gray-50 text-gray-700 cursor-default resize-none"></textarea>
                            </div>
                            {/* <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Available in Branches</label>
                                <div className="grid grid-cols-2 gap-2 max-h-40 overflow-y-auto border border-gray-200 rounded-lg p-3 bg-gray-50">
                                    {branches.map(branch => {
                                        const isSelected = selectedBranchIds.has(branch.branch_id)
                                        return (
                                            <div
                                                key={branch.branch_id}
                                                className={`flex items-center gap-2 p-2 rounded border ${isSelected ? 'bg-orange-50 border-orange-200' : 'border-gray-200 opacity-40'}`}
                                            >
                                                <div className={`w-3 h-3 rounded-full flex-shrink-0 ${isSelected ? 'bg-orange-400' : 'bg-gray-300'}`} />
                                                <span className="text-sm text-gray-700">{branch.name}</span>
                                            </div>
                                        )
                                    })}
                                </div>
                                <p className="text-xs text-gray-500 mt-2">{selectedBranchIds.size} of {branches.length} branches</p>
                            </div> */}
                        </div>
                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end">
                            <button
                                onClick={() => { setShowEditItemModal(false); setEditingItem(null); resetItemForm(); }}
                                className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Variant Rule Modal */}
            {showVariantRulesModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div
                        className="absolute inset-0 bg-black bg-opacity-50"
                        onClick={closeVariantRulesModal}
                    ></div>

                    <div className="relative bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
                        <div className="border-b border-gray-200 px-6 py-4">
                            <h2 className="text-xl font-bold text-gray-800">Variant Ingredient Rules</h2>
                            <p className="text-sm text-gray-600 mt-1">
                                For: {selectedItemForVariantRules?.name}
                            </p>
                        </div>

                        <div className="px-6 py-6 space-y-6">
                            {itemVariants.length === 0 ? (
                                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 text-sm text-yellow-800">
                                    This item has no variants yet. Add variants first before creating variant ingredient rules.
                                </div>
                            ) : (
                                <>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div className="relative" ref={variantDropdownRef}>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Variant <span className="text-red-500">*</span>
                                            </label>

                                            <input
                                                type="text"
                                                value={
                                                    variantRuleFormData.variant_id
                                                        ? itemVariants.find(variant => String(variant.variant_id) === String(variantRuleFormData.variant_id))
                                                            ? `${itemVariants.find(variant => String(variant.variant_id) === String(variantRuleFormData.variant_id))?.category || ''}${itemVariants.find(variant => String(variant.variant_id) === String(variantRuleFormData.variant_id))?.category ? ' - ' : ''}${itemVariants.find(variant => String(variant.variant_id) === String(variantRuleFormData.variant_id))?.variant_name || ''}`
                                                            : variantRuleVariantSearch
                                                        : variantRuleVariantSearch
                                                }
                                                onFocus={() => setOpenVariantDropdown(true)}
                                                onChange={(e) => {
                                                    setVariantRuleFormData(prev => ({
                                                        ...prev,
                                                        variant_id: ''
                                                    }))
                                                    setVariantRuleVariantSearch(e.target.value)
                                                    setOpenVariantDropdown(true)
                                                }}
                                                placeholder="Search and select variant..."
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#A0826D]"
                                            />

                                            {openVariantDropdown && (
                                                <div className="absolute z-20 mt-1 w-full max-h-56 overflow-y-auto rounded-lg border border-gray-300 bg-white shadow-lg">
                                                    {filteredVariantOptions.length === 0 ? (
                                                        <div className="px-3 py-2 text-sm text-gray-500">
                                                            No variants found.
                                                        </div>
                                                    ) : (
                                                        filteredVariantOptions.map((variant) => (
                                                            <button
                                                                key={variant.variant_id}
                                                                type="button"
                                                                onClick={() => {
                                                                    setVariantRuleFormData(prev => ({
                                                                        ...prev,
                                                                        variant_id: variant.variant_id
                                                                    }))
                                                                    setVariantRuleVariantSearch(
                                                                        `${variant.category ? `${variant.category} - ` : ''}${variant.variant_name}`
                                                                    )
                                                                    setOpenVariantDropdown(false)
                                                                }}
                                                                className="w-full border-b border-gray-100 px-3 py-2 text-left hover:bg-gray-50 last:border-b-0"
                                                            >
                                                                <div className="text-sm font-medium text-gray-800">
                                                                    {variant.variant_name}
                                                                </div>
                                                                <div className="text-xs text-gray-500">
                                                                    {variant.category || 'Uncategorized'}
                                                                    {parseFloat(variant.price || 0) > 0 ? ` • +₱${parseFloat(variant.price).toFixed(2)}` : ''}
                                                                </div>
                                                            </button>
                                                        ))
                                                    )}
                                                </div>
                                            )}
                                        </div>

                                        <div className="relative" ref={ingredientDropdownRef}>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Ingredient <span className="text-red-500">*</span>
                                            </label>

                                            <input
                                                type="text"
                                                value={
                                                    variantRuleFormData.ingredient_id
                                                        ? ingredients.find(ingredient => String(ingredient.ingredient_id) === String(variantRuleFormData.ingredient_id))?.ingredient_name || ''
                                                        : variantRuleIngredientSearch
                                                }
                                                onFocus={() => setOpenIngredientDropdown(true)}
                                                onChange={(e) => {
                                                    setVariantRuleFormData(prev => ({
                                                        ...prev,
                                                        ingredient_id: '',
                                                        unit: ''
                                                    }))
                                                    setVariantRuleIngredientSearch(e.target.value)
                                                    setOpenIngredientDropdown(true)
                                                }}
                                                placeholder="Search and select ingredient..."
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#A0826D]"
                                            />

                                            {openIngredientDropdown && (
                                                <div className="absolute z-20 mt-1 w-full max-h-56 overflow-y-auto rounded-lg border border-gray-300 bg-white shadow-lg">
                                                    {filteredIngredientOptions.length === 0 ? (
                                                        <div className="px-3 py-2 text-sm text-gray-500">
                                                            No ingredients found.
                                                        </div>
                                                    ) : (
                                                        filteredIngredientOptions.map((ingredient) => (
                                                            <button
                                                                key={ingredient.ingredient_id}
                                                                type="button"
                                                                onClick={() => {
                                                                    setVariantRuleFormData(prev => ({
                                                                        ...prev,
                                                                        ingredient_id: ingredient.ingredient_id,
                                                                        unit: ingredient.unit || ''
                                                                    }))
                                                                    setVariantRuleIngredientSearch(ingredient.ingredient_name || ingredient.name || '')
                                                                    setOpenIngredientDropdown(false)
                                                                }}
                                                                className="w-full border-b border-gray-100 px-3 py-2 text-left hover:bg-gray-50 last:border-b-0"
                                                            >
                                                                <div className="text-sm font-medium text-gray-800">
                                                                    {ingredient.ingredient_name || ingredient.name}
                                                                </div>
                                                                <div className="text-xs text-gray-500">
                                                                    {ingredient.unit || '—'}{ingredient.category ? ` • ${ingredient.category}` : ''}
                                                                </div>
                                                            </button>
                                                        ))
                                                    )}
                                                </div>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Quantity Delta <span className="text-red-500">*</span>
                                            </label>
                                            <input
                                                type="number"
                                                min="0"
                                                step="0.01"
                                                value={variantRuleFormData.quantity_delta}
                                                onChange={(e) =>
                                                    setVariantRuleFormData({
                                                        ...variantRuleFormData,
                                                        quantity_delta: e.target.value
                                                    })
                                                }
                                                onInput={(e) => {
                                                    if (e.target.value.replace('.', '').replace('-', '').length > 6)
                                                        e.target.value = e.target.value.slice(0, e.target.value.includes('.') ? 7 : 6)
                                                }}
                                                placeholder="e.g. 1, 40, 120"
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#A0826D]"
                                            />
                                            <p className="text-xs text-gray-500 mt-1">
                                                {String(variantRuleFormData.quantity_delta).replace('.', '').replace('-', '').length} / 6 characters
                                            </p>

                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Unit <span className="text-red-500">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                value={variantRuleFormData.unit}
                                                readOnly
                                                placeholder="Auto-filled from selected ingredient"
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-600"
                                            />
                                            <p className="text-xs text-gray-500 mt-1">
                                                Unit is based on the selected ingredient and cannot be edited here.
                                            </p>
                                        </div>

                                        <div className="md:col-span-2">
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Notes
                                            </label>
                                            <input
                                                type="text"
                                                value={variantRuleFormData.notes}
                                                onChange={(e) =>
                                                    setVariantRuleFormData({
                                                        ...variantRuleFormData,
                                                        notes: e.target.value
                                                    })
                                                }
                                                maxLength={30}
                                                placeholder="Optional note"
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#A0826D]"
                                            />
                                            <p className="text-xs text-gray-500 mt-1">
                                                {(variantRuleFormData.notes || '').length} / 30 characters
                                            </p>
                                        </div>
                                    </div>

                                    <div className="flex justify-end gap-3">
                                        {variantRuleFormData.id && (
                                            <button
                                                type="button"
                                                onClick={resetVariantRuleForm}
                                                className="px-5 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300"
                                            >
                                                Cancel Edit
                                            </button>
                                        )}
                                        <button
                                            type="button"
                                            onClick={() => {
                                                if (!variantRuleFormData.variant_id || !variantRuleFormData.ingredient_id || variantRuleFormData.quantity_delta === '') {
                                                    Swal.fire({ icon: 'warning', title: 'Missing Information', text: 'Please fill in variant, ingredient, and quantity.', confirmButtonColor: '#FF6F3C' })
                                                    return
                                                }
                                                const quantity = parseFloat(variantRuleFormData.quantity_delta)
                                                if (isNaN(quantity) || quantity < 0) {
                                                    Swal.fire({ icon: 'warning', title: 'Invalid Quantity', text: 'Quantity delta must be 0 or greater.', confirmButtonColor: '#FF6F3C' })
                                                    return
                                                }
                                                setPendingVariantRuleAction(variantRuleFormData.id ? 'update' : 'add')
                                                setPendingVariantRuleId(variantRuleFormData.id || null)
                                                setVariantRuleRequestReason('')
                                                setShowVariantRuleRequestModal(true)
                                            }}
                                            disabled={!hasVariantRuleChanges}
                                            className={`px-5 py-2 rounded-lg font-medium ${!hasVariantRuleChanges
                                                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                                : 'bg-[#FF6F3C] text-white hover:bg-[#ff4c0b]'
                                                }`}
                                        >
                                            {variantRuleFormData.id ? 'Request Update' : 'Request Add'}
                                        </button>
                                    </div>
                                </>
                            )}

                            <div className="border border-gray-200 rounded-lg overflow-hidden">
                                <div className="bg-gray-50 border-b border-gray-200 px-4 py-3 flex items-center justify-between gap-3">
                                    <span className="text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Saved Rules ({variantRules.length})
                                    </span>
                                    <div className="relative w-56">
                                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
                                                <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10a7 7 0 1 0 14 0a7 7 0 1 0-14 0m18 11l-6-6" />
                                            </svg>
                                        </span>
                                        <input
                                            type="text"
                                            placeholder="Search rules..."
                                            value={variantRuleTableSearch}
                                            onChange={(e) => setVariantRuleTableSearch(e.target.value)}
                                            className="w-full pl-8 pr-3 py-1.5 border border-gray-300 rounded-lg text-xs focus:outline-none focus:ring-2 focus:ring-[#A0826D]"
                                        />
                                    </div>
                                </div>

                                {loadingVariantRules ? (
                                    <div className="px-4 py-8 text-center text-gray-500 text-sm">Loading variant rules...</div>
                                ) : variantRules.length === 0 ? (
                                    <div className="px-4 py-8 text-center text-gray-500 text-sm">No variant rules added yet.</div>
                                ) : (() => {
                                    const query = variantRuleTableSearch.toLowerCase()

                                    const grouped = variantRules.reduce((acc, rule) => {
                                        const key = rule.variant_id
                                        if (!acc[key]) acc[key] = []
                                        acc[key].push(rule)
                                        return acc
                                    }, {})

                                    const filteredGroupEntries = Object.entries(grouped).filter(([variantId, rules]) => {
                                        const variantLabel = getVariantLabelById(variantId).toLowerCase()
                                        if (variantLabel.includes(query)) return true
                                        return rules.some(r =>
                                            getIngredientLabelById(r.ingredient_id).toLowerCase().includes(query) ||
                                            String(r.notes || '').toLowerCase().includes(query)
                                        )
                                    })

                                    if (filteredGroupEntries.length === 0) {
                                        return <div className="px-4 py-8 text-center text-gray-500 text-sm">No rules match your search.</div>
                                    }

                                    return (
                                        <VariantRuleGroups
                                            groupEntries={filteredGroupEntries}
                                            getVariantLabelById={getVariantLabelById}
                                            getIngredientLabelById={getIngredientLabelById}
                                            handleEditVariantRule={handleEditVariantRule}
                                            query={query}
                                            onRequestDelete={(rule) => {
                                                setPendingVariantRuleAction('delete')
                                                setPendingVariantRuleId(rule.id)
                                                setVariantRuleRequestReason('')
                                                setShowVariantRuleRequestModal(true)
                                            }}
                                        />
                                    )
                                })()}
                            </div>
                        </div>

                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end">
                            <button
                                onClick={closeVariantRulesModal}
                                className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Price Change Request Modal */}
            {showPriceChangeRequestModal && (
                <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => setShowPriceChangeRequestModal(false)} />
                    <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full">
                        <div className="border-b border-gray-200 px-6 py-4">
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" className="text-emerald-600">
                                        <text x="12" y="17.5" textAnchor="middle" fontSize="20" fontWeight="700" fill="currentColor" fontFamily="Arial, sans-serif">₱</text>
                                    </svg>
                                </div>
                                <div>
                                    <h2 className="text-lg font-bold text-gray-800">Request Price Change</h2>
                                    <p className="text-sm text-gray-500">This will be sent to Super Admin for approval</p>
                                </div>
                            </div>
                        </div>

                        <div className="px-6 py-5 space-y-4">
                            <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-3 space-y-1">
                                <p className="text-sm text-emerald-700">
                                    <span className="font-semibold">Item: </span>
                                    {priceChangeRequestType === 'menu_item' && priceChangeRequestItem?.name}
                                    {priceChangeRequestType === 'variant' && priceChangeRequestItem?.variant_name}
                                    {priceChangeRequestType === 'modifier' && priceChangeRequestItem?.modifier_name}
                                </p>
                                <p className="text-sm text-emerald-700">
                                    <span className="font-semibold">Current Price: </span>
                                    ₱{parseFloat(
                                        priceChangeRequestType === 'menu_item'
                                            ? (priceChangeRequestItem?.has_price_override
                                                ? priceChangeRequestItem?.branch_price
                                                : priceChangeRequestItem?.master_price ?? priceChangeRequestItem?.item_price)
                                            : priceChangeRequestItem?.price
                                    ).toFixed(2)}
                                </p>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    New Price <span className="text-red-500">*</span>
                                </label>
                                <div className="relative">
                                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 font-medium">₱</span>
                                    <input
                                        type="number"
                                        step="0.01"
                                        min="0.01"
                                        value={priceChangeRequestedPrice}
                                        onChange={(e) => setPriceChangeRequestedPrice(e.target.value)}
                                        placeholder="0.00"
                                        className="w-full pl-7 pr-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-400 text-sm"
                                    />
                                </div>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Reason for Price Change <span className="text-red-500">*</span>
                                </label>
                                <textarea
                                    value={priceChangeRequestReason}
                                    onChange={(e) => setPriceChangeRequestReason(e.target.value)}
                                    placeholder="Explain why the price needs to change..."
                                    rows={4}
                                    maxLength={300}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-400 text-sm resize-none"
                                />
                                <p className="text-xs text-gray-400 mt-1 text-right">{priceChangeRequestReason.length}/300</p>
                            </div>
                        </div>

                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3">
                            <button
                                onClick={() => setShowPriceChangeRequestModal(false)}
                                className="px-5 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleSubmitPriceChangeRequest}
                                disabled={submittingPriceChangeRequest || !priceChangeRequestedPrice || !priceChangeRequestReason.trim()}
                                className={`px-5 py-2 rounded-lg font-medium ${submittingPriceChangeRequest || !priceChangeRequestedPrice || !priceChangeRequestReason.trim()
                                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                    : 'bg-emerald-600 text-white hover:bg-emerald-700'
                                    }`}
                            >
                                {submittingPriceChangeRequest ? 'Submitting...' : 'Submit Request'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Add Variant Modal */}
            {showAddVariantModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div
                        className="absolute inset-0 bg-black bg-opacity-50"
                        onClick={() => confirmDiscardChanges(hasAddVariantChanges, () => {
                            setShowAddVariantModal(false)
                            setVariantFormData({ category: "", variant_name: "", price: "", applicable_categories: [] })
                            setVariantCategorySearch("")
                            setOpenVariantCategoryDropdown(false)
                        })}
                    ></div>

                    <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full">
                        <div className="border-b border-gray-200 px-6 py-4">
                            <h2 className="text-xl font-bold text-gray-800">Add Variant</h2>
                        </div>

                        <div className="px-6 py-6 space-y-4">

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Variant Name <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    value={variantFormData.variant_name}
                                    onChange={(e) => setVariantFormData({ ...variantFormData, variant_name: e.target.value })}
                                    maxLength={30}
                                    placeholder="e.g. Grande, Iced, 50%"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400"
                                />
                                <p className="text-xs text-gray-500 mt-1">
                                    {variantFormData.variant_name.length}/30 characters
                                </p>
                            </div>

                            <div className="relative" ref={variantCategoryDropdownRef}>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Category <span className="text-red-500">*</span>
                                </label>

                                <input
                                    type="text"
                                    value={variantFormData.category}
                                    onFocus={() => {
                                        setVariantCategorySearch(variantFormData.category || "")
                                        setOpenVariantCategoryDropdown(true)
                                    }}
                                    onChange={(e) => {
                                        setVariantFormData({ ...variantFormData, category: e.target.value })
                                        setVariantCategorySearch(e.target.value)
                                        setOpenVariantCategoryDropdown(true)
                                    }}
                                    maxLength={30}
                                    placeholder="Search or type a category..."
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400"
                                />

                                {openVariantCategoryDropdown && (
                                    <div className="absolute z-20 mt-1 w-full max-h-56 overflow-y-auto rounded-lg border border-gray-300 bg-white shadow-lg">
                                        {filteredVariantCategoryOptions.length === 0 ? (
                                            <div className="px-3 py-2 text-sm text-gray-500">
                                                No existing categories found. Continue typing to create a new one.
                                            </div>
                                        ) : (
                                            filteredVariantCategoryOptions.map((category) => (
                                                <button
                                                    key={category}
                                                    type="button"
                                                    onClick={() => {
                                                        setVariantFormData({ ...variantFormData, category })
                                                        setVariantCategorySearch(category)
                                                        setOpenVariantCategoryDropdown(false)
                                                    }}
                                                    className="w-full border-b border-gray-100 px-3 py-2 text-left hover:bg-gray-50 last:border-b-0"
                                                >
                                                    <div className="text-sm font-medium text-gray-800">
                                                        {category}
                                                    </div>
                                                </button>
                                            ))
                                        )}
                                    </div>
                                )}

                                <p className="text-xs text-gray-500 mt-1">
                                    {variantFormData.category.length}/30 characters
                                </p>
                                <p className="text-xs text-gray-500 mt-1">
                                    Select an existing category or type a new one.
                                </p>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Price <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    max="9999"
                                    value={variantFormData.price}
                                    onChange={(e) => {
                                        const raw = e.target.value.replace('.', '').replace('-', '')
                                        if (raw.length <= MAX_PRICE_LENGTH) {
                                            setVariantFormData({ ...variantFormData, price: e.target.value })
                                        }
                                    }}
                                    onKeyDown={handlePriceKeyDown}
                                    placeholder="0.00"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400"
                                />
                                <p className="text-xs text-gray-500 mt-1">{String(variantFormData.price).replace('.', '').replace('-', '').length} / 4 digits</p>
                                <p className="text-xs text-gray-500 mt-1">(can be 0 for no charge)</p>
                            </div>

                            <ApplicableCategoriesSelector
                                value={variantFormData.applicable_categories}
                                onChange={(cats) => setVariantFormData({ ...variantFormData, applicable_categories: cats })}
                            />
                        </div>

                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3">
                            <button
                                onClick={() => confirmDiscardChanges(hasAddVariantChanges, () => {
                                    setVariantFormData({ category: "", variant_name: "", price: "", applicable_categories: [] })
                                    setShowAddVariantModal(false)
                                    setVariantCategorySearch("")
                                    setOpenVariantCategoryDropdown(false)
                                })}
                                className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleOpenAddVariantRequestModal}
                                disabled={savingVariant || !hasAddVariantChanges}
                                className={`px-6 py-2 rounded-lg font-medium ${savingVariant || !hasAddVariantChanges
                                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                    : 'bg-indigo-600 text-white hover:bg-indigo-700'
                                    }`}
                            >
                                {savingVariant ? 'Saving...' : 'Add Variant'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Variant Modal */}
            {showEditVariantModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div
                        className="absolute inset-0 bg-black bg-opacity-50"
                        onClick={() => confirmDiscardChanges(hasEditVariantChanges, () => {
                            setShowEditVariantModal(false)
                            setEditingVariant(null)
                            setVariantFormData({ category: "", variant_name: "", price: "", applicable_categories: [] })
                            setInitialVariantFormData(null)
                        })}
                    ></div>

                    <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full">
                        <div className="border-b border-gray-200 px-6 py-4">
                            <h2 className="text-xl font-bold text-gray-800">Variant Details</h2>
                            <p className="text-sm text-gray-500 mt-1">View only — contact Super Admin to make changes.</p>
                        </div>

                        <div className="px-6 py-6 space-y-4">

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Variant Name <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    value={variantFormData.variant_name}
                                    readOnly
                                    className="w-full px-3 py-2 border border-gray-200 rounded-lg bg-gray-50 text-gray-700 cursor-default"
                                />
                            </div>

                            <div className="relative" ref={variantCategoryDropdownRef}>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Category <span className="text-red-500">*</span>
                                </label>

                                <input
                                    type="text"
                                    value={variantFormData.category}
                                    readOnly
                                    className="w-full px-3 py-2 border border-gray-200 rounded-lg bg-gray-50 text-gray-700 cursor-default"
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Price <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    value={`₱${parseFloat(variantFormData.price || 0).toFixed(2)}`}
                                    readOnly
                                    className="w-full px-3 py-2 border border-gray-200 rounded-lg bg-gray-50 text-gray-700 cursor-default"
                                />
                            </div>

                            <ApplicableCategoriesSelector
                                value={variantFormData.applicable_categories}
                                onChange={(cats) => setVariantFormData({ ...variantFormData, applicable_categories: cats })}
                            />

                        </div>

                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end">
                            <button
                                onClick={() => {
                                    setShowEditVariantModal(false)
                                    setEditingVariant(null)
                                    setVariantFormData({ category: "", variant_name: "", price: "", applicable_categories: [] })
                                    setInitialVariantFormData(null)
                                    setViewOnlyVariant(false)
                                }}
                                className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Add Modifier Modal */}
            {showAddModifierModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50"
                        onClick={() => confirmDiscardChanges(hasAddModifierChanges, () => {
                            setShowAddModifierModal(false);
                            setModifierFormData({ modifier_name: "", category: "", price: "", applicable_categories: [], ingredient_id: "" })
                            setInitialModifierFormData(null)
                            setModifierIngredientSearch("")
                            setOpenModifierIngredientDropdown(false)
                        })}></div>
                    <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full max-h-[90vh] flex flex-col">
                        <div className="border-b border-gray-200 px-6 py-4"><h2 className="text-xl font-bold text-gray-800">Add Modifier</h2></div>
                        <div className="px-6 py-6 space-y-4 overflow-y-auto flex-1">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Modifier Name <span className="text-red-500">*</span></label>
                                <input type="text" value={modifierFormData.modifier_name} onChange={(e) => setModifierFormData({ ...modifierFormData, modifier_name: e.target.value })} maxLength={50} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#A0826D]" placeholder="e.g., Extra Whipped Cream" />
                                <p className="text-xs text-gray-500 mt-1">{modifierFormData.modifier_name.length}/50 characters</p>
                            </div>
                            {/* Linked Ingredient */}
                            <div className="relative" ref={modifierIngredientDropdownRef}>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Linked Ingredient
                                    <span className="ml-1 text-xs font-normal text-gray-400">(optional)</span>
                                </label>
                                <input
                                    type="text"
                                    value={
                                        modifierFormData.ingredient_id
                                            ? ingredients.find(ing => String(ing.ingredient_id) === String(modifierFormData.ingredient_id))?.ingredient_name
                                            || ingredients.find(ing => String(ing.ingredient_id) === String(modifierFormData.ingredient_id))?.name
                                            || modifierIngredientSearch
                                            : modifierIngredientSearch
                                    }
                                    onFocus={() => setOpenModifierIngredientDropdown(true)}
                                    onChange={(e) => {
                                        setModifierFormData(prev => ({ ...prev, ingredient_id: '' }))
                                        setModifierIngredientSearch(e.target.value)
                                        setOpenModifierIngredientDropdown(true)
                                    }}
                                    placeholder="Search and select ingredient..."
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-400"
                                />
                                {modifierFormData.ingredient_id && (
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setModifierFormData(prev => ({ ...prev, ingredient_id: '' }))
                                            setModifierIngredientSearch('')
                                        }}
                                        className="absolute right-3 top-[2.15rem] text-gray-400 hover:text-gray-600"
                                        title="Clear ingredient"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
                                            <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                        </svg>
                                    </button>
                                )}
                                {openModifierIngredientDropdown && (
                                    <div className="absolute z-20 mt-1 w-full max-h-56 overflow-y-auto rounded-lg border border-gray-300 bg-white shadow-lg">
                                        {(() => {
                                            const query = modifierIngredientSearch.toLowerCase()
                                            const filtered = ingredients.filter(ing =>
                                                String(ing.ingredient_name || ing.name || '').toLowerCase().includes(query) ||
                                                String(ing.unit || '').toLowerCase().includes(query) ||
                                                String(ing.category || '').toLowerCase().includes(query)
                                            )
                                            if (filtered.length === 0) {
                                                return <div className="px-3 py-2 text-sm text-gray-500">No ingredients found.</div>
                                            }
                                            return filtered.map(ing => (
                                                <button
                                                    key={ing.ingredient_id}
                                                    type="button"
                                                    onClick={() => {
                                                        setModifierFormData(prev => ({ ...prev, ingredient_id: ing.ingredient_id }))
                                                        setModifierIngredientSearch(ing.ingredient_name || ing.name || '')
                                                        setOpenModifierIngredientDropdown(false)
                                                    }}
                                                    className="w-full border-b border-gray-100 px-3 py-2 text-left hover:bg-gray-50 last:border-b-0"
                                                >
                                                    <div className="text-sm font-medium text-gray-800">
                                                        {ing.ingredient_name || ing.name}
                                                    </div>
                                                    <div className="text-xs text-gray-500">
                                                        {ing.unit || '—'}{ing.category ? ` • ${ing.category}` : ''}
                                                    </div>
                                                </button>
                                            ))
                                        })()}
                                    </div>
                                )}
                                <p className="text-xs text-gray-500 mt-1">
                                    Link this modifier to an inventory ingredient for stock tracking.
                                </p>
                            </div>
                            <div className="relative" ref={modifierCategoryDropdownRef}>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Category <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    value={modifierFormData.category}
                                    onFocus={() => {
                                        setModifierCategorySearch(modifierFormData.category || "")
                                        setOpenModifierCategoryDropdown(true)
                                    }}
                                    onChange={(e) => {
                                        setModifierFormData({ ...modifierFormData, category: e.target.value })
                                        setModifierCategorySearch(e.target.value)
                                        setOpenModifierCategoryDropdown(true)
                                    }}
                                    maxLength={30}
                                    placeholder="Search or type a category..."
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-400"
                                />
                                {openModifierCategoryDropdown && (
                                    <div className="absolute z-20 mt-1 w-full max-h-56 overflow-y-auto rounded-lg border border-gray-300 bg-white shadow-lg">
                                        {filteredModifierCategoryOptions.length === 0 ? (
                                            <div className="px-3 py-2 text-sm text-gray-500">
                                                No existing categories found. Continue typing to create a new one.
                                            </div>
                                        ) : (
                                            filteredModifierCategoryOptions.map((category) => (
                                                <button
                                                    key={category}
                                                    type="button"
                                                    onClick={() => {
                                                        setModifierFormData({ ...modifierFormData, category })
                                                        setModifierCategorySearch(category)
                                                        setOpenModifierCategoryDropdown(false)
                                                    }}
                                                    className="w-full border-b border-gray-100 px-3 py-2 text-left hover:bg-gray-50 last:border-b-0"
                                                >
                                                    <div className="text-sm font-medium text-gray-800">{category}</div>
                                                </button>
                                            ))
                                        )}
                                    </div>
                                )}
                                <p className="text-xs text-gray-500 mt-1">
                                    {modifierFormData.category.length}/30 characters
                                </p>
                                <p className="text-xs text-gray-500 mt-1">Select an existing category or type a new one.</p>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Price <span className="text-red-500">*</span></label>
                                <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    max="9999"
                                    value={modifierFormData.price}
                                    onChange={(e) => {
                                        const raw = e.target.value.replace('.', '').replace('-', '')
                                        if (raw.length <= MAX_PRICE_LENGTH) {
                                            setModifierFormData({ ...modifierFormData, price: e.target.value })
                                        }
                                    }}
                                    onKeyDown={handlePriceKeyDown}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#A0826D]"
                                    placeholder="0.00"
                                />
                                <p className="text-xs text-gray-500 mt-1">{String(modifierFormData.price).replace('.', '').replace('-', '').length} / 4 digits</p>
                                <p className="text-xs text-gray-500 mt-1">(can be 0 for no charge)</p>
                            </div>
                            <ApplicableCategoriesSelector
                                value={modifierFormData.applicable_categories}
                                onChange={(cats) => setModifierFormData({ ...modifierFormData, applicable_categories: cats })}
                            />
                        </div>
                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3">
                            <button
                                onClick={() => confirmDiscardChanges(hasAddModifierChanges, () => {
                                    setShowAddModifierModal(false)
                                    setModifierFormData({ modifier_name: "", category: "", price: "", applicable_categories: [] })
                                    setInitialModifierFormData(null)
                                    setModifierIngredientSearch("")
                                    setOpenModifierIngredientDropdown(false)
                                })}
                                className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleOpenAddModifierRequestModal} disabled={!hasAddModifierChanges}
                                className={`px-6 py-2 rounded-lg font-medium ${!hasAddModifierChanges
                                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                    : 'bg-purple-600 text-white hover:bg-purple-700'
                                    }`}
                            >
                                Add Modifier
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Modifier Modal */}
            {showEditModifierModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50"
                        onClick={() => confirmDiscardChanges(hasEditModifierChanges, () => {
                            setShowEditModifierModal(false)
                            setEditingModifier(null)
                            setModifierFormData({ modifier_name: "", category: "", price: "", applicable_categories: [], ingredient_id: "" })
                            setInitialModifierFormData(null)
                            setModifierIngredientSearch("")
                            setOpenModifierIngredientDropdown(false)
                        })}>
                    </div>
                    <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full max-h-[90vh] flex flex-col">
                        <div className="border-b border-gray-200 px-6 py-4">
                            <h2 className="text-xl font-bold text-gray-800">Modifier Details</h2>
                            <p className="text-sm text-gray-500 mt-1">View only — contact Super Admin to make changes.</p>
                        </div>
                        <div className="px-6 py-6 space-y-4 overflow-y-auto flex-1">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Modifier Name</label>
                                <input type="text" value={modifierFormData.modifier_name} readOnly className="w-full px-3 py-2 border border-gray-200 rounded-lg bg-gray-50 text-gray-700 cursor-default" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Linked Ingredient</label>
                                <input
                                    type="text"
                                    value={
                                        modifierFormData.ingredient_id
                                            ? ingredients.find(ing => String(ing.ingredient_id) === String(modifierFormData.ingredient_id))?.ingredient_name
                                            || ingredients.find(ing => String(ing.ingredient_id) === String(modifierFormData.ingredient_id))?.name
                                            || 'Unknown'
                                            : 'None'
                                    }
                                    readOnly
                                    className="w-full px-3 py-2 border border-gray-200 rounded-lg bg-gray-50 text-gray-700 cursor-default"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Category</label>
                                <input type="text" value={modifierFormData.category} readOnly className="w-full px-3 py-2 border border-gray-200 rounded-lg bg-gray-50 text-gray-700 cursor-default" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Price</label>
                                <input
                                    type="text"
                                    value={parseFloat(modifierFormData.price || 0) === 0 ? 'No charge' : `₱${parseFloat(modifierFormData.price || 0).toFixed(2)}`}
                                    readOnly
                                    className="w-full px-3 py-2 border border-gray-200 rounded-lg bg-gray-50 text-gray-700 cursor-default"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Applicable Categories</label>
                                {(modifierFormData.applicable_categories || []).length === 0 ? (
                                    <p className="text-sm text-gray-400 italic">None</p>
                                ) : (
                                    <div className="flex flex-wrap gap-1">
                                        {modifierFormData.applicable_categories.map(cat => (
                                            <span key={cat} className="px-2 py-0.5 rounded-full text-xs font-medium bg-purple-50 text-purple-700 border border-purple-100">{cat}</span>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end">
                            <button
                                onClick={() => {
                                    setShowEditModifierModal(false)
                                    setEditingModifier(null)
                                    setModifierFormData({ modifier_name: "", category: "", price: "", applicable_categories: [], ingredient_id: "" })
                                    setInitialModifierFormData(null)
                                    setModifierIngredientSearch("")
                                    setViewOnlyModifier(false)
                                }}
                                className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Archived Modal */}
            {showArchivedViewerModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div
                        className="absolute inset-0 bg-black bg-opacity-50"
                        onClick={closeArchivedViewerModal}
                    ></div>

                    <div className="relative bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[85vh] overflow-hidden flex flex-col">
                        <div className="border-b border-gray-200 px-6 py-4 space-y-3">
                            <div className="flex items-center justify-between gap-4 flex-wrap">
                                <div>
                                    <h2 className="text-xl font-bold text-gray-800">
                                        Archived {activeTab === 'menu' ? 'Menu Items' : activeTab === 'variants' ? 'Variants' : 'Modifiers'}
                                    </h2>
                                    <p className="text-sm text-gray-500 mt-1">
                                        Reinstate archived records for the currently active tab.
                                    </p>
                                </div>
                            </div>
                            <div className="relative">
                                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                                        <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10a7 7 0 1 0 14 0a7 7 0 1 0-14 0m18 11l-6-6" />
                                    </svg>
                                </span>
                                <input
                                    type="text"
                                    placeholder={`Search archived ${activeTab === 'menu' ? 'items' : activeTab === 'variants' ? 'variants' : 'modifiers'}...`}
                                    value={archivedSearch}
                                    onChange={(e) => setArchivedSearch(e.target.value)}
                                    className="w-full pl-9 pr-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#A0826D]"
                                />
                            </div>
                            <div className="flex flex-wrap gap-2">
                                {['All', ...new Set(
                                    (activeTab === 'menu' ? archivedMenuItems
                                        : activeTab === 'variants' ? archivedVariants
                                            : archivedModifiers
                                    ).map(i => i.category).filter(Boolean)
                                )].map(cat => (
                                    <button
                                        key={cat}
                                        onClick={() => setArchivedCategoryFilter(cat)}
                                        className={`px-3 py-1 rounded-full text-xs font-semibold transition-colors ${archivedCategoryFilter === cat
                                            ? 'bg-[#A0826D] text-white'
                                            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                                            }`}
                                    >
                                        {cat}
                                        {cat !== 'All' && (
                                            <span className={`ml-1.5 px-1.5 py-0.5 rounded-full text-[10px] font-bold ${archivedCategoryFilter === cat
                                                ? 'bg-white/30 text-white'
                                                : 'bg-gray-200 text-gray-500'
                                                }`}>
                                                {(activeTab === 'menu' ? archivedMenuItems
                                                    : activeTab === 'variants' ? archivedVariants
                                                        : archivedModifiers
                                                ).filter(i => i.category === cat).length}
                                            </span>
                                        )}
                                    </button>
                                ))}
                            </div>
                        </div>

                        <div className="overflow-y-auto flex-1">
                            {loadingArchivedItems ? (
                                <div className="px-6 py-10 text-center text-gray-500">
                                    Loading archived records...
                                </div>
                            ) : activeTab === 'menu' ? (() => {
                                const filteredArchivedMenuItems = archivedMenuItems.filter(item =>
                                    (String(item.name || '').toLowerCase().includes(archivedSearch.toLowerCase()) ||
                                        String(item.category || '').toLowerCase().includes(archivedSearch.toLowerCase()) ||
                                        String(item.classification || '').toLowerCase().includes(archivedSearch.toLowerCase())) &&
                                    (archivedCategoryFilter === 'All' || item.category === archivedCategoryFilter)
                                )
                                const pagedArchivedMenuItems = filteredArchivedMenuItems.slice(
                                    (archivedPage - 1) * ARCHIVED_PAGE_SIZE,
                                    archivedPage * ARCHIVED_PAGE_SIZE
                                )
                                return filteredArchivedMenuItems.length === 0 ? (
                                    <div className="px-6 py-10 text-center text-gray-500">
                                        {archivedSearch || archivedCategoryFilter !== 'All' ? 'No archived items match your filters.' : 'No archived menu items found.'}
                                    </div>
                                ) : (
                                    <>
                                        <table className="w-full">
                                            <thead className="bg-gray-50 border-b border-gray-200">
                                                <tr>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Item</th>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Category</th>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Price</th>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-200 bg-white">
                                                {pagedArchivedMenuItems.map((item) => (
                                                    <tr key={item.item_id}>
                                                        <td className="px-6 py-4">
                                                            <div className="flex items-center gap-3">
                                                                {item.item_img && (
                                                                    <img
                                                                        src={item.item_img}
                                                                        alt={item.name}
                                                                        className="w-10 h-10 rounded-lg object-cover"
                                                                    />
                                                                )}
                                                                <div>
                                                                    <p className="font-medium text-gray-800">{item.name}</p>
                                                                    <p className="text-sm text-gray-500">{item.classification}</p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4 text-gray-700">{item.category}</td>
                                                        <td className="px-6 py-4 text-gray-700">₱{parseFloat(item.item_price || 0).toFixed(2)}</td>
                                                        <td className="px-6 py-4">
                                                            <button
                                                                onClick={() => handleRequestReinstateItem(item)}
                                                                disabled={isDuplicateActiveMenuItem(item) || hasPendingReinstateRequest('menu', item.item_id)}
                                                                className={`px-3 py-1.5 rounded-lg text-sm font-medium ${isDuplicateActiveMenuItem(item) || hasPendingReinstateRequest('menu', item.item_id)
                                                                    ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
                                                                    : 'bg-green-600 text-white hover:bg-green-700'
                                                                    }`}
                                                                title={isDuplicateActiveMenuItem(item) ? 'An active duplicate already exists' : hasPendingReinstateRequest('menu', item.item_id) ? 'A reinstate request is already pending' : 'Request Reinstate'}
                                                            >
                                                                {isDuplicateActiveMenuItem(item) ? 'Duplicate Exists' : hasPendingReinstateRequest('menu', item.item_id) ? 'Pending Request' : 'Request Reinstate'}
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        <Pagination
                                            page={archivedPage}
                                            totalItems={filteredArchivedMenuItems.length}
                                            pageSize={ARCHIVED_PAGE_SIZE}
                                            onPageChange={setArchivedPage}
                                        />
                                    </>
                                )
                            })() : activeTab === 'variants' ? (() => {
                                const filteredArchivedVariants = archivedVariants.filter(variant =>
                                    (String(variant.variant_name || '').toLowerCase().includes(archivedSearch.toLowerCase()) ||
                                        String(variant.category || '').toLowerCase().includes(archivedSearch.toLowerCase())) &&
                                    (archivedCategoryFilter === 'All' || variant.category === archivedCategoryFilter)
                                )
                                const pagedArchivedVariants = filteredArchivedVariants.slice(
                                    (archivedPage - 1) * ARCHIVED_PAGE_SIZE,
                                    archivedPage * ARCHIVED_PAGE_SIZE
                                )
                                return filteredArchivedVariants.length === 0 ? (
                                    <div className="px-6 py-10 text-center text-gray-500">
                                        {archivedSearch || archivedCategoryFilter !== 'All' ? 'No archived variants match your filters.' : 'No archived variants found.'}
                                    </div>
                                ) : (
                                    <>
                                        <table className="w-full">
                                            <thead className="bg-gray-50 border-b border-gray-200">
                                                <tr>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Variant</th>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Category</th>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Price</th>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-200 bg-white">
                                                {pagedArchivedVariants.map((variant) => (
                                                    <tr key={variant.variant_id}>
                                                        <td className="px-6 py-4 font-medium text-gray-800">{variant.variant_name}</td>
                                                        <td className="px-6 py-4 text-gray-700">{variant.category}</td>
                                                        <td className="px-6 py-4 text-gray-700">₱{parseFloat(variant.price || 0).toFixed(2)}</td>
                                                        <td className="px-6 py-4">
                                                            <button
                                                                onClick={() => handleRequestReinstateVariant(variant)}
                                                                disabled={isDuplicateActiveVariant(variant) || hasPendingReinstateRequest('variant', variant.variant_id)}
                                                                className={`px-3 py-1.5 rounded-lg text-sm font-medium ${isDuplicateActiveVariant(variant) || hasPendingReinstateRequest('variant', variant.variant_id)
                                                                    ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
                                                                    : 'bg-green-600 text-white hover:bg-green-700'
                                                                    }`}
                                                                title={isDuplicateActiveVariant(variant) ? 'An active duplicate already exists' : hasPendingReinstateRequest('variant', variant.variant_id) ? 'A reinstate request is already pending' : 'Request Reinstate'}
                                                            >
                                                                {isDuplicateActiveVariant(variant) ? 'Duplicate Exists' : hasPendingReinstateRequest('variant', variant.variant_id) ? 'Pending Request' : 'Request Reinstate'}
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        <Pagination
                                            page={archivedPage}
                                            totalItems={filteredArchivedVariants.length}
                                            pageSize={ARCHIVED_PAGE_SIZE}
                                            onPageChange={setArchivedPage}
                                        />
                                    </>
                                )
                            })() : (() => {
                                const filteredArchivedModifiers = archivedModifiers.filter(modifier =>
                                    (String(modifier.modifier_name || '').toLowerCase().includes(archivedSearch.toLowerCase()) ||
                                        String(modifier.category || '').toLowerCase().includes(archivedSearch.toLowerCase())) &&
                                    (archivedCategoryFilter === 'All' || modifier.category === archivedCategoryFilter)
                                )
                                const pagedArchivedModifiers = filteredArchivedModifiers.slice(
                                    (archivedPage - 1) * ARCHIVED_PAGE_SIZE,
                                    archivedPage * ARCHIVED_PAGE_SIZE
                                )
                                return filteredArchivedModifiers.length === 0 ? (
                                    <div className="px-6 py-10 text-center text-gray-500">
                                        {archivedSearch || archivedCategoryFilter !== 'All' ? 'No archived modifiers match your filters.' : 'No archived modifiers found.'}
                                    </div>
                                ) : (
                                    <>
                                        <table className="w-full">
                                            <thead className="bg-gray-50 border-b border-gray-200">
                                                <tr>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Modifier</th>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Category</th>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Price</th>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-200 bg-white">
                                                {pagedArchivedModifiers.map((modifier) => (
                                                    <tr key={modifier.modifier_id}>
                                                        <td className="px-6 py-4 font-medium text-gray-800">{modifier.modifier_name}</td>
                                                        <td className="px-6 py-4 text-gray-700">{modifier.category}</td>
                                                        <td className="px-6 py-4 text-gray-700">
                                                            {parseFloat(modifier.price || 0) === 0
                                                                ? 'No charge'
                                                                : `₱${parseFloat(modifier.price || 0).toFixed(2)}`}
                                                        </td>
                                                        <td className="px-6 py-4">
                                                            <button
                                                                onClick={() => handleRequestReinstateModifier(modifier)}
                                                                disabled={isDuplicateActiveModifier(modifier) || hasPendingReinstateRequest('modifier', modifier.modifier_id)}
                                                                className={`px-3 py-1.5 rounded-lg text-sm font-medium ${isDuplicateActiveModifier(modifier) || hasPendingReinstateRequest('modifier', modifier.modifier_id)
                                                                        ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
                                                                        : 'bg-green-600 text-white hover:bg-green-700'
                                                                    }`}
                                                                title={isDuplicateActiveModifier(modifier) ? 'An active duplicate already exists' : hasPendingReinstateRequest('modifier', modifier.modifier_id) ? 'A reinstate request is already pending' : 'Request Reinstate'}
                                                            >
                                                                {isDuplicateActiveModifier(modifier) ? 'Duplicate Exists' : hasPendingReinstateRequest('modifier', modifier.modifier_id) ? 'Pending Request' : 'Request Reinstate'}
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        <Pagination
                                            page={archivedPage}
                                            totalItems={filteredArchivedModifiers.length}
                                            pageSize={ARCHIVED_PAGE_SIZE}
                                            onPageChange={setArchivedPage}
                                        />
                                    </>
                                )
                            })()}
                        </div>

                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end">
                            <button
                                onClick={closeArchivedViewerModal}
                                className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {/* Delete Request Modal */}
            {showDeleteRequestModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div
                        className="absolute inset-0 bg-black bg-opacity-50"
                        onClick={() => { setShowDeleteRequestModal(false); setDeleteRequestReason('') }}
                    />
                    <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full">
                        <div className="border-b border-gray-200 px-6 py-4">
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" className="text-red-600">
                                        <path fill="currentColor" d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zM17 6H7v13h10zM9 17h2V8H9zm4 0h2V8h-2z" />
                                    </svg>
                                </div>
                                <div>
                                    <h2 className="text-lg font-bold text-gray-800">Request Deletion</h2>
                                    <p className="text-sm text-gray-500">This will be sent to Super Admin for approval</p>
                                </div>
                            </div>
                        </div>

                        <div className="px-6 py-5 space-y-4">
                            <div className="bg-red-50 border border-red-200 rounded-lg p-3">
                                <p className="text-sm text-red-700">
                                    <span className="font-semibold">Item to delete: </span>
                                    {deleteRequestType === 'menu' && deleteRequestItem?.name}
                                    {deleteRequestType === 'variant' && deleteRequestItem?.variant_name}
                                    {deleteRequestType === 'modifier' && deleteRequestItem?.modifier_name}
                                </p>
                                <p className="text-xs text-red-500 mt-1 capitalize">
                                    Type: {deleteRequestType === 'menu' ? 'Menu Item' : deleteRequestType === 'variant' ? 'Variant' : 'Modifier'}
                                </p>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Reason for Deletion <span className="text-red-500">*</span>
                                </label>
                                <textarea
                                    value={deleteRequestReason}
                                    onChange={(e) => setDeleteRequestReason(e.target.value)}
                                    placeholder="Explain why this item should be deleted..."
                                    rows={4}
                                    maxLength={300}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-400 text-sm resize-none"
                                />
                                <p className="text-xs text-gray-400 mt-1 text-right">{deleteRequestReason.length}/300</p>
                            </div>
                        </div>

                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3">
                            <button
                                onClick={() => { setShowDeleteRequestModal(false); setDeleteRequestReason('') }}
                                className="px-5 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleSubmitDeleteRequest}
                                disabled={submittingDeleteRequest || !deleteRequestReason.trim()}
                                className={`px-5 py-2 rounded-lg font-medium ${submittingDeleteRequest || !deleteRequestReason.trim()
                                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                    : 'bg-red-600 text-white hover:bg-red-700'
                                    }`}
                            >
                                {submittingDeleteRequest ? 'Submitting...' : 'Submit Request'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Add Item Request Modal */}
            {showAddItemRequestReasonModal && (
                <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => setShowAddItemRequestReasonModal(false)} />
                    <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full">
                        <div className="border-b border-gray-200 px-6 py-4">
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" className="text-green-600"><path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z" /></svg>
                                </div>
                                <div>
                                    <h2 className="text-lg font-bold text-gray-800">Request New Menu Item</h2>
                                    <p className="text-sm text-gray-500">This will be sent to Super Admin for approval</p>
                                </div>
                            </div>
                        </div>
                        <div className="px-6 py-5 space-y-4">
                            <div className="bg-green-50 border border-green-200 rounded-lg p-3">
                                <p className="text-sm text-green-700"><span className="font-semibold">Item: </span>{itemFormData.name}</p>
                                <p className="text-xs text-green-500 mt-1">{selectedBranchIds.size} branch{selectedBranchIds.size !== 1 ? 'es' : ''} selected</p>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Reason <span className="text-red-500">*</span></label>
                                <textarea
                                    value={addItemRequestReason}
                                    onChange={(e) => setAddItemRequestReason(e.target.value)}
                                    placeholder="Explain why this item should be added..."
                                    rows={4}
                                    maxLength={300}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-400 text-sm resize-none"
                                />
                                <p className="text-xs text-gray-400 mt-1 text-right">{addItemRequestReason.length}/300</p>
                            </div>
                        </div>
                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3">
                            <button onClick={() => setShowAddItemRequestReasonModal(false)} className="px-5 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300">Cancel</button>
                            <button
                                onClick={handleSubmitAddItemRequest}
                                disabled={submittingAddItemRequest || !addItemRequestReason.trim()}
                                className={`px-5 py-2 rounded-lg font-medium ${submittingAddItemRequest || !addItemRequestReason.trim() ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-green-600 text-white hover:bg-green-700'}`}
                            >
                                {submittingAddItemRequest ? 'Submitting...' : 'Submit Request'}
                            </button>
                        </div>
                    </div>
                </div>

            )}

            {/* Add Variant Request Modal */}
            {showAddVariantRequestModal && (
                <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => setShowAddVariantRequestModal(false)} />
                    <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full">
                        <div className="border-b border-gray-200 px-6 py-4">
                            <h2 className="text-lg font-bold text-gray-800">Request New Variant</h2>
                            <p className="text-sm text-gray-500">This will be sent to Super Admin for approval</p>
                        </div>
                        <div className="px-6 py-5 space-y-4">
                            <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-3">
                                <p className="text-sm text-indigo-700">
                                    <span className="font-semibold">Variant: </span>{variantFormData.category} - {variantFormData.variant_name}
                                </p>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Reason <span className="text-red-500">*</span></label>
                                <textarea
                                    value={addVariantRequestReason}
                                    onChange={(e) => setAddVariantRequestReason(e.target.value)}
                                    rows={4}
                                    maxLength={300}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400 text-sm resize-none"
                                />
                                <p className="text-xs text-gray-400 mt-1 text-right">{addVariantRequestReason.length}/300</p>
                            </div>
                        </div>
                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3">
                            <button onClick={() => setShowAddVariantRequestModal(false)} className="px-5 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300">Cancel</button>
                            <button
                                onClick={handleSubmitAddVariantRequest}
                                disabled={submittingAddVariantRequest || !addVariantRequestReason.trim()}
                                className={`px-5 py-2 rounded-lg font-medium ${submittingAddVariantRequest || !addVariantRequestReason.trim() ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-indigo-600 text-white hover:bg-indigo-700'}`}
                            >
                                {submittingAddVariantRequest ? 'Submitting...' : 'Submit Request'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Add Modifier Request Modal */}
            {showAddModifierRequestModal && (
                <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => setShowAddModifierRequestModal(false)} />
                    <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full">
                        <div className="border-b border-gray-200 px-6 py-4">
                            <h2 className="text-lg font-bold text-gray-800">Request New Modifier</h2>
                            <p className="text-sm text-gray-500">This will be sent to Super Admin for approval</p>
                        </div>
                        <div className="px-6 py-5 space-y-4">
                            <div className="bg-purple-50 border border-purple-200 rounded-lg p-3">
                                <p className="text-sm text-purple-700">
                                    <span className="font-semibold">Modifier: </span>{modifierFormData.modifier_name} ({modifierFormData.category})
                                </p>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Reason <span className="text-red-500">*</span></label>
                                <textarea
                                    value={addModifierRequestReason}
                                    onChange={(e) => setAddModifierRequestReason(e.target.value)}
                                    rows={4}
                                    maxLength={300}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-400 text-sm resize-none"
                                />
                                <p className="text-xs text-gray-400 mt-1 text-right">{addModifierRequestReason.length}/300</p>
                            </div>
                        </div>
                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3">
                            <button onClick={() => setShowAddModifierRequestModal(false)} className="px-5 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300">Cancel</button>
                            <button
                                onClick={handleSubmitAddModifierRequest}
                                disabled={submittingAddModifierRequest || !addModifierRequestReason.trim()}
                                className={`px-5 py-2 rounded-lg font-medium ${submittingAddModifierRequest || !addModifierRequestReason.trim() ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-purple-600 text-white hover:bg-purple-700'}`}
                            >
                                {submittingAddModifierRequest ? 'Submitting...' : 'Submit Request'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Request Modal (Variant / Modifier) */}
            {showEditRequestModal && (
                <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => setShowEditRequestModal(false)} />
                    <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full">
                        <div className="border-b border-gray-200 px-6 py-4">
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" className="text-blue-600"><path fill="currentColor" d="m14.06 9l.94.94L5.92 19H5v-.92zm3.6-6c-.25 0-.51.1-.7.29l-1.83 1.83l3.75 3.75l1.83-1.83c.39-.39.39-1.04 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29m-3.6 3.19L3 17.25V21h3.75L17.81 9.94z" /></svg>
                                </div>
                                <div>
                                    <h2 className="text-lg font-bold text-gray-800">Request Update</h2>
                                    <p className="text-sm text-gray-500">This will be sent to Super Admin for approval</p>
                                </div>
                            </div>
                        </div>
                        <div className="px-6 py-5 space-y-4">
                            <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                                <p className="text-sm text-blue-700">
                                    <span className="font-semibold">Updating: </span>
                                    {editRequestType === 'variant' ? editingVariant?.variant_name : editingModifier?.modifier_name}
                                </p>
                                <p className="text-xs text-blue-500 mt-1 capitalize">Type: {editRequestType}</p>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Reason for Update <span className="text-red-500">*</span></label>
                                <textarea
                                    value={editRequestReason}
                                    onChange={(e) => setEditRequestReason(e.target.value)}
                                    placeholder="Explain why this update is needed..."
                                    rows={4}
                                    maxLength={300}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm resize-none"
                                />
                                <p className="text-xs text-gray-400 mt-1 text-right">{editRequestReason.length}/300</p>
                            </div>
                        </div>
                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3">
                            <button onClick={() => setShowEditRequestModal(false)} className="px-5 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300">Cancel</button>
                            <button
                                onClick={handleEditRequestSubmit}
                                disabled={submittingEditRequest || !editRequestReason.trim()}
                                className={`px-5 py-2 rounded-lg font-medium ${submittingEditRequest || !editRequestReason.trim() ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-blue-600 text-white hover:bg-blue-700'}`}
                            >
                                {submittingEditRequest ? 'Submitting...' : 'Submit Request'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Assign Variant Request Modal */}
            {showAssignVariantRequestModal && (
                <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => setShowAssignVariantRequestModal(false)} />
                    <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full">
                        <div className="border-b border-gray-200 px-6 py-4">
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 bg-indigo-100 rounded-full flex items-center justify-center flex-shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" className="text-indigo-600"><path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z" /></svg>
                                </div>
                                <div>
                                    <h2 className="text-lg font-bold text-gray-800">Request Variant Assignment</h2>
                                    <p className="text-sm text-gray-500">This will be sent to Super Admin for approval</p>
                                </div>
                            </div>
                        </div>
                        <div className="px-6 py-5 space-y-4">
                            <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-3">
                                <p className="text-sm text-indigo-700"><span className="font-semibold">Item: </span>{selectedItemForVariants?.name}</p>
                                <p className="text-xs text-indigo-500 mt-1">{assignedVariantIds.size} variant{assignedVariantIds.size !== 1 ? 's' : ''} selected</p>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Reason <span className="text-red-500">*</span></label>
                                <textarea
                                    value={assignVariantRequestReason}
                                    onChange={(e) => setAssignVariantRequestReason(e.target.value)}
                                    placeholder="Explain why this variant assignment change is needed..."
                                    rows={4}
                                    maxLength={300}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400 text-sm resize-none"
                                />
                                <p className="text-xs text-gray-400 mt-1 text-right">{assignVariantRequestReason.length}/300</p>
                            </div>
                        </div>
                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3">
                            <button onClick={() => setShowAssignVariantRequestModal(false)} className="px-5 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300">Cancel</button>
                            <button
                                onClick={handleAssignVariantRequestSubmit}
                                disabled={submittingAssignVariantRequest || !assignVariantRequestReason.trim()}
                                className={`px-5 py-2 rounded-lg font-medium ${submittingAssignVariantRequest || !assignVariantRequestReason.trim() ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-indigo-600 text-white hover:bg-indigo-700'}`}
                            >
                                {submittingAssignVariantRequest ? 'Submitting...' : 'Submit Request'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Assign Modifier Request Modal */}
            {showAssignModifierRequestModal && (
                <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => setShowAssignModifierRequestModal(false)} />
                    <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full">
                        <div className="border-b border-gray-200 px-6 py-4">
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" className="text-orange-600"><path fill="currentColor" d="M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z" /></svg>
                                </div>
                                <div>
                                    <h2 className="text-lg font-bold text-gray-800">Request Modifier Assignment</h2>
                                    <p className="text-sm text-gray-500">This will be sent to Super Admin for approval</p>
                                </div>
                            </div>
                        </div>
                        <div className="px-6 py-5 space-y-4">
                            <div className="bg-orange-50 border border-orange-200 rounded-lg p-3">
                                <p className="text-sm text-orange-700"><span className="font-semibold">Item: </span>{selectedItemForModifiers?.name}</p>
                                <p className="text-xs text-orange-500 mt-1">{assignedModifierIds.size} modifier{assignedModifierIds.size !== 1 ? 's' : ''} selected</p>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Reason <span className="text-red-500">*</span></label>
                                <textarea
                                    value={assignModifierRequestReason}
                                    onChange={(e) => setAssignModifierRequestReason(e.target.value)}
                                    placeholder="Explain why this modifier assignment change is needed..."
                                    rows={4}
                                    maxLength={300}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400 text-sm resize-none"
                                />
                                <p className="text-xs text-gray-400 mt-1 text-right">{assignModifierRequestReason.length}/300</p>
                            </div>
                        </div>
                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3">
                            <button onClick={() => setShowAssignModifierRequestModal(false)} className="px-5 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300">Cancel</button>
                            <button
                                onClick={handleAssignModifierRequestSubmit}
                                disabled={submittingAssignModifierRequest || !assignModifierRequestReason.trim()}
                                className={`px-5 py-2 rounded-lg font-medium ${submittingAssignModifierRequest || !assignModifierRequestReason.trim() ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-[#FF6F3C] text-white hover:bg-[#ff4c0b]'}`}
                            >
                                {submittingAssignModifierRequest ? 'Submitting...' : 'Submit Request'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Variant Rule Request Modal */}
            {showVariantRuleRequestModal && (
                <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => setShowVariantRuleRequestModal(false)} />
                    <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full">
                        <div className="border-b border-gray-200 px-6 py-4">
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" className="text-amber-600"><path fill="currentColor" d="M14 17H5v-2h9zm5-4H5v-2h14zm0-4H5V7h14z" /></svg>
                                </div>
                                <div>
                                    <h2 className="text-lg font-bold text-gray-800">
                                        Request Variant Rule {pendingVariantRuleAction === 'add' ? 'Addition' : pendingVariantRuleAction === 'update' ? 'Update' : 'Deletion'}
                                    </h2>
                                    <p className="text-sm text-gray-500">This will be sent to Super Admin for approval</p>
                                </div>
                            </div>
                        </div>
                        <div className="px-6 py-5 space-y-4">
                            <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
                                <p className="text-sm text-amber-700">
                                    <span className="font-semibold">Item: </span>{selectedItemForVariantRules?.name}
                                </p>
                                <p className="text-xs text-amber-500 mt-1 capitalize">Action: {pendingVariantRuleAction} rule</p>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Reason <span className="text-red-500">*</span></label>
                                <textarea
                                    value={variantRuleRequestReason}
                                    onChange={(e) => setVariantRuleRequestReason(e.target.value)}
                                    placeholder="Explain why this variant rule change is needed..."
                                    rows={4}
                                    maxLength={300}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-400 text-sm resize-none"
                                />
                                <p className="text-xs text-gray-400 mt-1 text-right">{variantRuleRequestReason.length}/300</p>
                            </div>
                        </div>
                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3">
                            <button onClick={() => setShowVariantRuleRequestModal(false)} className="px-5 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300">Cancel</button>
                            <button
                                onClick={handleVariantRuleRequestSubmit}
                                disabled={submittingVariantRuleRequest || !variantRuleRequestReason.trim()}
                                className={`px-5 py-2 rounded-lg font-medium ${submittingVariantRuleRequest || !variantRuleRequestReason.trim() ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-amber-600 text-white hover:bg-amber-700'}`}
                            >
                                {submittingVariantRuleRequest ? 'Submitting...' : 'Submit Request'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Reinstate Request Modal — used for both Variant and Modifier reinstate requests */}
            {showReinstateRequestModal && (
                <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => setShowReinstateRequestModal(false)} />
                    <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full">
                        <div className="border-b border-gray-200 px-6 py-4">
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" className="text-green-600">
                                        <path fill="currentColor" d="M13 3a9 9 0 0 0-9 9H1l3.89 3.89l.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7s-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0 0 13 21a9 9 0 0 0 0-18m-1 5v5l4.25 2.52l.77-1.28l-3.52-2.09V8z" />
                                    </svg>
                                </div>
                                <div>
                                    <h2 className="text-lg font-bold text-gray-800">Request Reinstate</h2>
                                    <p className="text-sm text-gray-500">This will be sent to Super Admin for approval</p>
                                </div>
                            </div>
                        </div>
                        <div className="px-6 py-5 space-y-4">
                            <div className="bg-green-50 border border-green-200 rounded-lg p-3">
                                <p className="text-sm text-green-700">
                                    <span className="font-semibold">
                                        {reinstateRequestType === 'menu' ? 'Item: ' : reinstateRequestType === 'variant' ? 'Variant: ' : 'Modifier: '}
                                    </span>
                                    {reinstateRequestType === 'menu' ? reinstateRequestItem?.name : reinstateRequestType === 'variant' ? reinstateRequestItem?.variant_name : reinstateRequestItem?.modifier_name}
                                </p>
                                <p className="text-xs text-green-500 mt-1 capitalize">Type: {reinstateRequestType}</p>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Reason <span className="text-red-500">*</span></label>
                                <textarea
                                    value={reinstateRequestReason}
                                    onChange={(e) => setReinstateRequestReason(e.target.value)}
                                    placeholder="Explain why this should be reinstated..."
                                    rows={4}
                                    maxLength={300}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-400 text-sm resize-none"
                                />
                                <p className="text-xs text-gray-400 mt-1 text-right">{reinstateRequestReason.length}/300</p>
                            </div>
                        </div>
                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3">
                            <button
                                onClick={() => {
                                    setShowReinstateRequestModal(false)
                                    setReinstateRequestItem(null)
                                    setReinstateRequestReason('')
                                }}
                                className="px-5 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleSubmitReinstateRequest}
                                disabled={submittingReinstateRequest || !reinstateRequestReason.trim()}
                                className={`px-5 py-2 rounded-lg font-medium ${submittingReinstateRequest || !reinstateRequestReason.trim()
                                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                    : 'bg-green-600 text-white hover:bg-green-700'
                                    }`}
                            >
                                {submittingReinstateRequest ? 'Submitting...' : 'Submit Request'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}